// This API schema was generated automatically by TypescriptSchemaGenerator
type Without<T, U> = { [P in Exclude<keyof T, keyof U>]?: never }
// @ts-ignore XOR may not be used in this file, so suppress error on next line
type XOR<T, U> = T | U extends object ? (Without<T, U> & U) | (Without<U, T> & T) : T | U
export type AccountApps = {
  app_store_identifier: string
  app_id: string
  os_type: 'iOS'|'Android'
}
export type PollCard = {
  account_id: string
  name: string
  card_type: string
  card_uri: string
  duration_in_minutes: number
  first_choice: string
  second_choice: string
  third_choice: string|null
  fourth_choice: string|null
  media_key: string|null
}
export type Card = {
  account_id: string
  name: string
  card_type: string
  card_uri: string
}
export type Tweet = {
  id_str: string
  account_id: string
  text: string|null
  name: string|null
  nullcast: boolean
  media_keys: string[]|null
  card_uri: string|null
  poll_card: PollCard|null
  card: Card|null
  created_at: string
}
export type ObjectStorySpec = {
  instagram_actor_id: string|null
  page_id: string
}
export type FbCreative = {
  id: string
  account_id: string
  name: string
  title: string|null
  body: string|null
  effective_object_story_id: string|null
  call_to_action_type: string|null
  object_type: 'APPLICATION'|'DOMAIN'|'EVENT'|'OFFER'|'PAGE'|'PHOTO'|'SHARE'|'STATUS'|'STORE_ITEM'|'VIDEO'|'INVALID'|'PRIVACY_CHECK_FAIL'|'POST_DELETED'
  actor_id: string
  effective_instagram_story_id: string|null
  instagram_actor_id: string|null
  status: 'ACTIVE'|'IN_PROCESS'|'WITH_ISSUES'|'DELETED'
  video_id: string|null
  object_id: string|null
  link_url: string|null
  object_url: string|null
  object_story_spec: ObjectStorySpec|null
}
export type AdCreative = {
  network: 'twitter'|'facebook'
  account_id: string
  preview_result: string|null
  name: string
  creative_id: string
  created: string|null
  tweet: Tweet|null
  fb_creative: FbCreative|null
}
export type PollCardInput = {
  name: string
  duration_in_minutes: number
  first_choice: string
  second_choice: string
  third_choice: string|null
  fourth_choice: string|null
  media_key: string|null
}
export type DestinationInput = {
  type: 'WEBSITE'
  url: string
}
export type ComponentInput = {
  type: 'MEDIA'|'DETAILS'|'SWIPEABLE_MEDIA'
  media_key?: string|null
  media_keys?: string[]|null
  title?: string|null
  destination?: DestinationInput|null
}
export type CardInput = {
  name: string
  components: ComponentInput[]
}
export type TweetInput = {
  text: string|null
  name: string|null
  nullcast?: boolean
  media_keys?: string[]|null
  card_uri?: string|null
  poll_card: PollCardInput|null
  card: CardInput|null
}
export type AdCreativeInput = {
  network: 'twitter'|'facebook'
  objective: string
  account_id: string
  ad_account: string
  preview_only: boolean
  tweet: TweetInput|null
}
export type _TwitterImage = {
  media_key: string
  created_at: string
  updated_at: string
  media_status: string
  media_type: 'IMAGE'|'VIDEO'
  media_url: string
  tweeted: 'true'|null
  file_name: string|null
  name: string|null
}
export type _TwitterVideo = {
  media_key: string
  created_at: string
  updated_at: string
  media_status: string
  media_type: 'IMAGE'|'VIDEO'
  media_url: string
  aspect_ratio: string
  duration: number|null
  poster_media_url: string|null
  poster_media_key: string|null
  file_name: string|null
}
export type _FacebookImage = {
  id: string
  permalink_url: string
  created_time: string
  updated_time: string
  name: string
  hash: string
  width: number
  height: number
  status: string
}
export type _FacebookPhase = {
  status: string
}
export type _FacebookPublishingPhase = {
  status: string
  publish_status: string
  publish_time: string
}
export type _FacebookVideoStatus = {
  video_status: string
  uploading_phase: _FacebookPhase
  processing_phase: _FacebookPhase
  publishing_phase: _FacebookPublishingPhase
}
export type _FacebookVideo = {
  id: string
  permalink_url: string
  created_time: string
  updated_time: string
  length: number
  title: string|null
  source: string
  published: boolean
  is_instagram_eligible: boolean
  status: _FacebookVideoStatus
}
export type AdMedia = {
  network: 'twitter'|'facebook'
  account_id: string
  name: string
  media_type: 'image'|'video'
  twitter_image: _TwitterImage|null
  twitter_video: _TwitterVideo|null
  facebook_image: _FacebookImage|null
  facebook_video: _FacebookVideo|null
  id: string
  sdb_id: string
  modified: string
  status: string
  thumbnail_url: string
  video_url: string|null
}
export type AdMediaInput = {
  account_id: string
  name: string
  filename: string
  file: any
  media_type: 'image'|'video'
}
export type GetAdSetListQuery = {
  limit?: number
  offset?: number
}
export type CumulativeStats = {
  refdate: string|null
  network: 'facebook'|'twitter'|'linkedin'
  is_latest: boolean
  impressions: number
  engagements: number
  engagement_rate: number|null
  cost_per_engagement: number|null
  social_spend: number|null
  clicks: number
  click_through_rate: number|null
  spent: number|null
  billed_charge_local_micro: number
  reach: number
  call_to_action_clicks: number
  canvas_avg_view_percent: number|null
  canvas_avg_view_time: number|null
  canvas_component_avg_pct_view: number|null
  cost_per_10_sec_video_view: number|null
  cost_per_action_type: number|null
  cost_per_estimated_ad_recallers: number|null
  cost_per_inline_link_click: number|null
  cost_per_inline_post_engagement: number|null
  cost_per_total_action: number|null
  cost_per_unique_action_type: number|null
  cost_per_unique_click: number|null
  cost_per_unique_inline_link_click: number|null
  cpc_fb: number|null
  cpm_fb: number|null
  cpm: number|null
  cpp: number|null
  ctr: number|null
  deeplink_clicks: number
  estimated_ad_recall_rate: number|null
  estimated_ad_recallers: number
  frequency: number|null
  impressions_dummy: number
  inline_link_click_ctr: number|null
  inline_link_clicks: number
  inline_post_engagement: number
  relevance_score: number|null
  social_clicks: number
  social_impressions: number
  social_reach: number
  total_action_value: number|null
  total_actions: number
  total_unique_actions: number
  total_audience_reach: number|null
  unique_actions: number
  unique_clicks: number
  unique_ctr: number|null
  unique_inline_link_click_ctr: number|null
  unique_inline_link_clicks: number
  unique_link_clicks_ctr: number|null
  unique_social_clicks: number
  video_10_sec_watched_actions: number
  video_15_sec_watched_actions: number
  video_30_sec_watched_actions: number
  video_avg_percent_watched_actions: number|null
  video_avg_time_watched_actions: number|null
  video_p100_watched_actions: number
  video_p25_watched_actions: number
  video_p50_watched_actions: number
  video_p75_watched_actions: number
  video_p95_watched_actions: number
  website_clicks: number
  website_ctr: number|null
  comment: number
  landing_page_view: number
  like: number
  unlike: number
  link_click: number
  link_clicks: number
  cost_per_link_click: number|null
  offsite_conversion: number
  offsite_conversion_label: string|null
  page_engagement: number
  photo_view: number
  post_engagement: number
  post_reaction: number
  share: number
  video_view: number
  video_view_rate: number|null
  cost_per_video_view: number|null
  mention: number
  actions: object|null
  follows: number
  unfollows: number
  retweets: number
  replies: number
  media_engagements: number
  media_views: number
  url_clicks: number
  auto_created_conversion_sign_up_initiated: number
  video_views_25: number
  video_views_50: number
  video_views_75: number
  video_views_100: number
  video_3s100pct_views: number
  video_6s50pct_views: number
  video_6s_views: number|null
  video_15s_views: number|null
  video_content_starts: number
  video_mrc_views: number
  video_total_views: number
  tweets_send: number
  poll_card_vote: number
  app_clicks: number
  card_engagements: number
  conversion_custom: number|null
  conversion_downloads: number|null
  conversion_sign_ups: number|null
  conversion_site_visits: number|null
  conversion_purchases: number|null
  auto_created_conversion_purchase: number
  carousel_swipes: number
  video_cta_clicks: number
  auto_created_conversion_download: number|null
  promoted_tweet_profile_impressions: number|null
  promoted_tweet_search_impressions: number|null
  promoted_tweet_timeline_impressions: number|null
  promoted_tweet_app_install_attempts: number|null
  promoted_tweet_app_open_attempts: number|null
  promoted_tweet_search_url_clicks: number|null
  promoted_tweet_timeline_url_clicks: number|null
  promoted_account_follows: number|null
  promoted_account_follow_rate: number|null
  promoted_tweet_search_engagements: number|null
  promoted_tweet_timeline_engagements: number|null
  promoted_tweet_profile_engagements: number|null
  promoted_video_total_views: number|null
  promoted_tweet_profile_url_clicks: number|null
  qualified_impressions: number|null
  mobile_conversion_installs_post_views: number
  mobile_conversion_installs_post_engagements: number
  app_installs: number
  campaign: number|null
  adset: number|null
  ad: number|null
  segmentation: number|null
}
export type Ad = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  name: any
  created: string
  modified: string
  entity_type: string|null
  ad_id: string
  status: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  creative_id: string|null
  creative: object|null
  adset: number
}
export type Adset = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  max_bid: any
  budget: any
  status: any
  lifetime_budget: any
  daily_budget: any
  conversion_window: any
  ads: Ad[]
  created: string
  modified: string
  _campaign_id: string
  name: string|null
  adset_id: string
  targeting: object|null
  start_time: string|null
  end_time: string|null
  budget_type: 'daily'|'lifetime'
  _ads: object|null
  bid_amount: number
  is_autobid: boolean
  rule: string|null
  event_id: string|null
  pixel_id: string|null
  eventtype: string|null
  custom_event_type: string|null
  click_through_days: number
  view_through_days: number
  placement: object|null
  uses_sdb_audience: boolean|null
  uses_sdb_autopilot_audience: boolean|null
  uses_sdb_native_pack: boolean|null
  uses_sdb_autopilot_pack: boolean|null
  targeting_size: object|null
  false_positive: boolean|null
  campaign: number
  _audience: number|null
}
export type AdInput = {
  entity_type?: string|null
  ad_id: string
  status?: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  creative_id?: string|null
  creative?: object|null
  adset: number
}
export type AdsetInput = {
  ads: AdInput[]
  _campaign_id: string
  name?: string|null
  adset_id: string
  targeting?: object|null
  start_time?: string|null
  end_time?: string|null
  budget_type?: 'daily'|'lifetime'
  _ads?: object|null
  bid_amount?: number
  is_autobid?: boolean
  rule?: string|null
  event_id?: string|null
  pixel_id?: string|null
  eventtype?: string|null
  custom_event_type?: string|null
  click_through_days?: number
  view_through_days?: number
  placement?: object|null
  uses_sdb_audience?: boolean|null
  uses_sdb_autopilot_audience?: boolean|null
  uses_sdb_native_pack?: boolean|null
  uses_sdb_autopilot_pack?: boolean|null
  targeting_size?: object|null
  false_positive?: boolean|null
  campaign: number
  _audience?: number|null
}
export type DeleteAdSetInstanceQuery = GetAdSetListQuery
export type GetAdSetInstanceQuery = GetAdSetListQuery
export type WriteTwitterAdsetInput = {
  creatives: string[]
  end_time?: string|null
  is_autobid?: boolean
  max_bid?: number|null
  name: string
  start_time: string
  country?: string|null
  age_min?: number|null
  age_max?: number|null
  locations?: any[]
  daily_budget?: number|null
  exclude_audiences?: string[]
  include_audiences?: string[]
  handles?: string[]
  keywords?: string[]
  hashtags?: string[]
  iab_targeting?: string[]
  lifetime_budget: number
  status?: 'active'|'paused'
}
export type PatchAdSetInstanceQuery = GetAdSetListQuery
export type WriteTwitterAdset = {
  end_time: string|null
  is_autobid: boolean
  max_bid: number|null
  name: string
  start_time: string
  country: string|null
  age_min: number|null
  age_max: number|null
  locations: any[]
  daily_budget: number|null
  exclude_audiences: string[]
  include_audiences: string[]
  handles: string[]
  keywords: string[]
  hashtags: string[]
  iab_targeting: string[]
  lifetime_budget: number
  status: 'active'|'paused'
}
export type PutAdSetInstanceQuery = GetAdSetListQuery
export type AdvertiserBusinessCategories = {
  category_id: string
  name: string
  iab_categories: any[]
}
export type AppEvents = {
  event_id: string
  conversion_type: 'ACHIEVEMENT_UNLOCKED'|'ADDED_PAYMENT_INFO'|'ADD_TO_CART'|'ADD_TO_WISHLIST'|'CHECKOUT_INITIATED'|'CONTENT_VIEW'|'INSTALL'|'INVITE'|'LEVEL_ACHIEVED'|'LOGIN'|'PURCHASE'|'RATED'|'RESERVATION'|'RE_ENGAGE'|'SEARCH'|'SHARE'|'SIGN_UP'|'SPENT_CREDITS'|'TUTORIAL_COMPLETE'|'UPDATE'
  status: string
}
export type GetAudienceCategoryListQuery = {
  team?: string
  id?: number
}
export type AudienceCategory = {
  id: number
  created: string
  modified: string
  name: string
  is_default_category: boolean
}
export type GetAudienceCategoryInstanceQuery = GetAudienceCategoryListQuery
export type GetAudienceConfigListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  team?: string
  categories?: string
  regions?: string
  id?: string
}
export type AudiencePlan = {
  id: number
  created: string
  modified: string
  name: string
  description: string
  public: boolean
  is_active: boolean
}
export type TeamPublic = {
  id: number
  slug: string|null
  name: string
  member_count: number
  logo: string|null
}
export type AudienceRegion = {
  id: number
  country_codes: (string)[]
  is_single_country: boolean
  name: string
  m49_code: string|null
}
export type AudienceConfig = {
  id: number
  created: string
  modified: string
  name: string
  description: string|null
  audience_plan: AudiencePlan
  size: number
  approximate_count: string
  is_active: boolean
  created_by_team: TeamPublic
  categories: AudienceCategory[]
  regions: AudienceRegion[]
  plan_type: string
  top_influencers: any[]
  display_name: string
  audience_estimation: string
  native_estimation: string
  insights_id: number|null
  has_native_pack: boolean
}
export type AudienceConfigInput = {
  name: string
  description?: string|null
  approximate_count: string
  is_active: boolean
  parameters: object
  category_ids: number[]
  region_ids: number[]
  created_by_team_id: number
  audience_plan_id: string
  insights_id: number|null
}
export type AutoCompleteInput = {
  partial_query: string
}
export type AutoComplete = {
  queries: string[]
}
export type SearchPerspectivesInput = {
  keyword: string
}
export type SearchPerspectives = {
  entities: any[]
  countries: string[]
  audience_type: string
  spelling_correction: string
  inapropriate_words_message: string
  account_types: number[]
}
export type GetAudienceConfigInstanceQuery = GetAudienceConfigListQuery
export type Insights = {
  id: number
  insights_counts: any
  is_super_insights: boolean
  influencer_groups: string[]
  created: string
  modified: string
  status: any|null
  gender: { label: string; value: number; valueText: string }[]|null
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  regions: { label: string; value: number; valueText: string }[]|null
  cities: { label: string; value: number; valueText: string; long: number|null; lat: number|null }[]|null
  specific_interests: { label: string; value: number; valueText: string }[]|null
  interests: { label: string; value: number; valueText: string }[]|null
  interest_fields: { label: string; value: number; valueText: string }[]|null
  professions: { label: string; value: number; valueText: string }[]|null
  profession_fields: { label: string; value: number; valueText: string }[]|null
  income_level: { label: string; value: number; valueText: string }[]|null
  education_level: { label: string; value: number; valueText: string }[]|null
  socioeconomic_status: { label: string; value: number; valueText: string }[]|null
  bio_words: { label: string; value: number; valueText: string }[]
  bio_hashtags: { label: string; value: number; valueText: string }[]|null
  bio_chunks: any
  tweet_words: { label: string; value: number; valueText: string }[]|null
  tweet_keywords: { label: string; value: number; valueText: string }[]|null
  mentioned_hashtags: { label: string; value: number; valueText: string }[]|null
  mentioned_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_tweets: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_liked: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_retweeted: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  most_retweeted_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  influencers: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[]
  audience_estimation: { min: number; max: number; warning: string|null }|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: string|null; keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: string[]; gender: string; age: string; locations: string[] }|null
  targeting_package_size: { min: number; max: number }|null
  related_communities: null|string[]|null
  core_accounts: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture?: string|null; likes_per_month?: number|null; tweets_per_month?: number|null; activity_score?: number|null; likes_count?: number|null; tweets_count?: number|null; site?: string|null; gender?: string|null; profession?: string|null; interest?: string|null; sub_interest?: string|null; country?: string|null; region?: string|null; city?: string|null; age?: string|null; secondary_sub_interest?: string|null; tertiary_sub_interest?: string|null }[]
  age: { label: string; value: number; valueText: string }[]|null
  sites: { label: string; value: number; valueText: string }[]|null
  accounts_count: { InitialSearch: number|null; JobTitles: number|null; Influencers: number|null; FollowersCount: number|null }|null
  suggestions: { query: string; metadata: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[] }[]|null
}
export type AudienceConfigDetail = {
  id: number
  created: string
  modified: string
  name: string
  description: string|null
  audience_plan: AudiencePlan
  size: number
  approximate_count: string
  is_active: boolean
  created_by_team: TeamPublic
  categories: AudienceCategory[]
  regions: AudienceRegion[]
  plan_type: string
  top_influencers: any[]
  display_name: string
  audience_estimation: string
  native_estimation: string
  insights_id: number|null
  has_native_pack: boolean
  insights: Insights|null
}
export type PutAudienceConfigInstanceQuery = GetAudienceConfigListQuery
export type AudiencePlanInput = {
  name: string
  description: string
  public?: boolean
  is_active?: boolean
}
export type GetAudienceListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  team?: string
  id?: string
  ad_account?: string
  targetable?: string
}
export type AudienceConfigBasic = {
  id: number
  name: string|null
  description: string|null
  audience_plan: number|null
  is_active: boolean
}
export type Audience = {
  id: number
  created: string
  modified: string
  network: any
  imported: boolean
  audience_id: string|null
  name: string
  targeting: object|null
  approximate_count: number
  is_global_audience: boolean
  config: AudienceConfigBasic
  uploaded_insights_id: number|null
  account_id: string
  uploaded_audience_id: number|null
  targetable: boolean
  reasons_not_targetable: string[]
  top_influencers: any[]
  targetable_keywords: any[]
  targetable_hashtags: any[]
  targeting_package_size: any
}
export type GetAudienceInstanceQuery = GetAudienceListQuery
export type BuildAudienceInput = {
  plan_name: string
  plan_type: string|null
  input_query: string|null
  keywords: string[]
  input_countries?: string[]|null
  exclude_keywords?: string[]|null
  types?: string[]|null
  following_types?: any[]|null
  selected_influencers?: any[]|null
  engagement?: 'high'|'medium'|'low'
  size?: string|null
  config_id: number|null
}
export type BuildAudience = {
  id: number
  created: string
  modified: string
  status: any|null
  gender: { label: string; value: number; valueText: string }[]|null
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  regions: { label: string; value: number; valueText: string }[]|null
  cities: { label: string; value: number; valueText: string; long: number|null; lat: number|null }[]|null
  specific_interests: { label: string; value: number; valueText: string }[]|null
  interests: { label: string; value: number; valueText: string }[]|null
  interest_fields: { label: string; value: number; valueText: string }[]|null
  professions: { label: string; value: number; valueText: string }[]|null
  profession_fields: { label: string; value: number; valueText: string }[]|null
  income_level: { label: string; value: number; valueText: string }[]|null
  education_level: { label: string; value: number; valueText: string }[]|null
  socioeconomic_status: { label: string; value: number; valueText: string }[]|null
  bio_words: { label: string; value: number; valueText: string }[]
  bio_hashtags: { label: string; value: number; valueText: string }[]|null
  bio_chunks: any
  tweet_words: { label: string; value: number; valueText: string }[]|null
  tweet_keywords: { label: string; value: number; valueText: string }[]|null
  mentioned_hashtags: { label: string; value: number; valueText: string }[]|null
  mentioned_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_tweets: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_liked: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_retweeted: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  most_retweeted_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  influencers: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[]
  audience_estimation: { min: number; max: number; warning: string|null }|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: string|null; keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: string[]; gender: string; age: string; locations: string[] }|null
  targeting_package_size: { min: number; max: number }|null
  related_communities: null|string[]|null
  core_accounts: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture?: string|null; likes_per_month?: number|null; tweets_per_month?: number|null; activity_score?: number|null; likes_count?: number|null; tweets_count?: number|null; site?: string|null; gender?: string|null; profession?: string|null; interest?: string|null; sub_interest?: string|null; country?: string|null; region?: string|null; city?: string|null; age?: string|null; secondary_sub_interest?: string|null; tertiary_sub_interest?: string|null }[]
  age: { label: string; value: number; valueText: string }[]|null
  sites: { label: string; value: number; valueText: string }[]|null
  accounts_count: { InitialSearch: number|null; JobTitles: number|null; Influencers: number|null; FollowersCount: number|null }|null
  suggestions: { query: string; metadata: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[] }[]|null
  insights_counts: any
  following_types: any[]|null
  is_super_insights: boolean
  influencer_groups: string[]
}
export type CreateCampaignPdfInput = {
  campaign_id: number
}
export type CreateCampaignPdf = {
  response: string
}
export type GetCampaignListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  id?: string
  team?: string
  account_id?: string
  network?: string
  campaign_id?: string
  status?: string
  objective?: string
  completed?: string
  metrics?: string
}
export type CampaignListItem = {
  id: number
  adsets: number[]
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  status: any
  stop_time: any
  lifetime_budget: any
  daily_budget: any
  currency: string
  first_creative_id: string
  has_pro_targeting: any
  via_extension: boolean
  created: string
  modified: string
  account_id: string
  network: 'facebook'|'twitter'|'linkedin'
  campaign_id: string
  name: string
  objective: string
  created_time: string
  start_time: string
  updated_time: string|null
  data: object|null
  completed: boolean
  synced: string|null
  funding_instrument: string|null
  io_header: string|null
  reach: number|null
  average_frequency: number|null
  budget_optimization: 'CAMPAIGN'|'LINE_ITEM'|null
  effective_status: string|null
  stats_lock: any|null
  dbaccount: number
}
export type WriteTwitterCampaignInput = {
  name: string
  account_id: string
  status?: 'active'|'paused'|null
  objective: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'ENGAGEMENTS'|'FOLLOWERS'|'LEAD_GENERATION'|'PREROLL_VIEWS'|'REACH'|'VIDEO_VIEWS'|'WEBSITE_CLICKS'|'WEBSITE_CONVERSIONS'
  goal?: string|null
  is_conversions_objective?: boolean
  primary_web_event_tag?: string|null
  funding_instrument?: string|null
  lifetime_budget: number
  daily_budget?: number|null
  adsets: WriteTwitterAdsetInput[]
  app_store_identifier?: string|null
  categories?: string[]
  audience_expansion?: boolean
}
export type WriteTwitterCampaign = {
  name: string
  account_id: string
  status: 'active'|'paused'|null
  id: string
  objective: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'ENGAGEMENTS'|'FOLLOWERS'|'LEAD_GENERATION'|'PREROLL_VIEWS'|'REACH'|'VIDEO_VIEWS'|'WEBSITE_CLICKS'|'WEBSITE_CONVERSIONS'
  goal: string|null
  is_conversions_objective: boolean
  primary_web_event_tag: string|null
  funding_instrument: string|null
  daily_budget: number|null
  adsets: WriteTwitterAdset[]
  app_store_identifier: string|null
  categories: string[]
  audience_expansion: boolean
}
export type GetAdsQuery = GetCampaignListQuery
export type CampaignSummary = {
  name: string
  id: number
  network: 'facebook'|'twitter'|'linkedin'
  account_id: string
  currency: string
  objective: string
}
export type AdsetSummary = {
  name: string|null
  id: number
  status: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  campaign: CampaignSummary
  adset_id: string
}
export type AdListItem = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  name: any
  adset: AdsetSummary
  created: string
  modified: string
  entity_type: string|null
  ad_id: string
  status: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  creative_id: string|null
}
export type GetAdsetsQuery = GetCampaignListQuery
export type AdsetListItem = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  max_bid: any
  budget: any
  status: any
  lifetime_budget: any
  daily_budget: any
  conversion_window: any
  ads: number[]
  campaign: CampaignSummary
  created: string
  modified: string
  _campaign_id: string
  name: string|null
  adset_id: string
  start_time: string|null
  end_time: string|null
  budget_type: 'daily'|'lifetime'
  bid_amount: number
  is_autobid: boolean
  rule: string|null
  event_id: string|null
  pixel_id: string|null
  eventtype: string|null
  custom_event_type: string|null
  click_through_days: number
  view_through_days: number
  placement: object|null
  uses_sdb_audience: boolean|null
  uses_sdb_autopilot_audience: boolean|null
  uses_sdb_native_pack: boolean|null
  uses_sdb_autopilot_pack: boolean|null
  targeting_size: object|null
  false_positive: boolean|null
  _audience: number|null
}
export type GetReachQuery = {
  search?: string
  ordering?: string
  id?: string
  team?: string
  account_id?: string
  network?: string
  campaign_id?: string
  status?: string
  objective?: string
  completed?: string
  metrics?: string
}
export type ReachStats = {
  id: string
  total_audience_reach: number|null
  average_frequency: number|null
}
export type GetSegmentationsQuery = GetCampaignListQuery
export type AdSummary = {
  id: number
  status: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  adset: AdsetSummary
  ad_id: string
}
export type SegmentationListItem = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  name: any
  ad: AdSummary
  created: string
  modified: string
  segmentation_type: 'AUDIENCES'|'SIMILAR_TO_FOLLOWERS_OF_USER'|'CUSTOM_AUDIENCE_EXPANDED'
  segment_value: string
  segment_name: string|null
}
export type GetStatstotalQuery = GetReachQuery
export type StatsTotal = {
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  lifetime_budget: any
  daily_budget: any
}
export type DeleteCampaignInstanceQuery = GetCampaignListQuery
export type GetCampaignInstanceQuery = GetCampaignListQuery
export type Campaign = {
  id: number
  adsets: Adset[]
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  status: any
  stop_time: any
  lifetime_budget: any
  daily_budget: any
  currency: string
  first_creative_id: string
  has_pro_targeting: any
  via_extension: boolean
  created: string
  modified: string
  account_id: string
  network: 'facebook'|'twitter'|'linkedin'
  campaign_id: string
  name: string
  objective: string
  created_time: string
  start_time: string
  updated_time: string|null
  data: object|null
  completed: boolean
  synced: string|null
  funding_instrument: string|null
  io_header: string|null
  reach: number|null
  average_frequency: number|null
  budget_optimization: 'CAMPAIGN'|'LINE_ITEM'|null
  effective_status: string|null
  stats_lock: any|null
  dbaccount: number
}
export type PatchCampaignInstanceQuery = GetCampaignListQuery
export type PutCampaignInstanceQuery = GetCampaignListQuery
export type GetCommunitiesListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  id?: string
}
export type AudienceCommunity = {
  id: number
  created: string
  modified: string
  input_query: string|null
  config: number|null
  count: number
  insights: number|null
  top_influencers: any[]
  community_rank: number
}
export type GetCommunitiesInstanceQuery = GetCommunitiesListQuery
export type GetCommunityListQuery = {
  search?: string
  type_code?: string
}
export type Community = {
  account_id: number
  connectivity: number
  relevancy: number
  profile_pic: string
  handle: string
  name: string
  followers: number
  friends: number
  bio: string
}
export type GetCommunityInstanceQuery = GetCommunityListQuery
export type ContentCategories = {
  name: string
  category_id: string
  iab_categories: any[]
  publishers_in_last_thirty_days: number
  videos_monetized_in_last_thirty_days: number
}
export type CancellationInput = {
  subscription: number
}
export type Cancellation = CancellationInput
export type CheckoutInput = {
  team: number
  plan: number
  audiences?: number
}
export type Checkout = {
  team: number
  plan: number
  audiences: number
  stripe_url: string
}
export type Plan = {
  id: number
  name: string
  price: number
  currency: 'USD'|'EUR'|'YEN'
  ad_budget: number
  audiences_included: number
  audience_price: any
  overages: any
  fixed_price: boolean
  deck: string|null
  description: string|null
  display_name: string|null
}
export type Subscription = {
  id: number
  team: number
  plan: Plan
  start: string
  active: boolean
  audiences: number
}
export type UpgradeInput = {
  subscription: number
  plan: number
  audiences: number
}
export type Upgrade = UpgradeInput
export type ExploreXInput = {
  countries?: string[]|null
  input_query: string|null
}
export type ExploreX = {
  id: number
  created: string
  modified: string
  status: any|null
  gender: { label: string; value: number; valueText: string }[]|null
  regions: { label: string; value: number; valueText: string }[]|null
  cities: { label: string; value: number; valueText: string; long: number|null; lat: number|null }[]|null
  specific_interests: { label: string; value: number; valueText: string }[]|null
  interests: { label: string; value: number; valueText: string }[]|null
  interest_fields: { label: string; value: number; valueText: string }[]|null
  professions: { label: string; value: number; valueText: string }[]|null
  profession_fields: { label: string; value: number; valueText: string }[]|null
  income_level: { label: string; value: number; valueText: string }[]|null
  education_level: { label: string; value: number; valueText: string }[]|null
  socioeconomic_status: { label: string; value: number; valueText: string }[]|null
  bio_words: { label: string; value: number; valueText: string }[]
  bio_hashtags: { label: string; value: number; valueText: string }[]|null
  bio_chunks: any
  tweet_words: { label: string; value: number; valueText: string }[]|null
  tweet_keywords: { label: string; value: number; valueText: string }[]|null
  mentioned_hashtags: { label: string; value: number; valueText: string }[]|null
  mentioned_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_tweets: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_liked: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_retweeted: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  most_retweeted_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  influencers: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[]
  audience_estimation: { min: number; max: number; warning: string|null }|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: string|null; keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: string[]; gender: string; age: string; locations: string[] }|null
  targeting_package_size: { min: number; max: number }|null
  related_communities: null|string[]|null
  core_accounts: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture?: string|null; likes_per_month?: number|null; tweets_per_month?: number|null; activity_score?: number|null; likes_count?: number|null; tweets_count?: number|null; site?: string|null; gender?: string|null; profession?: string|null; interest?: string|null; sub_interest?: string|null; country?: string|null; region?: string|null; city?: string|null; age?: string|null; secondary_sub_interest?: string|null; tertiary_sub_interest?: string|null }[]
  age: { label: string; value: number; valueText: string }[]|null
  sites: { label: string; value: number; valueText: string }[]|null
  accounts_count: { InitialSearch: number|null; JobTitles: number|null; Influencers: number|null; FollowersCount: number|null }|null
  suggestions: { query: string; metadata: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[] }[]|null
  influencer_groups: string[]
}
export type GetStandaloneAdAccountListQuery = {
  account_id: string
}
export type StandaloneAdAccount = {
  is_active: boolean
  account_id: string
  name: string
}
export type StandaloneAdAccountInput = {
  account_id: string
  name?: string
}
export type StandaloneAudienceAdAccountInput = {
  account_id: string
  name?: string|null
}
export type StandaloneAudienceAdAccount = {
  account_id: string
  name: string|null
}
export type StandaloneAdAccountFundingSourcesInput = {
  ad_account_id: string
}
export type StandaloneFundingSource = {
  id: string
  description: string
  able_to_fund: boolean
}
export type StandaloneAdAccountFundingSources = {
  funding_sources: StandaloneFundingSource[]
}
export type GetStandaloneAdAccountInstanceQuery = GetStandaloneAdAccountListQuery
export type StandaloneDescriptionAnalyzerInput = {
  email?: string|null
  description: string
}
export type StandaloneDescriptionAnalyzer = {
  analyzed_keyword_groups: string[][]
  analyzed_handles: string[]
  analyzed_countries: string[]
  analyzed_location_states: string[]
  analyzed_gender: 1|2|12|null
  analyzed_age_range: string|null
}
export type StandaloneInsightsAnalyzerInput = {
  email?: string|null
  ad_account_id?: string|null
  query?: string
  query_type?: 'searchbar'|'advanced_settings'|'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'|'creator_analysis'
  input_keywords?: string[][]
  alpha_2?: string
}
export type SizeData = {
  min: number
  max: number
}
export type PostCounts = {
  like_count: number|null
  impression_count: number|null
  post_count: number|null
}
export type ChartData = {
  label: string
  value: number
  valueText: string
}
export type StandaloneSubreddits = {
  name: string
  daily_impressions: number
  count: number
}
export type StandaloneAudienceConfigListItem = {
  id: number
  name: string
  description: string
  modified: string
}
export type StandalonePostMetadataCount = {
  image_with_link: number|null
  image_without_link: number|null
  video: number|null
  poll: number|null
  short_form: number|null
  long_form: number|null
  text: number|null
  image: number|null
}
export type DeepThoughtAccount = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  verified_count: number|null
  verified_count_rank: number|null
  auth_token: string|null
  token: string|null
  bot: boolean|null
  active: boolean|null
  gender: string|null
  following: boolean|null
  follows_you: boolean|null
  suspended: boolean|null
  verified_followers_count: number|null
  classifier_names: string[]|null
  updated: string|null
  churn_ratio: number|null
  engager: boolean
  tweets: number|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  location: string|null
  site: string|null
  facebook: string|null
  instagram: string|null
  youtube: string|null
  linkedin: string|null
  tweet_date: string|null
}
export type DeepThoughtPostAccount = {
  accountid: string
  pic: string
  handle: string
  name: string
  verified: boolean
}
export type DeepThoughtImages = {
  url: string|null
  width: number|null
  height: number|null
}
export type DeepThoughtTimelineURLs = {
  start: number|null
  end: number|null
  url: string|null
  expanded_url: string|null
  display_url: string|null
  images: DeepThoughtImages[]|null
  status: number|null
  title: string|null
  description: string|null
  unwound_url: string|null
}
export type DeepThoughtMedia = {
  start: number|null
  end: number|null
  media_key: string|null
  url: string|null
  preview_image_url: string|null
  width: number|null
  height: number|null
  type: 'animated_gif'|'photo'|'video'|null
}
export type DeepThoughtPostTweetTimeline = {
  id: string
  text: string
  like_count: number
  retweet_count: number
  impression_count: number|null
  reply_count: number|null
  quote_count: number|null
  created_at: string
  tweet_time: string|null
  verified_like_count: number|null
  verified_reply_count: number|null
  verified_retweet_count: number|null
  payout_estimation: number|null
  bookmark_count: number|null
  user_profile_clicks: number|null
  engagements: number|null
  post_type: string|null
  sentiment: string|null
  urls: DeepThoughtTimelineURLs[]
  media: DeepThoughtMedia[]
}
export type DeepThoughtAccountTweet = {
  account: DeepThoughtPostAccount
  tweet: DeepThoughtPostTweetTimeline
}
export type DeepThoughtFollowerGrowth = {
  refdate: string
  followers: number
  verified_count: number|null
}
export type DeepThoughtAccountStats = {
  follower_growth: DeepThoughtFollowerGrowth[]
  account_id: string
}
export type DeepThoughtEnrichmentTopic = {
  id: number
  topic: string
  score: number
  baseline: number|null
  corrected: number|null
  score_ratio: number|null
}
export type DeepThoughtEnrichment = {
  parent: string
  children: DeepThoughtEnrichmentTopic[]
}
export type StandaloneInsightsAnalyzer = {
  size: SizeData|null
  post_counts: PostCounts|null
  hashtags_tweets: ChartData[]
  keywords_tweets: ChartData[]
  double_keywords_tweets: ChartData[]
  emoji_counts: ChartData[]
  professions: ChartData[]
  subreddits: StandaloneSubreddits[]|null
  genders: ChartData[]
  languages: ChartData[]
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]
  cities: ChartData[]
  keywords: ChartData[]
  double_keywords: ChartData[]
  hashtags: ChartData[]
  age_percentages: ChartData[]|null
  query: string
  show_country_message: boolean|null
  seo_keywords: string[]
  seo_phrases: string[]
  audience_configs: StandaloneAudienceConfigListItem[]
  hashtags_handles: ChartData[]
  single_keywords_handles: ChartData[]
  double_keywords_handles: ChartData[]
  emoji_counts_handles: ChartData[]
  handle_posts_analyzed: number|null
  audience_creator_query_id: number
  percentage_active: number|null
  counts: StandalonePostMetadataCount
  summary: string|null
  accounts: DeepThoughtAccount[]
  top_posts_handles: DeepThoughtAccountTweet[]
  account_stats: DeepThoughtAccountStats[]|null
  top_followers: DeepThoughtAccount[]|null
  enrichments: DeepThoughtEnrichment[]|null
  sample_accounts: DeepThoughtAccount[]
  top_accounts: DeepThoughtAccount[]
  top_posts: DeepThoughtAccountTweet[]
}
export type StandaloneInsightsAnalyzerKeywordAccountsInput = {
  keywords: string[]
  countries: string[]
}
export type StandaloneInsightsAnalyzerKeywordAccounts = {
  accounts: DeepThoughtAccount[]
}
export type StandaloneInsightsAnalyzerGenerateSheetInput = {
  data: string[][]
  title: string
  template?: 'handle'|'audience'|'conversation'|'creators'|'creators_with_follower_growth'|'other'
  locale?: 'en'|'ja'
  countries: string[]
  headings?: string[]
}
export type StandaloneInsightsAnalyzerGenerateSheet = {
  url: string
}
export type StandaloneExploreQueryAnalyzerInput = {
  email?: string|null
  ad_account_id?: string|null
  query?: string
  query_type?: 'searchbar'|'advanced_settings'|'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'|'creator_analysis'
}
export type StandaloneExploreParameters = {
  handles: string[]|null
  keywords: string[]|null
  countries: string[]|null
  title: string|null
  query: string|null
  input_keywords: string[][]|null
  date_start: string|null
  date_end: string|null
}
export type StandaloneExploreQueryAnalyzer = {
  query: string
  parameters: StandaloneExploreParameters
  audience_creator_query_id: number
}
export type GetStandaloneAudienceBuilderListQuery = {
  ad_account_id?: string
  email?: string
}
export type AudienceBuilder = {
  id: number
  created: string
  modified: string
  name: string
  email: string
  parameters: object|null
  ad_account_id: string|null
  size: number|null
  deleted_at: string|null
}
export type StandaloneAudienceBuilderWordsInProfileInput = StandaloneInsightsAnalyzerKeywordAccountsInput
export type StandaloneAudienceBuilderPostedAboutInput = {
  keywords: string[]
  start?: string|null
  end?: string|null
  time_interval: 'last_week'|'last_month'|'last_3_months'|'last_year'
}
export type StandaloneAudienceBuilderFollowersOfInput = {
  handles: string[]
  following_at_least?: number
}
export type StandaloneAudienceBuilderInterestedInInput = StandaloneInsightsAnalyzerKeywordAccountsInput
export type StandaloneAudienceBuilderCriterionInput = {
  words_in_profile?: StandaloneAudienceBuilderWordsInProfileInput
  posted_about?: StandaloneAudienceBuilderPostedAboutInput
  followers_of?: StandaloneAudienceBuilderFollowersOfInput
  interested_in?: StandaloneAudienceBuilderInterestedInInput
}
export type StandaloneAudienceBuilderInput = {
  email?: string|null
  ad_account_id?: string|null
  name: string
  criteria: StandaloneAudienceBuilderCriterionInput[][]
  generate_insights?: boolean
}
export type StandaloneInsightsAnalyzerSync = {
  size: SizeData|null
  post_counts: PostCounts|null
  hashtags_tweets: ChartData[]
  keywords_tweets: ChartData[]
  double_keywords_tweets: ChartData[]
  emoji_counts: ChartData[]
  professions: ChartData[]
  subreddits: StandaloneSubreddits[]|null
  genders: ChartData[]
  languages: ChartData[]
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]
  cities: ChartData[]
  keywords: ChartData[]
  double_keywords: ChartData[]
  hashtags: ChartData[]
  age_percentages: ChartData[]|null
  enrichments: DeepThoughtEnrichment[]|null
  sample_accounts: DeepThoughtAccount[]
  top_accounts: DeepThoughtAccount[]
  top_posts: DeepThoughtAccountTweet[]
}
export type StandaloneAudienceBuilder = {
  audience_size: number|null
  insights: StandaloneInsightsAnalyzerSync|null
  audience_creator_query_id: number|null
  accounts: DeepThoughtAccount[]
}
export type StandaloneAudienceBuilderFollowersOf = {
  audience_size: number|null
  accounts: DeepThoughtAccount[]
}
export type StandaloneAudienceBuilderGenerateInsightsInput = {
  email?: string|null
  ad_account_id?: string|null
  audience_builder_id: number
}
export type StandaloneAudienceBuilderGenerateInsights = {
  insights: StandaloneInsightsAnalyzerSync|null
  audience_creator_query_id: number
}
export type StandaloneAudienceBuilderInterestedIn = StandaloneAudienceBuilderFollowersOf
export type DeepThoughtPostTweet = {
  id: string
  text: string
  like_count: number
  retweet_count: number
  impression_count: number|null
  reply_count: number|null
  quote_count: number|null
  created_at: string
  tweet_time: string|null
  verified_like_count: number|null
  verified_reply_count: number|null
  verified_retweet_count: number|null
  payout_estimation: number|null
  bookmark_count: number|null
  user_profile_clicks: number|null
  engagements: number|null
  post_type: string|null
  sentiment: string|null
}
export type DeepThoughtPost = {
  account: DeepThoughtPostAccount
  tweet: DeepThoughtPostTweet
}
export type StandaloneAudienceBuilderPostedAbout = {
  post_count: number|null
  accounts: DeepThoughtAccount[]
  posts: DeepThoughtPost[]
}
export type StandaloneAudienceBuilderSuggestInterestsInput = SearchPerspectivesInput
export type ClassifierChild = {
  id: number
  name: string
}
export type StandaloneAudienceBuilderSuggestInterests = {
  classifiers: ClassifierChild[]
}
export type StandaloneAudienceBuilderWordsInProfile = StandaloneAudienceBuilderFollowersOf
export type DeleteStandaloneAudienceBuilderInstanceQuery = GetStandaloneAudienceBuilderListQuery
export type GetStandaloneAudienceCategoryListQuery = GetAudienceCategoryListQuery
export type GetStandaloneAudienceCategoryInstanceQuery = GetAudienceCategoryListQuery
export type GetStandaloneAudienceConfigListQuery = {
  limit?: number
  offset?: number
  search?: string
  categories?: string
  regions?: string
  classic_xpro_id?: string
  ad_account_id?: string
  token?: string
  list_type?: string
}
export type StandaloneAudienceConfig = {
  id: number
  created: string
  modified: string
  name: string
  description: string|null
  size: number
  approximate_count: string
  is_active: boolean
  categories: AudienceCategory[]
  regions: AudienceRegion[]
  plan_type: string
  top_influencers: any[]
  display_name: string
  audience_estimation: string
  native_estimation: string
  insights_id: number|null
  has_native_pack: boolean
  child_count: number
  parent_count: number
  status: 'Imported'|'Processing'|'Done'
}
export type StandaloneAudienceConfigInput = {
  name: string
  description?: string|null
  approximate_count: string
  is_active: boolean
  parameters: object
  insights_id: number|null
  ad_account_id: string
}
export type StandaloneShareViaAccountAudienceConfigInput = {
  ad_account_id: string
  audience_config_id?: string
}
export type StandaloneShareViaAccountAudienceConfig = {
}
export type StandaloneShareAudienceConfigInput = {
  audience_config_id: number
}
export type StandaloneShareAudienceConfig = {
  audiences_url: string
}
export type GetStandaloneAudienceConfigInstanceQuery = GetStandaloneAudienceConfigListQuery
export type RelatedAudienceConfig = {
  id: number
  parent: AudienceConfig
  child: AudienceConfig
}
export type StandaloneAudienceConfigDetail = {
  id: number
  created: string
  modified: string
  name: string
  description: string|null
  size: number
  approximate_count: string
  is_active: boolean
  categories: AudienceCategory[]
  regions: AudienceRegion[]
  plan_type: string
  top_influencers: any[]
  display_name: string
  audience_estimation: string
  native_estimation: string
  insights_id: number|null
  has_native_pack: boolean
  insights: Insights|null
  child: RelatedAudienceConfig[]
  parent: RelatedAudienceConfig[]
  status: any
  native_pack_link: any
}
export type PutStandaloneAudienceConfigInstanceQuery = GetStandaloneAudienceConfigListQuery
export type GetDownloadTargetingPackageQuery = {
  search?: string
  categories?: string
  regions?: string
  classic_xpro_id?: string
  ad_account_id?: string
  token?: string
  list_type?: string
}
export type StandaloneDownloadTargetingPackage = StandaloneInsightsAnalyzerGenerateSheet
export type StandaloneAudienceRequestInput = {
  ad_account_id?: string|null
  advertiser_name?: string|null
  audience_config_id?: number|null
  audience_size?: string|null
  audience_type?: 'custom'|'exclusion'|'abm'|'event'|null
  currency?: string|null
  description?: string|null
  email: string
  funding_source_id?: string|null
  geographic?: string|null
  google_drive_link?: string|null
  input_budget?: string|null
  input_end_date?: string|null
  input_start_date?: string|null
  io_signed?: boolean|null
  name?: string|null
  request_type?: 'native'|'audience'
  salesforce_id?: string|null
  advertiser_handle?: string|null
  form_opened_via?: string|null
}
export type StandaloneAudienceRequest = {
  id: number
  asana_id: string|null
  native_pack_link: string|null
  ad_account_id: string|null
  advertiser_name: string|null
  audience_config_id: number|null
  audience_size: string|null
  audience_type: 'custom'|'exclusion'|'abm'|'event'|null
  currency: string|null
  description: string|null
  email: string
  funding_source_id: string|null
  geographic: string|null
  google_drive_link: string|null
  io_signed: boolean|null
  name: string|null
  request_type: 'native'|'audience'
  salesforce_id: string|null
  advertiser_handle: string|null
  form_opened_via: string|null
}
export type StandaloneFeedbackInput = {
  name?: string|null
  email?: string|null
  feedback: string
}
export type StandaloneFeedback = {
  name: string|null
  email: string|null
  feedback: string
}
export type StandaloneAudienceRequestRedditInput = {
  email: string
  description?: string
  ad_account_id?: string
  advertiser_name?: string
  geographic?: string
  budget?: string
}
export type StandaloneAudienceRequestReddit = StandaloneShareViaAccountAudienceConfig
export type GetSimilarHandlesQuery = {
  handle: string
}
export type StandaloneHandle = {
  handle: string
  id: string
  name: string
  followers: number
  bio: string
  profile_pic_url: string
}
export type StandaloneSimilarHandles = {
  handles: StandaloneHandle[]
}
export type StandaloneCheckAdAccountAccessInput = {
  ad_account_id?: string|null
}
export type StandaloneCheckAdAccountAccess = {
  access: boolean
}
export type PrivateModelInput = {
  email: string
}
export type PrivateModel = StandaloneShareViaAccountAudienceConfig
export type StandaloneHandleInput = GetSimilarHandlesQuery
export type GetStandaloneAudienceUsedInAdsListQuery = {
  limit?: number
  offset?: number
  search?: string
  ad_account_id?: string
  token?: string
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
}
export type StandaloneAudienceUsedInAds = {
  id: number
  has_insights: boolean
  state: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
  name: string|null
  description: string|null
  ad_account_id: string
  ad_account_name: string
  audience_config_id: number|null
  audience_config_status: 'Imported'|'Processing'|'Done'
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  created: string
  modified: string
  campaign_id: string|null
  campaign_name: string|null
  funding_source_id: string|null
  currency: string|null
  daily_budget: string|null
  total_budget: string|null
  start_date: string|null
  end_date: string|null
  audience_size: string|null
  data: object|null
  reviewed: boolean|null
}
export type StandaloneDetailAudienceUsedInAdsInput = {
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
  email?: string|null
  name?: string|null
  description?: string|null
  ad_account_id?: string
  audience_config_id?: number|null
  audience_creator_query_id?: number|null
  countries?: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  campaign_id?: string|null
  campaign_name?: string|null
  funding_source_id?: string|null
  currency?: string|null
  daily_budget?: string|null
  total_budget?: string|null
  start_date?: string|null
  end_date?: string|null
  audience_size?: string|null
  data?: object|null
  targeting_package_extra?: object
  exclusion_audience?: boolean
  reviewed?: boolean|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: string|null; keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: string[]; gender: string; age: string; locations: string[] }|null
}
export type StandaloneDetailAudienceUsedInAds = {
  id: number
  has_insights: boolean
  state: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
  name: string|null
  description: string|null
  ad_account_id: string
  ad_account_name: string
  audience_config_id: number|null
  audience_config_status: 'Imported'|'Processing'|'Done'
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  created: string
  modified: string
  campaign_id: string|null
  campaign_name: string|null
  funding_source_id: string|null
  currency: string|null
  daily_budget: string|null
  total_budget: string|null
  start_date: string|null
  end_date: string|null
  audience_size: string|null
  data: object|null
  reviewed: boolean|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: string|null; keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: string[]; gender: string; age: string; locations: string[] }|null
}
export type GetAutopilotSuggestedBudgetQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneAutopilotSuggestedBudget = {
  budget: number
  size: number|null
}
export type GetAutopilotUsageAllowedQuery = {
  ad_account_id?: string
}
export type StandaloneAutopilotUsageAllowedAudienceUsedInAds = {
  allowed: boolean
  enterprise: boolean
}
export type GetAutopilotUsageQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneAutopilotUsageAudienceUsedInAds = {
  campaigns_launched: string
  campaigns_budget: string
}
export type StandaloneAudienceUsedInAdsGenerateSheetInput = {
  id: number
}
export type StandaloneAudienceUsedInAdsGenerateSheet = StandaloneInsightsAnalyzerGenerateSheet
export type StandaloneReorderHandlesAudienceUsedInAdsInput = {
  audience_used_in_ads_id: number
  order: 'balanced'|'narrow'|'broad'|'custom'
}
export type StandaloneReorderHandlesAudienceUsedInAds = {
  handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]
}
export type StandaloneShareViaAccountAudienceUsedInAdsInput = {
  ad_account_id: string
  audience_used_in_ads_id?: string
}
export type StandaloneShareViaAccountAudienceUsedInAds = StandaloneShareViaAccountAudienceConfig
export type StandaloneShareAudienceUsedInAdsInput = {
  ad_account_id: string
  audience_used_in_ads_ids?: string
}
export type StandaloneShareAudienceUsedInAds = StandaloneShareAudienceConfig
export type StandaloneSharedAudienceUsedInAdsInput = {
  audience_used_in_ads_id?: string
}
export type StandaloneSharedAudienceUsedInAds = {
  ad_account_ids: string[]
}
export type GetVerifySignedQuery = {
  token?: string
}
export type DeleteStandaloneAudienceUsedInAdsInstanceQuery = GetStandaloneAudienceUsedInAdsListQuery
export type GetStandaloneAudienceUsedInAdsInstanceQuery = GetStandaloneAudienceUsedInAdsListQuery
export type PatchStandaloneAudienceUsedInAdsInstanceQuery = GetStandaloneAudienceUsedInAdsListQuery
export type PutStandaloneAudienceUsedInAdsInstanceQuery = GetStandaloneAudienceUsedInAdsListQuery
export type StandaloneAudienceUsedInAdsInput = {
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
  email?: string|null
  name?: string|null
  description?: string|null
  ad_account_id?: string
  audience_config_id?: number|null
  audience_creator_query_id?: number|null
  countries?: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  campaign_id?: string|null
  campaign_name?: string|null
  funding_source_id?: string|null
  currency?: string|null
  daily_budget?: string|null
  total_budget?: string|null
  start_date?: string|null
  end_date?: string|null
  audience_size?: string|null
  data?: object|null
  targeting_package_extra?: object
  exclusion_audience?: boolean
  reviewed?: boolean|null
}
export type PatchRestoreQuery = {
  search?: string
  ad_account_id?: string
  token?: string
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
}
export type CreateProTargetingPdfInput = {
  insights_id: number
}
export type CreateProTargetingPdf = CreateCampaignPdf
export type GetStandaloneAudienceListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  id?: string
  ad_account?: string
  targetable?: string
}
export type GetStandaloneAudienceInstanceQuery = GetStandaloneAudienceListQuery
export type BigDipperAdSuggestionPromptInput = {
  prompt: string
  search_id?: string|null
  url?: string|null
  keywords?: string[]
  countries?: string[]
}
export type BigDipperAdSuggestionResult = {
  id: number
  created: string
  modified: string
  image_prompt: string|null
  image_url: string|null
  image_description: string|null
  ad_text: string|null
}
export type BigDipperAdSuggestionPrompt = {
  id: number
  created: string
  modified: string
  search: number
  site: string|null
  user_prompt: string|null
  results: BigDipperAdSuggestionResult[]
}
export type StandaloneMessage = {
  role: 'user'|'assistant'|'system'
  content: string
}
export type GetAnalyzeQueryQuery = {
  user_query: string
  history?: StandaloneMessage[]
  email?: string
  session_id?: number
}
export type AmygdalaAccount = {
  name: string
  pic: string
  country: string
  classifier_names: string[]
}
export type StandaloneAmygdalaAnalyzeQuery = {
  session_id: number|null
  accounts: AmygdalaAccount[]
  n_entities: string|null
  parsed_query: string|null
}
export type GetAnswerQueryQuery = {
  user_query?: string
  history?: string
}
export type NoneType = StandaloneShareViaAccountAudienceConfig
export type GetDiscoverSummaryStreamQuery = {
  topic_name?: string
  location?: string
}
export type StandaloneAmygdalaDiscoverTopics = {
  topics: any
}
export type GetDiscoverQuery = {
  topic_name: string
  location?: string
}
export type AmygdalaEntity = {
  uuid: string|null
  name: string
  pic: string
  rank: number
  country: string
  topics: string[]
  entity_type: string|null
}
export type YouTubeChannel = {
  channel_id: string
  handle: string
  title: string
  description: string|null
  view_count: number|null
  subscriber_count: number|null
  video_count: number|null
  thumbnail_url: string|null
}
export type YouTubeVideo = {
  channel_id: string
  video_id: string
  title: string
  description: string|null
  publish_date: string|null
  thumbnail_url: string|null
  channel: YouTubeChannel
  view_count: number|null
  like_count: number|null
  comment_count: number|null
}
export type DeepThoughtPostMedia = {
  account: DeepThoughtPostAccount
  post: DeepThoughtPostTweetTimeline
}
export type StandaloneAmygdalaDiscover = {
  entities: AmygdalaEntity[]
  youtube_videos: YouTubeVideo[]
  posts: DeepThoughtPostMedia[]
}
export type GetEntityDetailQuery = {
  uuid: string
}
export type StandaloneAmygdalaEntityDetail = {
  uuid: string
  name: string
  pic: string
  country: string
  site: string
  topics: string[]
  entity_type: string|null
  bio: string
  x_handle: string
  x_followers: number|null
  facebook_handle: string
  facebook_followers: number|null
  instagram_handle: string
  instagram_followers: number|null
  linkedin_handle: string
  linkedin_followers: number|null
  reddit_handle: string
  reddit_followers: number|null
  tiktok_handle: string
  tiktok_followers: number|null
  snapchat_handle: string
  snapchat_followers: number|null
  youtube_handle: string
  youtube_followers: number|null
  discord_handle: string
  discord_followers: number|null
  twitch_handle: string
  twitch_followers: number|null
  spotify_id: string
  spotify_handle: string
  spotify_followers: number|null
  pinterest_handle: string
  pinterest_followers: number|null
}
export type GetGenerateContextQuery = {
  user_query: string
  session_id?: number
}
export type SpotifyShow = {
  spotify_id: string
  spotify_handle: string|null
  account_name: string
  pic: string|null
  name: string
  description: string|null
  image_url: string|null
  publisher: string|null
  total_episodes: number|null
}
export type SpotifyArtist = {
  spotify_id: string
  spotify_handle: string|null
  account_name: string
  pic: string|null
  spotify_followers: number|null
  name: string
  description: string|null
  popularity: number|null
  genres: string[]
  image_url: string|null
}
export type Subreddit = {
  subreddit: string
  mentions: number
  comment_count: number|null
  public_description: string|null
  subscribers: number|null
  subreddit_name: string
  daily_impressions: number|null
  img_url: string|null
}
export type GoogleInstance = {
  title: string
  url: string
  text: string
  published_date: string
  icon: string|null
  name: string|null
}
export type StandalonePlatformAccount = {
  name: string
  handle: string
  followers: number|null
  pic: string|null
  description: string|null
}
export type StandaloneAmygdalaContext = {
  spotify_shows: SpotifyShow[]
  spotify_artists: SpotifyArtist[]
  youtube_channels: YouTubeChannel[]
  subreddits: Subreddit[]
  google: GoogleInstance[]
  instagram: StandalonePlatformAccount[]
  tiktok: StandalonePlatformAccount[]
  discord: StandalonePlatformAccount[]
  accounts_posts: DeepThoughtPostMedia[]
  searched_posts: DeepThoughtPostMedia[]
}
export type StandaloneAmygdalaGenerateContext = {
  session_id: number|null
  context: StandaloneAmygdalaContext
}
export type GetAmygdalaSearchQuery = {
  user_query: string
  limit?: number
  append_socials?: string
}
export type StandaloneAmygdalaSearch = {
  entities: AmygdalaEntity[]
}
export type GetSentimentAnalysisQuery = {
  user_query: string
}
export type StandaloneMonitorWeekResultCounts = {
  positive: number|null
  negative: number|null
  neutral: number|null
  offensive: number|null
  non_offensive: number|null
}
export type StandaloneAmygdalaSentimentAnalysis = {
  sentiments: StandaloneMonitorWeekResultCounts
}
export type StandaloneAmygdalaUserSearchSummaryInput = {
  session_id: number
  input_query: string
  summary: string
}
export type StandaloneAmygdalaUserSearchSummary = StandaloneAmygdalaUserSearchSummaryInput
export type GetUserSessionSearchesQuery = {
  session_id?: string
}
export type StandaloneAmygdalaUserSessionSearches = {
  id: number
  session: number
  input_query: string|null
  keywords: object
  countries: object
  entities: object
  n_entities: string|null
  context: object
  summary: string
  created: string
}
export type GetUserSessionsQuery = {
  email?: string
}
export type StandaloneAmygdalaUserSessions = {
  id: number
  user: number
  email: string|null
  created: string
  title: string|null
}
export type GetAnalyzePromptQuery = {
  input_query: string
  countries?: string[]
  email?: string
}
export type StandaloneAnalyzeQuery = {
  analyzed_countries: string[]
  analyzed_keywords: string[]
  search_id: number
}
export type GetAudienceInsightsQuery = {
  keywords: string[]
  countries?: string[]
  user_query?: string
  history?: StandaloneMessage[]
}
export type StandaloneAudienceInsights = {
  professions: ChartData[]
  genders: ChartData[]
  languages: ChartData[]
  output_countries: ChartData[]
  cities: ChartData[]
  enrichments: DeepThoughtEnrichment[]|null
}
export type StandaloneFeedback2 = {
  email: string|null
  feedback: string
}
export type StandaloneFeedbackInput2 = {
  email?: string|null
  feedback: string
}
export type GetCreateMagicLoginLinkQuery = PrivateModelInput
export type StandaloneCreateMagicLoginLink = {
  email: string
  magic_code: string
}
export type GetFetchGrokathonIdsQuery = {
  keywords: string[]
  countries: string[]
  plan_type: 'interest'|'profession'
}
export type StandaloneFetchGrokathonIds = {
  ids: number[]
}
export type GetFetchIdsHandlesTopicsGrokathonQuery = {
  handles: string[]
  topics: string[]
  limit?: number
  location?: string
}
export type StandaloneFetchIdsHandlesTopicsGrokathon = StandaloneFetchGrokathonIds
export type GetFetchSizeGrokathonIdsQuery = StandaloneFetchGrokathonIds
export type StandaloneFetchSizeGrokathonIds = {
  size: string
}
export type GetFetchTopicsAndRanksIdsGrokathonQuery = StandaloneFetchGrokathonIds
export type StandaloneFetchTopicsAndRanksIdsGrokathon = {
  topics: string[]
  accounts_ranks: any
}
export type StandaloneFetchTopicsGrokathon = {
  topics: any
  all_topics: string[]
}
export type GetFetchTopicsRanksHandleGrokathonQuery = GetSimilarHandlesQuery
export type StandaloneFetchTopicsRanksHandleGrokathon = {
  accounts_ranks: string[]
  topics: string[]
}
export type GetKeywordsHashtagsQuery = GetAudienceInsightsQuery
export type StandAloneKeywordsHashtags = {
  top_keywords: ChartData[]
  top_hashtags: ChartData[]
}
export type StandaloneUser = PrivateModelInput
export type GetRedditCommentsQuery = {
  subreddit_names: string[]
}
export type RedditSubmission = {
  id: string
  title: string
  author: string|null
  selftext: string
  score: number
  ups: number
  num_comments: number
  subreddit: string
  subreddit_name_prefixed: string
  permalink: string
  url: string
  thumbnail: string
  is_self: boolean
  domain: string
  upvote_ratio: number
  created: string|null
  created_utc: number|null
}
export type RedditComment = {
  id: string
  author: string|null
  body: string
  score: number
  ups: number
  subreddit: string
  subreddit_name_prefixed: string
  permalink: string
  link_title: string
  link_url: string
  num_comments: number
  created: string|null
  created_utc: number|null
  submission: RedditSubmission
}
export type StandaloneRedditComments = {
  comments: RedditComment[]
}
export type SavedPost = {
  id: number
  post_text: string|null
  image_url: string|null
  image_prompt: string|null
  reference_image_urls: object|null
  generation_prompt: string|null
  status: 'draft'|'published'|'scheduled'|'schedule_failed'|null
  publish_type: 'organic'|'dark'|null
  published_at: string|null
  published_platforms: object|null
  created: string
}
export type SavedPostInput = {
  post_text?: string|null
  image_url?: string|null
  image_prompt?: string|null
  reference_image_urls?: object|null
  generation_prompt?: string|null
  status?: 'draft'|'published'|'scheduled'|'schedule_failed'|null
  publish_type?: 'organic'|'dark'|null
}
export type GetAdSuggestionPromptsBySearchQuery = {
  search_id?: string
}
export type GetSocialAccountsContentQuery = {
  keywords: string[]
  countries?: string[]
}
export type SpotifyEpisode = {
  episode_id: string
  account_name: string
  pic: string|null
  show_name: string
  episode_name: string
  description: string|null
  image_url: string|null
  audio_preview_url: string|null
  release_date: string|null
  duration: number|null
  show_id: string
}
export type TwitchVideo = {
  video_id: string
  handle: string
  title: string
  description: string|null
  publish_date: string|null
  thumbnail_url: string|null
  view_count: number|null
}
export type StandaloneSocialAccountsContent = {
  spotify_shows: SpotifyShow[]
  spotify_artists: SpotifyArtist[]
  spotify_episodes: SpotifyEpisode[]
  youtube_channels: YouTubeChannel[]
  youtube_videos: YouTubeVideo[]
  subreddits: Subreddit[]
  twitch_channels: StandalonePlatformAccount[]
  twitch_videos: TwitchVideo[]
  posts: DeepThoughtPostMedia[]
}
export type GetSocialAccountsPerPlatformQuery = GetSocialAccountsContentQuery
export type StandalonePlatformUsage = {
  platform: string
  usage: number|null
}
export type StandalonePlatformAccountsPerPlatform = {
  facebook_accounts: StandalonePlatformAccount[]
  instagram_accounts: StandalonePlatformAccount[]
  linkedin_accounts: StandalonePlatformAccount[]
  tiktok_accounts: StandalonePlatformAccount[]
  youtube_accounts: StandalonePlatformAccount[]
  discord_accounts: StandalonePlatformAccount[]
  twitch_accounts: StandalonePlatformAccount[]
  x_accounts: StandalonePlatformAccount[]
  pinterest_accounts: StandalonePlatformAccount[]
  spotify_shows: SpotifyShow[]
  subreddits: Subreddit[]
  platform_usage: StandalonePlatformUsage[]
}
export type GetSocialAccountsQuery = {
  keywords?: string[]
  countries?: string[]
  email?: string
}
export type AccountSocials = {
  name: string
  bio: string
  x_handle: string
  x_followers: number|null
  facebook_handle: string
  facebook_followers: number|null
  instagram_handle: string
  instagram_followers: number|null
  linkedin_handle: string
  linkedin_followers: number|null
  reddit_handle: string
  reddit_followers: number|null
  tiktok_handle: string
  tiktok_followers: number|null
  snapchat_handle: string
  snapchat_followers: number|null
  youtube_handle: string
  youtube_followers: number|null
  discord_handle: string
  discord_followers: number|null
  twitch_handle: string
  twitch_followers: number|null
  spotify_id: string
  spotify_handle: string
  spotify_followers: number|null
  pinterest_handle: string
  pinterest_followers: number|null
  pic: string
  classifier_names: string[]
}
export type StandaloneSocialAccounts = {
  accounts: AccountSocials[]
  analyzed_countries: string[]
  analyzed_keywords: string[]
}
export type GetTargetingPackDiscordQuery = GetSocialAccountsContentQuery
export type StandaloneDiscordTargetingPack = {
  discord_accounts: StandalonePlatformAccount[]
}
export type GetTargetingPackRedditQuery = GetSocialAccountsContentQuery
export type StandaloneRedditTargetingPack = {
  keywords_targeting_pack: string[]
  subreddits: Subreddit[]
}
export type GetTargetingPackSeoQuery = GetSocialAccountsContentQuery
export type StandaloneSeoTargetingPack = {
  seo_keywords: string[]
  seo_phrases: string[]
}
export type GetTargetingPackSpotifyQuery = GetSocialAccountsContentQuery
export type StandaloneSpotifyTargetingPack = {
  spotify_shows: SpotifyShow[]
  ad_category: string
  interests: string[]
  age_ranges: string[]
}
export type GetTargetingPackTiktokQuery = GetSocialAccountsContentQuery
export type StandaloneTiktokTargetingPack = {
  hashtags_and_interests: string[]
}
export type GetTargetingPackTwitchQuery = GetSocialAccountsContentQuery
export type StandaloneTwitchTargetingPack = {
  audience_interests: string[]
  game_category: string
  devices: string
  peak_streaming_times: string
  recommended_ad_formats: string
  bid_optimization_strategy: string
  measurement_kpis: string
  twitch_channels: StandalonePlatformAccount[]
}
export type GetTargetingPackXQuery = GetSocialAccountsContentQuery
export type StandaloneHandless = {
  handle: string
  name: string
  followers: number|null
  pic: string|null
}
export type StandaloneXTargetingPack = {
  keywords_targeting_pack: string[]
  hashtags: string[]
  handles: StandaloneHandless[]
}
export type GetTargetingPackYoutubeQuery = GetSocialAccountsContentQuery
export type StandaloneYoutubeTargetingPack = {
  youtube_channels: YouTubeChannel[]
  youtube_videos: YouTubeVideo[]
}
export type BigDipperTeam = {
  website: string|null
}
export type BigDipperTeamInput = {
  website?: string|null
}
export type GetUseMagicLoginLinkQuery = {
  magic_code: string
  confirm_code: string
}
export type UseMagicLoginLink = {
  token: string
  is_new_user: boolean
}
export type GetUserSearchHistoryQuery = {
  distinct?: boolean
  with_ad_suggestions?: boolean
}
export type StandaloneUserSearchHistory = {
  id: number
  created: string
  modified: string
  has_ad_suggestions: boolean
  ad_suggestions: BigDipperAdSuggestionPrompt[]
  keywords: string
  countries: string[]
  input_query: string
}
export type WallPostSuggestionInput = {
  prompt: string
  reference_image_urls?: string[]
  url?: string|null
  custom_image_prompt?: string|null
  use_exact_images?: boolean
}
export type WallPostSuggestion = {
  results: any[]
}
export type GetYoutubeVideosQuery = {
  channel_ids: string[]
}
export type StandaloneYoutubeVideos = {
  videos: YouTubeVideo[]
}
export type BigDipperAdSuggestionResultInput = {
  image_description?: string|null
  ad_text?: string|null
}
export type StandaloneCampaignCalculatorInput = {
  objective: 'reach'|'video_views'|'pre_roll_views'|'engagements'|'traffic'|'app_installs'|'app_engagements'
  countries: string[]
  budget: number
  weeks: number
}
export type StandaloneCampaignCalculatorReach = {
  budget: number
  value: number
}
export type StandaloneCampaignCalculatorEstimate = {
  cpm: number
  impressions: number
  reach: number
  frequency: number
  prediction: StandaloneCampaignCalculatorReach[]|null
  budget: number
  weeks: number
}
export type StandaloneCampaignCalculator = {
  objective: 'reach'|'video_views'|'pre_roll_views'|'engagements'|'traffic'|'app_installs'|'app_engagements'
  countries: string[]
  budget: number
  weeks: number
  estimates: StandaloneCampaignCalculatorEstimate[]
}
export type StandaloneWriteTwitterAdsetInput = {
  creatives: string[]
  end_time?: string|null
  is_autobid?: boolean
  max_bid?: number|null
  name: string
  start_time: string
  country?: string|null
  age_min?: number|null
  age_max?: number|null
  locations?: any[]
  daily_budget?: number|null
  exclude_audiences?: string[]
  include_audiences?: string[]
  handles?: string[]
  keywords?: string[]
  hashtags?: string[]
  iab_targeting?: string[]
  lifetime_budget?: number|null
  status?: 'active'|'paused'
}
export type StandaloneCampaignCreateInput = {
  audience_description: string
  countries: string[]
  ad_account_id: string
  funding_instrument_id: string
  name: string
  budget?: number|null
  objective?: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'REACH'|'FOLLOWERS'|'ENGAGEMENTS'|'VIDEO_VIEWS'|'PREROLL_VIEWS'|'WEBSITE_CLICKS'
  adsets: StandaloneWriteTwitterAdsetInput[]
}
export type StandaloneCampaignCreate = StandaloneInsightsAnalyzerGenerateSheet
export type StandaloneCampaignExtractParametersMessagesInput = {
  type: 'ai'|'user'
  response?: string
}
export type StandaloneCampaignExtractParametersInput = {
  audience_description?: string
  countries?: string[]
  ad_account_id?: string
  funding_instrument_id?: string
  name?: string
  messages: StandaloneCampaignExtractParametersMessagesInput[]
  budget?: string
  objective?: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'REACH'|'FOLLOWERS'|'ENGAGEMENTS'|'VIDEO_VIEWS'|'PREROLL_VIEWS'|'WEBSITE_CLICKS'
}
export type StandaloneCampaignExtractParameters = {
  audience_description: string
  countries: string[]
  ad_account_id: string
  funding_instrument_id: string
  name: string
  budget: string
  more_information_required: boolean
  create_campaign: boolean
  start_new_session: boolean
  objective: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'REACH'|'FOLLOWERS'|'ENGAGEMENTS'|'VIDEO_VIEWS'|'PREROLL_VIEWS'|'WEBSITE_CLICKS'
}
export type GetStandAloneCampaignOptionListQuery = StandaloneAdAccountFundingSourcesInput
export type StandAloneCampaignOption = {
  campaign_id: string
  name: string
  start_time: string
}
export type GetStandAloneCampaignOptionInstanceQuery = StandaloneAdAccountFundingSourcesInput
export type GetStandaloneCheckAgencyAdAccountListQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneCheckAgencyAdAccount = {
  ad_account_ids: string[]
  agency: string
}
export type GetStandaloneCheckAgencyAdAccountInstanceQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneCheckCustomAudiencesInput = {
  ad_account_id: string
  audience_config_id?: number
  audience_used_in_ads_id?: number
  custom_audience_names?: string[]
}
export type StandaloneCustomAudienceStatus = {
  name: string
  audience_id: string
  targetable: boolean
  reasons_not_targetable: string[]
}
export type StandaloneCheckCustomAudiences = {
  custom_audiences: StandaloneCustomAudienceStatus[]
}
export type StandAloneCompetitorAnalysisInput = {
  email?: string|null
  ad_account_id?: string|null
  input_handle: string
  input_handles: string[]
  days: number
}
export type DeepThoughtAccountCompetitor = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  verified_count: number|null
  verified_count_rank: number|null
  auth_token: string|null
  token: string|null
  bot: boolean|null
  active: boolean|null
  gender: string|null
  following: boolean|null
  follows_you: boolean|null
  suspended: boolean|null
  verified_followers_count: number|null
  classifier_names: string[]|null
  updated: string|null
  churn_ratio: number|null
  engager: boolean
  tweets: number|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  location: string|null
  site: string|null
  facebook: string|null
  instagram: string|null
  youtube: string|null
  linkedin: string|null
  tweet_date: string|null
  percentage_overlap: number|null
  engagement_rate: number|null
  impressions: number|null
  post_count: number|null
  genders: ChartData[]
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]
  percentage_active: number|null
}
export type StandAloneCompetitorAnalysis = {
  audience_creator_query_id: number
  accounts: DeepThoughtAccountCompetitor[]
  top_posts: DeepThoughtPost[]
}
export type StandaloneAccountTopicsInput = {
  handles: string[]
}
export type DeepThoughtEnrichedAccount = {
  account: DeepThoughtAccount
  enrichments: DeepThoughtEnrichment[]
}
export type StandaloneAccountTopics = {
  enriched_accounts: DeepThoughtEnrichedAccount[]
}
export type StandaloneCompetitorAnalysisSuggestCompetitorsInput = GetSimilarHandlesQuery
export type StandaloneCompetitorAnalysisSuggestCompetitors = {
  suggestions: string[]
}
export type StandaloneExploreParametersInput = {
  handles?: string[]|null
  keywords?: string[]|null
  countries?: string[]|null
  title?: string|null
  query?: string|null
  input_keywords?: string[][]|null
  date_start?: string|null
  date_end?: string|null
}
export type StandAloneComputeAgeGroupsInput = {
  parameters?: StandaloneExploreParametersInput|null
  handles: string[]
  countries_alpha_2: string[]
}
export type StandAloneComputeAgeGroups = {
  age_percentages: ChartData[]
}
export type StandaloneConfigGenerateExploreInsightsInput = {
  email?: string|null
  ad_account_id?: string|null
  audience_config_id: number
}
export type StandaloneConfigGenerateExploreInsights = {
  insights: StandaloneInsightsAnalyzerSync|null
}
export type StandaloneConversationTopic = {
  label: string
}
export type StandaloneSearchConversationTopicsInput = {
  keywords: string
}
export type StandaloneSearchConversationTopics = {
  conversation_topics: StandaloneConversationTopic[]
}
export type StandAloneCreateExclusionAudienceInput = {
  name: string
  email: string
  use_in_all_campaigns: boolean
  ad_account_id: string
  campaign_ids: string[]
}
export type StandAloneCreateExclusionAudience = {
  name: string
  email: string
  audience_id_link: string
}
export type GetAnalyseSpamQuery = {
  input_handle?: string
}
export type DeepThoughtAnalyseSpam = {
  spam_ratio: number
  posts_per_day: number|null
}
export type GetExtractAccountRanksQuery = GetAnalyseSpamQuery
export type DeepThoughtClassifierRank = {
  classifier_id: number
  classifier_name: string
  rank: number
}
export type DeepThoughtExtractAccountRanks = {
  ranks: DeepThoughtClassifierRank[]
}
export type GetFollowersTokenQuery = {
  limit?: number
  offset?: number
  verified?: boolean
  spam?: string
  active?: boolean
  input_handle?: string
  handle?: string
  follower_gte?: string
  follower_lte?: string
  verified_follower_gte?: string
  verified_follower_lte?: string
  following_gte?: string
  following_lte?: string
  order?: string
  order_by?: string
}
export type GetFollowingTokenQuery = {
  limit?: number
  offset?: number
  verified?: boolean
  spam?: string
  active?: boolean
  input_handle?: string
  handle?: string
  classifier_name?: string
  follower_gte?: string
  follower_lte?: string
  verified_follower_gte?: string
  verified_follower_lte?: string
  following_gte?: string
  following_lte?: string
  order_by?: string
  order?: string
  follows_you?: boolean
}
export type GetPredictPayoutBasedOnEngagementsTokenQuery = {
  input_handle?: string
  like_count?: number
  retweet_count?: number
  quote_count?: number
  reply_count?: number
  bookmark_count?: number
  user_profile_clicks?: number
}
export type DeepThoughtVerifiedEngagementCounts = {
  verified_like_count: number|null
  verified_retweet_count: number|null
  verified_quote_count: number|null
  verified_reply_count: number|null
  verified_engagement_count: number|null
  verified_bookmark_count: number|null
  verified_user_profile_clicks: number|null
}
export type DeepThoughtPredictPayoutBasedOnEngagements = {
  payout: number
  verified_engagements: DeepThoughtVerifiedEngagementCounts
}
export type GetUnfollowersTokenQuery = {
  input_handle?: string
  handle?: string
  follower_gte?: string
  follower_lte?: string
  order?: string
  order_by?: string
}
export type DeepThoughtFollowerOverlap = StandaloneInsightsAnalyzerKeywordAccounts
export type DeepThoughtVerifiedFollowersInput = GetSimilarHandlesQuery
export type DeepThoughtVerifiedFollowers = {
  count: number
  account: DeepThoughtAccount
}
export type DeepThoughtWhoToFollowInput = {
  description: string
  input_handle?: string
  max_followers?: number|null
  is_verified?: boolean|null
  is_not_following?: boolean|null
  limit?: number
}
export type DeepThoughtWhoToFollow = {
  influencers: DeepThoughtAccount[]|null
}
export type DeepThoughtListMemberInput = {
  list_id: string
  account_ids: string[]
}
export type DeepThoughtListMember = {
  success: boolean
}
export type _DeepThoughtCountryInput = {
  country: string
  percentage: number
}
export type DeepThoughtBestPostTimeInput = {
  countries: _DeepThoughtCountryInput[]
  timezone: string
}
export type DeepThoughtBestPostTime = CreateCampaignPdf
export type SubscriptionCancelInput = StandaloneShareViaAccountAudienceConfig
export type SubscriptionCancel = {
  message: string
}
export type DeepThoughtListInput = {
  name: string
  description: string|null
  private: boolean
}
export type DeepThoughtList = {
  id: string
  name: string
  description: string|null
  private: boolean
}
export type ReferralCreateInput = {
  referred_handle: string
}
export type ReferralCreate = {
  success: boolean
  referral_url: string
}
export type SubscriptionCreateInput = {
  referrer_handle?: string
}
export type SubscriptionCreate = {
  checkout_url: string
}
export type GetEngagersQuery = {
  verified?: boolean
  follower_gte?: number
  follower_lte?: number
  following_gte?: number
  following_lte?: number
  handle?: string
  order?: string
  order_by?: string
}
export type DeepThoughtEngager = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  verified_count: number|null
  verified_count_rank: number|null
  auth_token: string|null
  token: string|null
  bot: boolean|null
  active: boolean|null
  gender: string|null
  following: boolean|null
  follows_you: boolean|null
  suspended: boolean|null
  verified_followers_count: number|null
  classifier_names: string[]|null
  updated: string|null
  churn_ratio: number|null
  engager: boolean
  tweets: number|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  location: string|null
  site: string|null
  facebook: string|null
  instagram: string|null
  youtube: string|null
  linkedin: string|null
  tweet_date: string|null
  like_count: number
  reply_count: number
  retweet_count: number
  quote_count: number
  total_engagements: number
}
export type DeepThoughtEngagers = {
  accounts: DeepThoughtEngager[]
}
export type DeepThoughtEnrichmentAccountsInput = {
  classifier_ids?: number[]|null
  already_following?: boolean
  verified?: boolean
  follower_gte?: number
  follower_lte?: number
  following_gte?: number
  following_lte?: number
}
export type DeepThoughtEnrichmentClassifierAccounts = {
  classifier_id: number
  accounts: DeepThoughtAccount[]
}
export type DeepThoughtEnrichmentAccounts = {
  enriched_classifier_accounts: DeepThoughtEnrichmentClassifierAccounts[]
}
export type DeepThoughtEnrichedAccountMany = {
  accounts: DeepThoughtEnrichmentClassifierAccounts[]
  enrichments: DeepThoughtEnrichment[]
}
export type DeepThoughtEnrichmentsInput = StandaloneAccountTopicsInput
export type DeepThoughtEnrichments = StandaloneAccountTopics
export type GetFetchInterestsQuery = {
  name?: string
}
export type DeepThoughtInterest = ClassifierChild
export type DeepThoughtFetchInterests = {
  interests: DeepThoughtInterest[]
}
export type GetFetchTimelineQuery = {
  classifier_ids?: number[]
  account_ids?: number[]
  tweet_ids?: number[]
  locations?: string[]
  order_by?: string
  min_score?: number
  max_score?: number
  limit?: number
  is_verified?: boolean
  max_followers?: number
}
export type DeepThoughtTimelineAccount = {
  accountid: string
  pic: string
  handle: string
  name: string
  verified: boolean
  blue: boolean
  followers: number
  friends: number
  grey: boolean
  gold: boolean
  affiliation_description: string
  affiliation_badge_url: string|null
}
export type DeepThoughtTimeline = {
  account: DeepThoughtTimelineAccount
  post: DeepThoughtPostTweetTimeline
}
export type DeepThoughtFetchTimeline = {
  posts: DeepThoughtTimeline[]
}
export type DeepThoughtFollowAccountInput = GetStandaloneAdAccountListQuery
export type DeepThoughtFollowAccount = {
  following: boolean
}
export type DeepThoughtFollowerIntersectionInput = StandaloneAccountTopicsInput
export type DeepThoughtFollowerIntersection = {
  accounts: DeepThoughtAccount[]
  count: number
}
export type DeepThoughtBotPercentageInput = {
  handles?: string[]
}
export type DeepThoughtBotPercentage = {
  bot_percentage: number
}
export type GetFollowersQuery = {
  limit?: number
  offset?: number
  verified?: boolean
  non_engagers?: string
  spam?: string
  active?: boolean
  handle?: string
  follower_gte?: string
  follower_lte?: string
  verified_follower_gte?: string
  verified_follower_lte?: string
  following_gte?: string
  following_lte?: string
  order?: string
  order_by?: string
}
export type GetFollowingQuery = {
  limit?: number
  offset?: number
  verified?: boolean
  spam?: string
  active?: boolean
  handle?: string
  classifier_name?: string
  follower_gte?: string
  follower_lte?: string
  verified_follower_gte?: string
  verified_follower_lte?: string
  following_gte?: string
  following_lte?: string
  order_by?: string
  order?: string
  follows_you?: boolean
}
export type DeepThoughtPayoutActualInput = {
  periods: string[]
  payouts: string[]
}
export type DeepThoughtPayoutActual = DeepThoughtListMember
export type _DeepThoughtPayoutPredictor = {
  engagement_count: number
  verified_engagement_count: number
  payout: number
  period: string
  verified_like_count: number
  verified_retweet_count: number
  verified_quote_count: number
  verified_reply_count: number
  verified_bookmark_count: number
  verified_user_profile_clicks: number
}
export type DeepThoughtPayoutPredictor = {
  estimation: number
  previous: _DeepThoughtPayoutPredictor
  current: _DeepThoughtPayoutPredictor
  last_updated: string
}
export type DeepThoughtPostsAccountInput = GetStandaloneAdAccountListQuery
export type DeepThoughtPostCounts = {
  total: number|null
  like_count: number|null
  retweet_count: number|null
  reply_count: number|null
  quote_count: number|null
  bookmark_count: number|null
  user_profile_clicks: number|null
  impression_count: number|null
}
export type DeepThoughtViewCounts = {
  retweets: number|null
  replies: number|null
  quotes: number|null
  posts: number|null
  percentage: number|null
  reach: number|null
}
export type DeepThoughtPostsAccount = {
  account: DeepThoughtAccount
  posts: DeepThoughtPost[]
  post_counts: DeepThoughtPostCounts
  view_counts: DeepThoughtViewCounts
}
export type GetPostsAndLikesQuery = {
  days?: string
  order?: string
  order_by?: string
}
export type DeepThoughtLiker = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  verified_count: number|null
  verified_count_rank: number|null
  auth_token: string|null
  token: string|null
  bot: boolean|null
  active: boolean|null
  gender: string|null
  following: boolean|null
  follows_you: boolean|null
  suspended: boolean|null
  verified_followers_count: number|null
  classifier_names: string[]|null
  updated: string|null
  churn_ratio: number|null
  engager: boolean
  tweets: number|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  location: string|null
  site: string|null
  facebook: string|null
  instagram: string|null
  youtube: string|null
  linkedin: string|null
  tweet_date: string|null
  like_count: number|null
}
export type DeepThoughtPostsAndLikes = {
  posts: DeepThoughtPost[]
  likers: DeepThoughtLiker[]
  post_counts: DeepThoughtPostCounts
  view_counts: DeepThoughtViewCounts
  verified_engagement_counts: DeepThoughtVerifiedEngagementCounts
}
export type GetPredictPayoutBasedOnEngagementsQuery = {
  like_count?: number
  retweet_count?: number
  quote_count?: number
  reply_count?: number
  bookmark_count?: number
  user_profile_clicks?: number
}
export type DeepThoughtPredictPostPerformanceInput = {
  draft_post: string
}
export type DeepThoughtPredictPost = {
  like_count: number
  reply_count: number
  impression_count: number
}
export type DeepThoughtImprovedPost = {
  like_count: number
  reply_count: number
  impression_count: number
  improved_post: string
}
export type DeepThoughtPredictPostPerformance = {
  prediction_text: string
  predicted_engagements: DeepThoughtPredictPost
  improved_post: DeepThoughtImprovedPost
}
export type DeepThoughtAccountRecentlyJoined = {
  recently_joined: boolean
}
export type GetSearchNotificationsQuery = {
  input_text?: string
}
export type DeepThoughtSearchNotifications = {
  found_likes: DeepThoughtPost[]
  found_engagements: DeepThoughtPost[]
  found_followers: DeepThoughtPostAccount[]
}
export type UserSubscription = {
  id: number
  referral_credit_months: any
  created: string
  modified: string
  invoice_name: string
  website: string|null
  vat_number: string|null
  address: string|null
  zip_code: string|null
  city: string|null
  country: string|null
  phone: string|null
  invoice_email: string|null
  stripe_customer_id: string|null
  accepted_terms_and_conditions: string|null
  is_active: boolean
  cancels_at: string|null
  user: number
}
export type UserSubscriptionInput = {
  invoice_name?: string
  website?: string|null
  vat_number?: string|null
  address?: string|null
  zip_code?: string|null
  city?: string|null
  country?: string|null
  phone?: string|null
  invoice_email?: string|null
  accepted_terms_and_conditions?: string|null
  cancels_at?: string|null
  user: number
}
export type DeepThoughtQuestions = {
  questions: string[]
}
export type DeepThoughtTalkToXInput = {
  query: string
}
export type DeepThoughtTalkToX = {
  unmodified_query: string
  user_queries: number
  accounts: DeepThoughtAccount[]
  follower_enrichments: DeepThoughtEnrichedAccountMany
  followers: DeepThoughtAccount[]
  friends: DeepThoughtAccount[]
  posts: DeepThoughtPost[]
  question: string|null
  information_type: string[]
  title: string
  percentage_active: string
  gender_split: any|null
  community_size: string
  enrichments: DeepThoughtEnrichment[]
}
export type DeepThoughtCountry = {
  country: string
  alpha_2: string
  percentage: number
  count: number|null
}
export type DeepThoughtCountries = {
  countries: DeepThoughtCountry[]
}
export type DeepThoughtUnfollowAccountBulkInput = {
  account_ids: string[]
}
export type DeepThoughtUnfollowAccountBulk = DeepThoughtListMember
export type GetUnfollowersQuery = {
  handle?: string
  follower_gte?: string
  follower_lte?: string
  order?: string
  order_by?: string
}
export type DeepThoughtInputHandleInput = {
  input_handle: string
}
export type DeepThoughtInputHandle = StandaloneShareViaAccountAudienceConfig
export type DeepThoughtXStatsCountryActivity = {
  country: string
  alpha_2: string
  active_users: number
  population_percentage: number|null
}
export type GetXStatsQuery = {
  alpha2_code?: string
}
export type DeepThoughtEstimate = {
  min: number|null
  max: number|null
}
export type DeepThoughtXStatsAge = {
  age: string
  estimate: DeepThoughtEstimate
}
export type DeepThoughtXStatsCount = {
  country: string
  alpha_2: string
  count: number
}
export type DeepThoughtXStatsTrend = {
  trend_name: string
  tweet_count: number|null
}
export type DeepThoughtXStats = {
  active_users_last_6_months: number
  active_users_last_3_months: number
  active_users_last_month: number
  active_users_age_groups: DeepThoughtXStatsAge[]|null
  verified_users: number
  gold_users: number
  top_accounts: DeepThoughtAccount[]
  top_tweets: DeepThoughtPost[]
  top_countries: DeepThoughtXStatsCountryActivity[]
  verified_users_by_country: DeepThoughtXStatsCount[]
  gold_users_by_country: DeepThoughtXStatsCount[]
  trends: DeepThoughtXStatsTrend[]
  age_groups: DeepThoughtXStatsAge[]|null
}
export type GetPostEngagementsQuery = {
  verified?: string
  spam?: string
  active?: boolean
  handle?: string
  follower_gte?: string
  follower_lte?: string
  following_gte?: string
  following_lte?: string
  order_by?: string
  engagement_type?: string
}
export type DeepThoughtPostEngagement = {
  post: DeepThoughtPost
  likers: DeepThoughtAccount[]
  retweeters: DeepThoughtAccount[]
  retweets: DeepThoughtPost[]
}
export type DeepThoughtReport = {
  mean_eng_rate: number
  reply_percentage: number
  engagement_counts: DeepThoughtPostCounts
  top_posts: DeepThoughtPost[]
  avg_text_length: number
  avg_followers_per_day: number
  avg_friends_per_day: number
  avg_tweets_per_day: number
  top_followers: DeepThoughtAccount[]
}
export type DeepThoughtUpdateListInput = DeepThoughtListInput
export type DeepThoughtUpdateList = DeepThoughtList
export type BlobSocialdatabase = {
  file: any
  preview_file: any|null
  name: string
  description: string|null
  bucket: 'dashboard-storage-msdb'|'xprotargeting-assets'|'xprotargeting-assets-private'
}
export type EventSocialdatabase = {
  id: number
  name: string
  title: string
  description: string
  slides_url: string
  icon: BlobSocialdatabase|null
  header: BlobSocialdatabase
  slides: BlobSocialdatabase
  onepager: BlobSocialdatabase
  targeting_keywords: BlobSocialdatabase
  dashboard: BlobSocialdatabase|null
}
export type StandaloneExploreClustersInput = {
  parent_id?: number
}
export type Cluster = {
  id: number
  name: string
  score: number
  percentage: number
}
export type ClusterChildren = {
  id: number
  name: string
  score: number
  percentage: number
  parent: string|null
  parent_id: number|null
  parent_score: number|null
  parent_percentage: number|null
  children: Cluster[]
}
export type StandaloneExploreClusters = {
  id: number
  name: string
  score: number
  percentage: number
  parent: string|null
  parent_score: number|null
  parent_percentage: number|null
  children: Cluster[]
  cluster_data: ClusterChildren[]
}
export type StandaloneCompareAccountsInput = {
  handles: string[]
  direction?: string|null
}
export type AccountsEnrichments = {
  handle: string
  enrichments: DeepThoughtEnrichment[]|null
}
export type StandaloneCompareAccounts = {
  handles_enrichments: AccountsEnrichments[]|null
}
export type StandaloneCreatorsParametersInput = {
  handles?: string[]|null
  keywords?: string[]|null
  countries?: string[]|null
  title?: string|null
  query?: string|null
  input_keywords?: string[][]|null
  date_start?: string|null
  date_end?: string|null
  min_followers?: number|null
  max_followers?: number|null
  min_friends?: number|null
  max_friends?: number|null
  is_creator?: boolean
}
export type StandAloneExploreExtractCreatorsInput = {
  parameters?: StandaloneCreatorsParametersInput|null
  top_k?: number
}
export type CreatorAccount = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  classifier_names: string[]|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  label: string|null
  country: string|null
  gender: string|null
  account_creation_date: string|null
}
export type StandAloneExploreExtractCreators = {
  accounts: CreatorAccount[]
  classifier_name_options: string[]
}
export type StandaloneCreatorClassifierChildrenInput = {
  classifier_name: string
}
export type StandaloneCreatorClassifierChildren = {
  children: string[]
}
export type StandAloneExploreDemographicsInput = {
  parameters: StandaloneExploreParametersInput
}
export type StandAloneExploreDemographics = {
  genders: ChartData[]
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]
  cities: ChartData[]
  languages: ChartData[]
  keywords: ChartData[]
  double_keywords: ChartData[]
  hashtags: ChartData[]
  show_country_message: boolean|null
}
export type GetStandaloneExploreEmailAdAccountsListQuery = {
  email: string
  ad_account_id: string
}
export type StandaloneExploreEmailAdAccounts = {
  id: number
  email: string
  ad_account_id: string
  ad_account_name: string
  ad_account: any
}
export type StandaloneExploreEmailAdAccountsInput = {
  email: string
  ad_account_id: string
  ad_account_name: string
}
export type GetStandaloneExploreEmailAdAccountsInstanceQuery = GetStandaloneExploreEmailAdAccountsListQuery
export type PatchStandaloneExploreEmailAdAccountsInstanceQuery = GetStandaloneExploreEmailAdAccountsListQuery
export type PutStandaloneExploreEmailAdAccountsInstanceQuery = GetStandaloneExploreEmailAdAccountsListQuery
export type StandAloneExploreEnrichmentsInput = {
  parameters: StandaloneExploreParametersInput
  top_k?: number
  input_handle?: string
  query_type?: 'account'|'friends'|'followers'
}
export type StandAloneExploreEnrichments = {
  professions: ChartData[]
  subreddits: StandaloneSubreddits[]|null
  enrichments: DeepThoughtEnrichment[]|null
}
export type StandaloneExploreExtractDataHandlesInput = StandAloneExploreDemographicsInput
export type StandaloneExploreExtractDataHandles = {
  percentage_active: number|null
  percentage_active_tweeter: number|null
  sample_accounts: DeepThoughtAccount[]
  accounts: DeepThoughtAccount[]
}
export type StandaloneExploreExtractDataKeywordsInput = StandAloneExploreDemographicsInput
export type StandaloneExploreExtractDataKeywords = {
  sample_accounts: DeepThoughtAccount[]
}
export type StandaloneExploreExtractDataTweetKeywordsInput = {
  input_keywords?: string[][]
  alpha_2?: string
}
export type StandaloneExploreExtractDataTweetKeywords = {
  parameters: StandaloneExploreParameters
  sample_accounts: DeepThoughtAccount[]
}
export type StandalonePostMetadataHandleInput = {
  handles: string[]
  location?: string|null
}
export type StandalonePostMetadataHandle = {
  counts: StandalonePostMetadataCount
  summary: string|null
}
export type StandAloneExploreFollowerGrowthInput = {
  handles: string[]
  max_months?: number
}
export type StandAloneExploreFollowerGrowth = {
  account_stats: DeepThoughtAccountStats[]|null
}
export type StandaloneExploreExtractPostDataHandlesInput = {
  parameters: StandaloneExploreParametersInput
  days?: number|null
  order_by?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
}
export type StandaloneExploreExtractPostDataHandles = {
  single_keywords_handles: ChartData[]
  double_keywords_handles: ChartData[]
  hashtags_handles: ChartData[]
  emoji_counts_handles: ChartData[]
  top_posts_handles: DeepThoughtAccountTweet[]
}
export type StandAloneExplorePostsDataInput = StandaloneExploreExtractPostDataHandlesInput
export type StandAloneExplorePostsData = {
  keywords_tweets: ChartData[]
  double_keywords_tweets: ChartData[]
  hashtags_tweets: ChartData[]
  post_counts: PostCounts|null
  emoji_counts: ChartData[]
  top_posts: DeepThoughtAccountTweet[]
}
export type GetStandaloneExploreSearchListQuery = {
  email?: string
  ad_account_id?: string
  query_type?: 'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'
}
export type StandaloneAudienceCreatorQuery = {
  id: number
  input_query: string|null
  ad_account_id: string|null
  email: string|null
  parameters: StandaloneExploreParameters|null
  input_type: 'searchbar'|'advanced_settings'|'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'|'creator_analysis'|null
}
export type StandaloneExploreSearch = {
  id: number
  email: string
  audience_creator_query: StandaloneAudienceCreatorQuery
  query_type: 'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'
  name: string
  ad_account_id: string
  size: number
}
export type StandaloneExploreSearchInput = {
  email?: string
  audience_creator_query_id: number
  query_type?: 'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'
  name?: string
  ad_account_id?: string
  size?: number
}
export type DeleteStandaloneExploreSearchInstanceQuery = GetStandaloneExploreSearchListQuery
export type GetStandaloneExploreSearchInstanceQuery = GetStandaloneExploreSearchListQuery
export type PatchStandaloneExploreSearchInstanceQuery = GetStandaloneExploreSearchListQuery
export type PutStandaloneExploreSearchInstanceQuery = GetStandaloneExploreSearchListQuery
export type StandAloneExploreExtractSEOKeywordsInput = StandAloneExploreDemographicsInput
export type StandAloneExploreExtractSEOKeywords = StandaloneSeoTargetingPack
export type StandaloneFindRelatedAudiencesClassifierInput = {
  classifier_id: number
  location?: string
}
export type StandaloneFindRelatedAudiencesClassifier = {
  audience_configs: StandaloneAudienceConfigListItem[]
}
export type StandaloneFindRelatedAudiencesInput = StandAloneExploreDemographicsInput
export type StandaloneFindRelatedAudiences = StandaloneFindRelatedAudiencesClassifier
export type StandAloneExploreTopAccountsInput = {
  parameters: StandaloneExploreParametersInput
  engages_with?: boolean
}
export type StandAloneExploreTopAccounts = {
  size: SizeData|null
  top_accounts: DeepThoughtAccount[]
}
export type StandAloneExploreTopFollowersInput = StandaloneAccountTopicsInput
export type StandAloneExploreTopFollowers = {
  top_followers: DeepThoughtAccount[]
}
export type StandAloneExploreTopPostsInput = {
  parameters: StandaloneExploreParametersInput
  days?: number|null
  limit?: number
  offset?: number
}
export type StandAloneExploreTopPosts = {
  top_posts: DeepThoughtAccountTweet[]
}
export type StandAloneExtractExclusionSampleInput = {
  ad_account_id: string
  campaign_ids: string[]
}
export type StandAloneExtractExclusionSample = {
  size: number
  counts: StandaloneMonitorWeekResultCounts
}
export type StandaloneNativePackGeneratorInput = {
  input_keyword_groups?: string[][]|null
  input_handles?: string[]|null
  input_countries?: string[]|null
  input_genders?: ('any'|'male'|'female')[]|null
  input_audience_selectivity?: 'balanced'|'narrow'|'broad'|null
  input_exclude_keywords?: string[]|null
  input_location_states?: string[]|null
  input_budget?: 500|1000|2500|5000|10000|20000|50000|100000|250000|500000|750000|1000000|null
  input_size?: 25000|50000|100000|150000|300000|600000|1500000|3000000|7500000|15000000|22000000|30000000|null
  description?: string|null
  email?: string|null
  ad_account_id?: string|null
  plan_type?: string|null
}
export type StandaloneNativePackGenerator = {
  id: number
  created: string
  modified: string
  status: any|null
  gender: { label: string; value: number; valueText: string }[]|null
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  regions: { label: string; value: number; valueText: string }[]|null
  cities: { label: string; value: number; valueText: string; long: number|null; lat: number|null }[]|null
  specific_interests: { label: string; value: number; valueText: string }[]|null
  interests: { label: string; value: number; valueText: string }[]|null
  interest_fields: { label: string; value: number; valueText: string }[]|null
  professions: { label: string; value: number; valueText: string }[]|null
  profession_fields: { label: string; value: number; valueText: string }[]|null
  income_level: { label: string; value: number; valueText: string }[]|null
  education_level: { label: string; value: number; valueText: string }[]|null
  socioeconomic_status: { label: string; value: number; valueText: string }[]|null
  bio_words: { label: string; value: number; valueText: string }[]
  bio_hashtags: { label: string; value: number; valueText: string }[]|null
  bio_chunks: any
  tweet_words: { label: string; value: number; valueText: string }[]|null
  tweet_keywords: { label: string; value: number; valueText: string }[]|null
  mentioned_hashtags: { label: string; value: number; valueText: string }[]|null
  mentioned_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_tweets: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_liked: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_retweeted: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  most_retweeted_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  influencers: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[]
  audience_estimation: { min: number; max: number; warning: string|null }|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: string|null; keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: string[]; gender: string; age: string; locations: string[] }|null
  targeting_package_size: { min: number; max: number }|null
  related_communities: null|string[]|null
  core_accounts: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture?: string|null; likes_per_month?: number|null; tweets_per_month?: number|null; activity_score?: number|null; likes_count?: number|null; tweets_count?: number|null; site?: string|null; gender?: string|null; profession?: string|null; interest?: string|null; sub_interest?: string|null; country?: string|null; region?: string|null; city?: string|null; age?: string|null; secondary_sub_interest?: string|null; tertiary_sub_interest?: string|null }[]
  age: { label: string; value: number; valueText: string }[]|null
  sites: { label: string; value: number; valueText: string }[]|null
  accounts_count: { InitialSearch: number|null; JobTitles: number|null; Influencers: number|null; FollowersCount: number|null }|null
  suggestions: { query: string; metadata: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[] }[]|null
  audience_creator_query_id: number
  analyzed_keyword_groups: string[][]
  analyzed_handles: string[]
  analyzed_countries: string[]
  analyzed_location_states: string[]
  analyzed_gender: 1|2|12|null
  analyzed_age_range: string|null
  analyzed_audience_selectivity: 'balanced'|'narrow'|'broad'
  plan_type: string|null
}
export type GetDownloadImageUniqueNameQuery = {
  url?: string
}
export type StandaloneInterest = StandaloneConversationTopic
export type StandaloneSearchInterestsInput = StandaloneSearchConversationTopicsInput
export type StandaloneSearchInterests = {
  interests: StandaloneInterest[]
}
export type StandAloneJobTitlesSizeEstimatorInput = {
  job_titles: string[]
  countries: string[]
}
export type StandAloneJobTitlesSizeEstimator = {
  size: SizeData
}
export type StandaloneJobTitleTargetingInput = {
  email?: string|null
  ad_account_id: string
  campaign_name?: string|null
  campaign_id?: string|null
  job_titles: string[]
  countries: string[]
}
export type StandaloneJobTitleTargeting = {
  custom_audience_names: string[]
}
export type StandaloneAutopilotKeywordSuggestionUsageInput = {
  keyword_groups?: string[][]|null
  exclude_keywords?: string[]|null
  countries?: string[]|null
  handles?: string[]|null
  suggestions_added?: string[]|null
  suggestions?: string[]|null
  ad_account_id?: string|null
  description?: string|null
}
export type StandaloneAutopilotKeywordSuggestionUsageManyInput = {
  usages: StandaloneAutopilotKeywordSuggestionUsageInput[]
}
export type StandaloneAutopilotKeywordSuggestionUsageMany = DeepThoughtListMember
export type StandaloneLanguage = StandaloneConversationTopic
export type GetStandaloneTargetingLocationsListQuery = {
  country_code?: string
}
export type StandaloneTargetingLocation = StandaloneConversationTopic
export type StandaloneSearchTargetingLocationsInput = {
  country_code: string
  keywords: string
}
export type StandaloneSearchTargetingLocations = {
  locations: StandaloneTargetingLocation[]
}
export type BlobList = {
  preview_file: any|null
  name: string
  description: string|null
  bucket: 'dashboard-storage-msdb'|'xprotargeting-assets'|'xprotargeting-assets-private'
}
export type MarketingMaterialList = {
  id: number
  name: string
  title: string
  document_type: 'one-pager'|'slides'|'faq'|'case-study'
  file: BlobList
}
export type MarketingMaterialInput = PrivateModelInput
export type MarketingMaterial = {
  id: number
  name: string
  title: string
  document_type: 'one-pager'|'slides'|'faq'|'case-study'
  file: BlobSocialdatabase
}
export type GetStandaloneMonitorListQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneMonitor = ClassifierChild
export type GetStandaloneMonitorInstanceQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneMoviesTvShows = StandaloneConversationTopic
export type StandaloneSearchMoviesTvShowsInput = StandaloneSearchConversationTopicsInput
export type StandaloneSearchMoviesTvShows = {
  movies_tv_shows: StandaloneMoviesTvShows[]
}
export type StandaloneNetworkOperator = StandaloneConversationTopic
export type StandaloneSearchNetworkOperatorsInput = StandaloneSearchConversationTopicsInput
export type StandaloneSearchNetworkOperators = {
  network_operators: StandaloneNetworkOperator[]
}
export type StandalonePersonaTokenInput = {
  query?: string|null
  url?: string|null
}
export type StandalonePersonaToken = {
  query: string|null
  url: string|null
}
export type GetMagicQuery = {
  email?: string
  magic_code?: string
  confirm_code?: string
}
export type CreateMagicLoginLink = StandaloneCreateMagicLoginLink
export type GetUseQuery = GetMagicQuery
export type StandAlonePostsAccountInput = GetStandaloneAdAccountListQuery
export type StandAlonePostsAccount = {
  posts: DeepThoughtPost[]
  post_counts: DeepThoughtPostCounts
  view_counts: DeepThoughtViewCounts
}
export type StandAloneXplorePostsSentimentAnalysisInput = {
  ad_account_id?: string|null
  tweet_ids: string[]
  order_posts?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
}
export type StandAloneXplorePostsSentimentAnalysis = {
  tweet_ids: string[]
  sentiments: StandaloneMonitorWeekResultCounts
  audience_creator_query_id: number
  posts: DeepThoughtPost[]
}
export type GetStandaloneRecentlyCreatedAudiencesListQuery = GetAutopilotUsageAllowedQuery
export type StandaloneRecentlyCreatedAudienceConfig = {
  id: number
  created: string
}
export type StandaloneRecentlyCreatedAudienceUsedInAds = {
  id: number
  audience_config_status: 'Imported'|'Processing'|'Done'
  created: string
}
export type StandaloneRecentlyCreatedAudiences = {
  audience_configs: StandaloneRecentlyCreatedAudienceConfig[]
  audience_used_in_ads: StandaloneRecentlyCreatedAudienceUsedInAds[]
}
export type GetStandaloneRecentlyCreatedAudiencesInstanceQuery = GetAutopilotUsageAllowedQuery
export type StandaloneRelatedKeywordsInput = {
  input_keywords: string[]
  exclude_keywords?: string[]|null
}
export type StandaloneRelatedKeywords = {
  related_keywords: string[]
}
export type StandaloneMe = PrivateModelInput
export type StandaloneTopicAccountsInput = {
  classifier_id?: number
  classifier_name?: string
  order_top_accounts?: 'connectivity'|'relevancy'
  limit?: number
}
export type StandaloneTopicAccounts = {
  classifier_id: number
  published: boolean
  accounts: DeepThoughtAccount[]
}
export type StandAloneUploadAudienceInput = {
  ad_account_id: string
  config_id: number
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
}
export type StandAloneUploadAudience = {
  audience_used_in_ads_id: number
}
export type StandaloneUserActivityEntryInput = {
  action?: string|null
  context?: string|null
  action_at: string
  classifier_id?: number
  audience_creator_query_id?: number
}
export type StandaloneUserActivityEntry = {
  id: number
  user_id: number
  action: string|null
  context: string|null
  action_at: string
  classifier_id: number
  audience_creator_query_id: number
}
export type StandaloneMonitorExtractWeeklyResultsInput = {
  monitor_id: number
}
export type StandaloneMonitorWeekResults = {
  week: string
  counts: StandaloneMonitorWeekResultCounts
}
export type StandaloneMonitorExtractWeeklyResults = {
  weekly_results: StandaloneMonitorWeekResults[]
}
export type StandaloneXConversationInput = {
  email?: string|null
  ad_account_id?: string|null
  keywords: string[][]
  exclude_keywords?: string[]|null
  start?: string|null
  end?: string|null
  skip_sentiments?: boolean
  skip_conversation_volume?: boolean
  order_posts?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
  alpha_2?: string
  input_type?: 'searchbar'|'advanced_settings'|'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'|'creator_analysis'
}
export type StandalonePostActivity = {
  end: string
  start: string
  tweet_count: number
}
export type StandaloneXConversation = {
  keywords: string[][]
  sentiments: StandaloneMonitorWeekResultCounts
  post_activity: StandalonePostActivity[]
  pa_const: number|null
  synonym_words: string[]
  audience_creator_query_id: number
  posts: DeepThoughtPost[]
}
export type StandAlonePostActivityInput = {
  keywords: string[][]
  start?: string|null
  end?: string|null
  alpha_2?: string
  pa_const?: number|null
}
export type StandAlonePostActivity = {
  post_activity: StandalonePostActivity[]
  count: number
}
export type StandAloneExploreSentimentAnalysisInput = {
  keywords: string[][]
}
export type StandAloneExploreSentimentAnalysis = {
  keywords: string[][]
  sentiments: StandaloneMonitorWeekResultCounts
}
export type StandAloneGenerateShareOfVoiceAliasesInput = {
  keyword: string
  locale?: 'en'|'ja'
}
export type StandAloneGenerateShareOfVoiceAliases = {
  aliases_keyword: string[]
}
export type StandAloneGenerateShareOfVoiceKeywordsInput = {
  keywords: string[][]
  alpha_2?: string
  locale?: 'en'|'ja'
}
export type StandAloneShareOfVoice = {
  name: string
  aliases: string[]
}
export type StandAloneGenerateShareOfVoiceKeywords = {
  share_of_voice_keywords: StandAloneShareOfVoice[]
}
export type GetTrendingTopicsQuery = GetXStatsQuery
export type StandaloneXploreDetailTrendsInput = {
  classifier_id: number
  country?: string|null
}
export type StandaloneXploreDetailTrends = {
  keywords_tweets: ChartData[]
  double_keywords_tweets: ChartData[]
  hashtags_tweets: ChartData[]
}
export type StandaloneXploreDetailInput = {
  classifier_id?: number
  country?: string
  order_top_accounts?: 'followers'|'connectivity'|'relevancy'
  order_posts?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
  classifier_name?: string
}
export type StandaloneXploreDetail = {
  classifier_id: number
  classifier_name: string
  children: ClassifierChild[]
  audience_size: number|null
  post_activity: StandalonePostActivity[]
  audience_regions: AudienceRegion[]
  parents: ClassifierChild[]
  subreddits: StandaloneSubreddits[]|null
  accounts: DeepThoughtAccount[]
  posts: DeepThoughtPost[]
}
export type StandAloneXplorePostsSentimentInput = {
  sentiment: string
  keywords: string[][]
}
export type StandAloneXplorePostsSentiment = {
  posts: DeepThoughtPost[]
}
export type StandAloneXplorePostsStartEndInput = {
  keywords: string[][]
  exclude_keywords?: string[]
  alpha_2?: string
  start: string
  end: string
  order_posts?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
}
export type StandAloneXplorePostsStartEnd = StandAloneXplorePostsSentiment
export type StandaloneXploreInput = {
  search?: string
}
export type Account = {
  accountid: number
  handle: string
  pic: string
  connectivity: number
}
export type ClassifierResult = {
  classifier_id: number
  name: string
  accounts: Account[]
  audience_size: number|null
}
export type StandaloneXplore = {
  classifiers: ClassifierResult[]
}
export type GeoLocation = {
  country: string
}
export type HelperDocuments = {
  id: number
  description: string|null
  filename: any
  label: string|null
  created_at: string
  updated_at: string
}
export type GetDownloadQuery = {
  id?: string
  name?: string
}
export type HelperDocumentsDownload = StandaloneInsightsAnalyzerGenerateSheet
export type Icon = {
  id: number
  name: string
  icon_image: any|null
  icon_type: 'group'
  group_id: number|null
  neighbours: number[]
  type_code: number|null
}
export type IconNeighbours = {
  id: number
  name: string
  icon_image: any|null
  icon_type: 'group'
  group_id: number|null
  neighbours: Icon[]
  type_code: number|null
}
export type GetIconoGraphyListQuery = {
  search?: string
  id?: number
  child?: IconNeighbours
  parent?: IconNeighbours
}
export type Iconography = {
  id: number
  child: IconNeighbours|null
  parent: IconNeighbours
  order: number
}
export type GetIconoGraphyInstanceQuery = GetIconoGraphyListQuery
export type GetInsightsInfluencerListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  account_id?: string
  handle: string
}
export type InsightsInfluencer = {
  id: number
  community_name: string|null
  account_id: string
  created: string
  modified: string
  handle: string
  influencer_data: object|null
  rank: number
  insights: number
}
export type GetInsightsInfluencerInstanceQuery = GetInsightsInfluencerListQuery
export type CreateInsightsPdfInput = CreateProTargetingPdfInput
export type CreateInsightsPdf = CreateCampaignPdf
export type JobTitle = ClassifierChild
export type MetricInfo = {
  key: string
  label: string
  description: string
  group: 'delivery'|'engagement'|'spend'|'video'|'website'|'conversions'|'other'
  networks: ('twitter'|'facebook'|'linkedin')[]
  objectives: string[]
  is_super_metric: boolean
  is_featured: boolean
  unit: 'none'|'percent'|'currency'
  aggregate: 'total'|'average'
  abm_phase: 'phase_1_video_views'|'phase_2_engagements'|'phase_3_traffic'|null
}
export type E2E = {
  e2estatus: string
}
export type TargetingCountries = {
  key: string
  name: string
}
export type TargetingInterests = TargetingCountries
export type TargetingLocations = {
  key: string
  name: string
  country_code: string
}
export type GetUserTeamListQuery = {
  ordering?: string
}
export type TeamInput = {
  name: string
  logo?: string|null
  website?: string|null
  invoice_name?: string
  vat_number?: string|null
  address?: string|null
  zip_code?: string|null
  city?: string|null
  country?: string|null
  phone?: string|null
  invoice_email?: string|null
}
export type Team = {
  id: number
  slug: string|null
  validate_email_domain: boolean
  feature_campaigns: boolean
  feature_superinsights: boolean
  region: number|null
  member_count: number
  subscriptions: Subscription[]
  accepted_terms_and_conditions: string|null
  name: string
  logo: string|null
  website: string|null
  invoice_name: string
  vat_number: string|null
  address: string|null
  zip_code: string|null
  city: string|null
  country: string|null
  phone: string|null
  invoice_email: string|null
}
export type GetUserTeamInstanceQuery = GetUserTeamListQuery
export type PatchUserTeamInstanceQuery = GetUserTeamListQuery
export type PutUserTeamInstanceQuery = GetUserTeamListQuery
export type AdAccount = {
  name: string|null
  network: 'facebook'|'twitter'|'linkedin'
  timezone: string|null
  default_page_id: string|null
  funding_instruments: any
  timezone_offset_hours_utc: any
  countries: any[]
  id: string
  default_funding_instrument: string|null
  pixels: object|null
  default_pixel_id: string|null
}
export type TeamInvite = {
  id: number
  team_name: string
  invite_url: string
  invited_email: string
  level: 'admin'|'member'
  message: string|null
  accepted_at: string|null
  updated_at: string
  created_at: string
  team: number
  user: number
  invited_user: number|null
}
export type TeamInviteInput = {
  invited_email: string
  level?: 'admin'|'member'
  message?: string|null
}
export type InviteAcceptInput = {
  code: string
}
export type InviteAccept = InviteAcceptInput
export type TeamUser = {
  id: number
  username: string
  first_name: string
  last_name: string
  email: string
  date_joined: string
  last_login: string|null
}
export type TeamMember = {
  user: TeamUser
  team: number
  level: 'admin'|'member'
  updated_at: string
  created_at: string
  accounts: string[]
}
export type UploadedAudiencesInput = {
  ad_account: string
  team: string
  configs_to_upload: number[]
}
export type UploadedAudiences = UploadedAudiencesInput
export type UserAdAccount = {
  name: string|null
  network: 'facebook'|'twitter'|'linkedin'
  id: string
}
export type FollowUnfollowInput = {
  insights_id: number
  account_ids: number[]
  is_followed?: boolean|null
}
export type FollowUnfollow = {
  is_followed: boolean|null
}
export type _GrantedAccount = {
  id: number
  account_id: string
  name: string|null
  network: 'facebook'|'twitter'|'linkedin'
}
export type GrantedAccount = {
  id: number
  account: _GrantedAccount
  updated_at: string
  member: number
}
export type _GrantedAccountInput = {
  account_id: string
  name?: string|null
  network: 'facebook'|'twitter'|'linkedin'
}
export type GrantedAccountInput = {
  account: _GrantedAccountInput
  member: number
}
export type TwitterList = {
  id: string|null
  name: string
  description: string|null
  private: boolean
}
export type TwitterListInput = {
  id?: string|null
  name: string
  description: string|null
  private?: boolean
}
export type TwitterListsMembersInput = {
  id?: string|null
  intent: 'create'|'destroy'
  members: number[]
}
export type TwitterListsMembers = {
  id: string|null
  intent: 'create'|'destroy'
  members: number[]
  message: string
}
export type CreateMagicLoginLinkInput = PrivateModelInput
export type UseMagicLoginLinkInput = GetUseMagicLoginLinkQuery
export type UseMagicLoginLink2 = StandaloneShareViaAccountAudienceConfig
export type SocialAccount = {
  id: number
  uid: string
  provider: string
  name: any
  last_login: string
  date_joined: string
}
export type Membership = {
  id: number
  level: 'admin'|'member'
  team: number
  team_name: string
}
export type Group = {
  name: string
}
export type User = {
  id: number
  email: string
  first_name: string
  last_name: string
  social_accounts: SocialAccount[]
  memberships: Membership[]
  groups: Group[]
  token: string
  onboarding_completed_at: string|null
  language: 'en'|'ja'|null
  team_invite: any
  company: string|null
  job_title: string|null
}
export type SocialAccountInput = {
  uid: string
  provider: string
}
export type MembershipInput = {
  level: 'admin'|'member'
  team: number
  team_name: string
}
export type GroupInput = Group
export type UserInput = {
  email?: string
  first_name?: string
  last_name?: string
  social_accounts?: SocialAccountInput[]
  memberships?: MembershipInput[]
  groups?: GroupInput[]
  onboarding_completed_at?: string|null
  language?: 'en'|'ja'|null
  company?: string|null
  job_title?: string|null
}
export type WebEvents = {
  name: string
  event_id: string
  tag_id: string
  status: string
  type: string
}
export type LoginViaTokenInput = {
  token: string
}
export type LoginViaToken = DeepThoughtListMember
export type SocialAccount2 = {
  id: number
  provider: string
  uid: string
  last_login: string
  date_joined: string
}
export type SocialConnectInput = {
  access_token?: string
  code?: string
  id_token?: string
}
export type SocialConnect = {
  access_token: string
  code: string
  id_token: string
}
export type TwitterLoginInput = {
  access_token: string
  token_secret: string
}
export type TwitterLogin = TwitterLoginInput
export type TwitterAccessToken = {
  access_token: string
  secret_token: string
  csrf_token: string
}
export type TwitterConnectInput = TwitterLoginInput
export type TwitterConnect = TwitterLoginInput
export type TwitterRequestToken = {
  oauth_token: string
}
export type MyLoginInput = SocialConnectInput
export type MyLogin = {
  access_token: string
  code: string
  id_token: string
  auth_token: string
  token: string
}
export type TwitterAuthParams = {
  code_challenge: string
  code_challenge_method: string
  csrf_token: string
}
export const schema = {
  AccountApps: {
    list: {
      /** Account apps list */
      path: '/api/account-apps/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AccountApps[],
      errors: {} as {},
    },
  },
  AdCreatives: {
    list: {
      path: '/api/ad-creatives/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AdCreative[],
      errors: {} as {},
    },
    create: {
      path: '/api/ad-creatives/',
      method: 'POST',
      paramsType: {} as {
        body: AdCreativeInput
      },
      responseType: {} as AdCreative,
      errors: {} as {},
    },
    destroy: {
      path: '/api/ad-creatives/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as {},
    },
    retrieve: {
      path: '/api/ad-creatives/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdCreative,
      errors: {} as {},
    },
    partial_update: {
      path: '/api/ad-creatives/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<AdCreativeInput>
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdCreative,
      errors: {} as {},
    },
    update: {
      path: '/api/ad-creatives/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: AdCreativeInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdCreative,
      errors: {} as {},
    },
  },
  AdMedia: {
    list: {
      path: '/api/ad-media/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AdMedia[],
      errors: {} as {},
    },
    create: {
      path: '/api/ad-media/',
      method: 'POST',
      paramsType: {} as {
        body: AdMediaInput
      },
      responseType: {} as AdMedia,
      errors: {} as {},
    },
    destroy: {
      path: '/api/ad-media/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as {},
    },
  },
  Ad: {
    destroy: {
      path: '/api/ads/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as {},
    },
    toggle: {
      path: '/api/ads/{pk}/toggle/',
      method: 'POST',
      paramsType: {} as {
        body: {}
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as {},
    },
  },
  AdSet: {
    list: {
      path: '/api/adsets/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAdSetListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: Adset[]
      },
      errors: {} as {},
    },
    create: {
      path: '/api/adsets/',
      method: 'POST',
      paramsType: {} as {
        body: AdsetInput
      },
      responseType: {} as Adset,
      errors: {} as {},
    },
    destroy: {
      path: '/api/adsets/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteAdSetInstanceQuery
      },
      responseType: {} as {},
      errors: {} as {},
    },
    retrieve: {
      path: '/api/adsets/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAdSetInstanceQuery
      },
      responseType: {} as Adset,
      errors: {} as {},
    },
    partial_update: {
      path: '/api/adsets/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<WriteTwitterAdsetInput>
        path: {
          pk: string|number
        }
        query?: PatchAdSetInstanceQuery
      },
      responseType: {} as WriteTwitterAdset,
      errors: {} as {},
    },
    update: {
      path: '/api/adsets/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: WriteTwitterAdsetInput
        path: {
          pk: string|number
        }
        query?: PutAdSetInstanceQuery
      },
      responseType: {} as WriteTwitterAdset,
      errors: {} as {},
    },
  },
  AdvertiserBusinessCategories: {
    list: {
      /** Account advertiser business categories list */
      path: '/api/advertiser-categories/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AdvertiserBusinessCategories[],
      errors: {} as {},
    },
  },
  FileUploadCompleteHandler: {
    post: {
      path: '/api/api/files/complete/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as {},
    },
  },
  FilePolicyAPI: {
    post: {
      /** This view is to get the AWS Upload Policy for our s3 bucket.
      What we do here is first create a FileItem object instance in our
      Django backend. This is to include the FileItem instance in the path
      we will use within our bucket as you'll see below. */
      path: '/api/api/files/policy/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as {},
    },
  },
  AppEvents: {
    list: {
      /** Account app events list */
      path: '/api/app-events/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AppEvents[],
      errors: {} as {},
    },
  },
  AudienceCategory: {
    list: {
      path: '/api/audience-categories/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAudienceCategoryListQuery
      },
      responseType: {} as AudienceCategory[],
      errors: {} as {},
    },
    retrieve: {
      path: '/api/audience-categories/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAudienceCategoryInstanceQuery
      },
      responseType: {} as AudienceCategory,
      errors: {} as {},
    },
  },
  AudienceConfig: {
    list: {
      path: '/api/audience-configs/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAudienceConfigListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AudienceConfig[]
      },
      errors: {} as {},
    },
    create: {
      path: '/api/audience-configs/',
      method: 'POST',
      paramsType: {} as {
        body: AudienceConfigInput
      },
      responseType: {} as AudienceConfig,
      errors: {} as {},
    },
    autocomplete: {
      path: '/api/audience-configs/autocomplete/',
      method: 'POST',
      paramsType: {} as {
        body: AutoCompleteInput
      },
      responseType: {} as AutoComplete,
      errors: {} as {},
    },
    insights: {
      path: '/api/audience-configs/insights/',
      method: 'POST',
      paramsType: {} as {
        body: AudienceConfigInput
      },
      responseType: {} as AudienceConfig,
      errors: {} as {},
    },
    perspectives: {
      path: '/api/audience-configs/perspectives/',
      method: 'POST',
      paramsType: {} as {
        body: SearchPerspectivesInput
      },
      responseType: {} as SearchPerspectives,
      errors: {} as {},
    },
    retrieve: {
      path: '/api/audience-configs/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAudienceConfigInstanceQuery
      },
      responseType: {} as AudienceConfigDetail,
      errors: {} as {},
    },
    update: {
      path: '/api/audience-configs/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: AudienceConfigInput
        path: {
          pk: string|number
        }
        query?: PutAudienceConfigInstanceQuery
      },
      responseType: {} as AudienceConfig,
      errors: {} as {},
    },
  },
  Insights: {
    retrieve: {
      path: '/api/audience-insight/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as Insights,
      errors: {} as {},
    },
  },
  AudienceInsights: {
    by_config: {
      path: '/api/audience-insights/{pk}/by_config/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as Insights,
      errors: {} as {},
    },
  },
  AudiencePlan: {
    list: {
      path: '/api/audience-plan/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AudiencePlan[],
      errors: {} as {},
    },
    create: {
      path: '/api/audience-plan/',
      method: 'POST',
      paramsType: {} as {
        body: AudiencePlanInput
      },
      responseType: {} as AudiencePlan,
      errors: {} as {},
    },
    destroy: {
      path: '/api/audience-plan/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as {},
    },
    retrieve: {
      path: '/api/audience-plan/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudiencePlan,
      errors: {} as {},
    },
    partial_update: {
      path: '/api/audience-plan/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<AudiencePlanInput>
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudiencePlan,
      errors: {} as {},
    },
    update: {
      path: '/api/audience-plan/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: AudiencePlanInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudiencePlan,
      errors: {} as {},
    },
  },
  AudienceRegion: {
    list: {
      path: '/api/audience-regions/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AudienceRegion[],
      errors: {} as {},
    },
    retrieve: {
      path: '/api/audience-regions/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudienceRegion,
      errors: {} as {},
    },
  },
  Audience: {
    list: {
      path: '/api/audiences/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAudienceListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: Audience[]
      },
      errors: {} as {},
    },
    retrieve: {
      path: '/api/audiences/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAudienceInstanceQuery
      },
      responseType: {} as Audience,
      errors: {} as {},
    },
  },
  BuildAudience: {
    create: {
      path: '/api/build-audience/',
      method: 'POST',
      paramsType: {} as {
        body: BuildAudienceInput
      },
      responseType: {} as BuildAudience,
      errors: {} as {},
    },
  },
  CampaignSummaryPDF: {
    create: {
      path: '/api/campaign-summary-pdf/',
      method: 'POST',
      paramsType: {} as {
        body: CreateCampaignPdfInput
      },
      responseType: {} as CreateCampaignPdf,
      errors: {} as {},
    },
  },
  Campaign: {
    list: {
      path: '/api/campaigns/',
      method: 'GET',
      paramsType: {} as {
        query?: GetCampaignListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: CampaignListItem[]
      },
      errors: {} as {},
    },
    create: {
      path: '/api/campaigns/',
      method: 'POST',
      paramsType: {} as {
        body: WriteTwitterCampaignInput
      },
      responseType: {} as WriteTwitterCampaign,
      errors: {} as {},
    },
    ads: {
      path: '/api/campaigns/ads/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAdsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AdListItem[]
      },
      errors: {} as {},
    },
    adsets: {
      path: '/api/campaigns/adsets/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAdsetsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AdsetListItem[]
      },
      errors: {} as {},
    },
    reach: {
      path: '/api/campaigns/reach/',
      method: 'GET',
      paramsType: {} as {
        query?: GetReachQuery
      },
      responseType: {} as ReachStats,
      errors: {} as {},
    },
    segmentations: {
      path: '/api/campaigns/segmentations/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSegmentationsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: SegmentationListItem[]
      },
      errors: {} as {},
    },
    statstotal: {
      path: '/api/campaigns/statstotal/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStatstotalQuery
      },
      responseType: {} as StatsTotal,
      errors: {} as {},
    },
    destroy: {
      path: '/api/campaigns/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteCampaignInstanceQuery
      },
      responseType: {} as {},
      errors: {} as {},
    },
    retrieve: {
      path: '/api/campaigns/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignInstanceQuery
      },
      responseType: {} as Campaign,
      errors: {} as {},
    },
    partial_update: {
      path: '/api/campaigns/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<WriteTwitterCampaignInput>
        path: {
          pk: string|number
        }
        query?: PatchCampaignInstanceQuery
      },
      responseType: {} as WriteTwitterCampaign,
      errors: {} as {},
    },
    update: {
      path: '/api/campaigns/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: WriteTwitterCampaignInput
        path: {
          pk: string|number
        }
        query?: PutCampaignInstanceQuery
      },
      responseType: {} as WriteTwitterCampaign,
      errors: {} as {},
    },
  },
  Communities: {
    list: {
      path: '/api/communities/',
      method: 'GET',
      paramsType: {} as {
        query?: GetCommunitiesListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AudienceCommunity[]
      },
      errors: {} as {},
    },
    retrieve: {
      path: '/api/communities/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCommunitiesInstanceQuery
      },
      responseType: {} as AudienceCommunity,
      errors: {} as {},
    },
  },
  Community: {
    list: {
      path: '/api/community/',
      method: 'GET',
      paramsType: {} as {
        query?: GetCommunityListQuery
      },
      responseType: {} as Community[],
      errors: {} as {},
    },
    retrieve: {
      path: '/api/community/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCommunityInstanceQuery
      },
      responseType: {} as Community,
      errors: {} as {},
    },
  },
  ContentCategories: {
    list: {
      /** Account content categories list */
      path: '/api/content-categories/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as ContentCategories[],
      errors: {} as {},
    },
  },
  Subscription: {
    cancel: {
      path: '/api/customer/subscriptions/cancel/',
      method: 'POST',
      paramsType: {} as {
        body: CancellationInput
      },
      responseType: {} as Cancellation,
      errors: {} as {},
    },
    checkout: {
      path: '/api/customer/subscriptions/checkout/',
      method: 'POST',
      paramsType: {} as {
        body: CheckoutInput
      },
      responseType: {} as Checkout,
      errors: {} as {},
    },
    public_key: {
      path: '/api/customer/subscriptions/public_key/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as Subscription,
      errors: {} as {},
    },
    upgrade: {
      path: '/api/customer/subscriptions/upgrade/',
      method: 'POST',
      paramsType: {} as {
        body: UpgradeInput
      },
      responseType: {} as Upgrade,
      errors: {} as {},
    },
  },
  ExploreX: {
    create: {
      path: '/api/explore-x/',
      method: 'POST',
      paramsType: {} as {
        body: ExploreXInput
      },
      responseType: {} as ExploreX,
      errors: {} as {},
    },
  },
  StandaloneAdAccount: {
    list: {
      path: '/api/external/ad-account/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAdAccountListQuery
      },
      responseType: {} as StandaloneAdAccount[],
      errors: {} as {},
    },
    create: {
      path: '/api/external/ad-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAdAccountInput
      },
      responseType: {} as StandaloneAdAccount,
      errors: {} as {},
    },
    create_audiences_ad_account: {
      path: '/api/external/ad-account/create-audiences-ad-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceAdAccountInput
      },
      responseType: {} as StandaloneAudienceAdAccount,
      errors: {} as {},
    },
    funding_instruments: {
      path: '/api/external/ad-account/funding-instruments/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAdAccountFundingSourcesInput
      },
      responseType: {} as StandaloneAdAccountFundingSources,
      errors: {} as {},
    },
    retrieve: {
      path: '/api/external/ad-account/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAdAccountInstanceQuery
      },
      responseType: {} as StandaloneAdAccount,
      errors: {} as {},
    },
  },
  StandaloneDescriptionAnalyzer: {
    create: {
      path: '/api/external/analyse-description/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneDescriptionAnalyzerInput
      },
      responseType: {} as StandaloneDescriptionAnalyzer,
      errors: {} as "Brand safety",
    },
  },
  analyze_campaign_creator: {
    post: {
      path: '/api/external/analyze-campaign-creator/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as {},
    },
  },
  analyze_chat_query: {
    post: {
      path: '/api/external/analyze-chat-query/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as {},
    },
  },
  StandaloneInsightsAnalyzer: {
    create: {
      /** Standalone create for insights */
      path: '/api/external/analyze-handles/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneInsightsAnalyzerInput
      },
      responseType: {} as StandaloneInsightsAnalyzer,
      errors: {} as {},
    },
    accounts_for_keywords: {
      /** Standalone accounts for keywords for insights */
      path: '/api/external/analyze-handles/accounts-for-keywords/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneInsightsAnalyzerKeywordAccountsInput
      },
      responseType: {} as StandaloneInsightsAnalyzerKeywordAccounts,
      errors: {} as {},
    },
    create_sheet: {
      /** Standalone create sheet for insights */
      path: '/api/external/analyze-handles/create-sheet/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneInsightsAnalyzerGenerateSheetInput
      },
      responseType: {} as StandaloneInsightsAnalyzerGenerateSheet,
      errors: {} as {},
    },
  },
  StandaloneExploreQueryAnalyzer: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/analyze-query/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreQueryAnalyzerInput
      },
      responseType: {} as StandaloneExploreQueryAnalyzer,
      errors: {} as {},
    },
    create_post: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-query-analyzer/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreQueryAnalyzerInput
      },
      responseType: {} as StandaloneExploreQueryAnalyzer,
      errors: {} as {},
    },
  },
  analyze_topic_posts_sentiments_replies: {
    list: {
      path: '/api/external/analyze-topic-posts-sentiments-replies/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as {},
    },
  },
  analyze_topic_posts_sentiments: {
    list: {
      path: '/api/external/analyze-topic-posts-sentiments/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as {},
    },
  },
  analyze_topic_posts: {
    list: {
      path: '/api/external/analyze-topic-posts/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as {},
    },
  },
  proxy_event_stream: {
    list: {
      path: '/api/external/api/proxy-event-stream/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as {},
    },
  },
  StandaloneAudienceBuilder: {
    list: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceBuilderListQuery
      },
      responseType: {} as AudienceBuilder[],
      errors: {} as {},
    },
    create: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderInput
      },
      responseType: {} as StandaloneAudienceBuilder,
      errors: {} as {},
    },
    followers_of: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/followers-of/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderFollowersOfInput
      },
      responseType: {} as StandaloneAudienceBuilderFollowersOf,
      errors: {} as {},
    },
    generate_insights: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/generate-insights/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderGenerateInsightsInput
      },
      responseType: {} as StandaloneAudienceBuilderGenerateInsights,
      errors: {} as {},
    },
    interested_in: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/interested-in/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderInterestedInInput
      },
      responseType: {} as StandaloneAudienceBuilderInterestedIn,
      errors: {} as {},
    },
    posted_abount: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/posted-about/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderPostedAboutInput
      },
      responseType: {} as StandaloneAudienceBuilderPostedAbout,
      errors: {} as {},
    },
    suggest_interests: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/suggest-interests/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderSuggestInterestsInput
      },
      responseType: {} as StandaloneAudienceBuilderSuggestInterests,
      errors: {} as {},
    },
    words_in_profile: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/words-in-profile/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderWordsInProfileInput
      },
      responseType: {} as StandaloneAudienceBuilderWordsInProfile,
      errors: {} as {},
    },
    destroy: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteStandaloneAudienceBuilderInstanceQuery
      },
      responseType: {} as {},
      errors: {} as {},
    },
  },
  StandaloneAudienceCategory: {
    list: {
      /** Standalone view for audiences */
      path: '/api/external/audience-categories/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceCategoryListQuery
      },
      responseType: {} as AudienceCategory[],
      errors: {} as {},
    },
    retrieve: {
      /** Standalone view for audiences */
      path: '/api/external/audience-categories/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAudienceCategoryInstanceQuery
      },
      responseType: {} as AudienceCategory,
      errors: {} as {},
    },
  },
  StandaloneAudienceConfig: {
    list: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceConfigListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: StandaloneAudienceConfig[]
      },
      errors: {} as {},
    },
    create: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceConfigInput
      },
      responseType: {} as StandaloneAudienceConfig,
      errors: {} as {},
    },
    autocomplete: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/autocomplete/',
      method: 'POST',
      paramsType: {} as {
        body: AutoCompleteInput
      },
      responseType: {} as AutoComplete,
      errors: {} as {},
    },
    insights: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/insights/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceConfigInput
      },
      responseType: {} as StandaloneAudienceConfig,
      errors: {} as {},
    },
    perspectives: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/perspectives/',
      method: 'POST',
      paramsType: {} as {
        body: SearchPerspectivesInput
      },
      responseType: {} as SearchPerspectives,
      errors: {} as {},
    },
    share_via_account: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/share-via-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneShareViaAccountAudienceConfigInput
      },
      responseType: {} as StandaloneShareViaAccountAudienceConfig,
      errors: {} as {},
    },
    share: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/share/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneShareAudienceConfigInput
      },
      responseType: {} as StandaloneShareAudienceConfig,
      errors: {} as {},
    },
    retrieve: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAudienceConfigInstanceQuery
      },
      responseType: {} as StandaloneAudienceConfigDetail,
      errors: {} as {},
    },
    update: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: StandaloneAudienceConfigInput
        path: {
          pk: string|number
        }
        query?: PutStandaloneAudienceConfigInstanceQuery
      },
      responseType: {} as StandaloneAudienceConfig,
      errors: {} as {},
    },
    download_targeting_package: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/{pk}/download_targeting_package/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetDownloadTargetingPackageQuery
      },
      responseType: {} as StandaloneDownloadTargetingPackage,
      errors: {} as {},
    },
  },
  StandaloneAudienceRegion: {
    list: {
      /** Standalone view for audiences */
      path: '/api/external/audience-regions/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AudienceRegion[],
      errors: {} as {},
    },
    retrieve: {
      /** Standalone view for audiences */
      path: '/api/external/audience-regions/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudienceRegion,
      errors: {} as {},
    },
  },
  StandaloneAudienceRequest: {
    create: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceRequestInput
      },
      responseType: {} as StandaloneAudienceRequest,
      errors: {} as {},
    },
    feedback: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/feedback/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput
      },
      responseType: {} as StandaloneFeedback,
      errors: {} as {},
    },
    reddit: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/reddit/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceRequestRedditInput
      },
      responseType: {} as StandaloneAudienceRequestReddit,
      errors: {} as {},
    },
    similar_handles: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/similar-handles/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSimilarHandlesQuery
      },
      responseType: {} as StandaloneSimilarHandles,
      errors: {} as {},
    },
    validate_ad_account: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/validate-ad-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCheckAdAccountAccessInput
      },
      responseType: {} as StandaloneCheckAdAccountAccess,
      errors: {} as {},
    },
    validate_email: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/validate-email/',
      method: 'POST',
      paramsType: {} as {
        body: PrivateModelInput
      },
      responseType: {} as PrivateModel,
      errors: {} as {},
    },
    validate_handle: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/validate-handle/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneHandleInput
      },
      responseType: {} as StandaloneHandle,
      errors: {} as {},
    },
  },
  StandaloneAudienceUsedInAds: {
    list: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceUsedInAdsListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: StandaloneAudienceUsedInAds[]
      },
      errors: {} as {},
    },
    create: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneDetailAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneDetailAudienceUsedInAds,
      errors: {} as "No email found",
    },
    autopilot_suggested_budget: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/autopilot-suggested-budget/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAutopilotSuggestedBudgetQuery
      },
      responseType: {} as StandaloneAutopilotSuggestedBudget,
      errors: {} as {},
    },
    autopilot_usage_allowed: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/autopilot-usage-allowed/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAutopilotUsageAllowedQuery
      },
      responseType: {} as StandaloneAutopilotUsageAllowedAudienceUsedInAds,
      errors: {} as {},
    },
    autopilot_usage: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/autopilot-usage/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAutopilotUsageQuery
      },
      responseType: {} as StandaloneAutopilotUsageAudienceUsedInAds,
      errors: {} as {},
    },
    generate_sheet: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/generate-sheet/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceUsedInAdsGenerateSheetInput
      },
      responseType: {} as StandaloneAudienceUsedInAdsGenerateSheet,
      errors: {} as "A sheet can not be generated as this audience is not associated with an audience created by Socialdatabase."|"No email found",
    },
    reorder_handles: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/reorder-handles/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneReorderHandlesAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneReorderHandlesAudienceUsedInAds,
      errors: {} as "No email found",
    },
    share_via_account: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/share-via-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneShareViaAccountAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneShareViaAccountAudienceUsedInAds,
      errors: {} as "No email found",
    },
    share: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/share/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneShareAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneShareAudienceUsedInAds,
      errors: {} as "No email found",
    },
    shared_with: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/shared-with/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneSharedAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneSharedAudienceUsedInAds,
      errors: {} as "No email found",
    },
    verify_signed: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/verify-signed/',
      method: 'GET',
      paramsType: {} as {
        query?: GetVerifySignedQuery
      },
      responseType: {} as StandaloneAudienceUsedInAds,
      errors: {} as {},
    },
    destroy: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteStandaloneAudienceUsedInAdsInstanceQuery
      },
      responseType: {} as {},
      errors: {} as {},
    },
    retrieve: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAudienceUsedInAdsInstanceQuery
      },
      responseType: {} as StandaloneDetailAudienceUsedInAds,
      errors: {} as {},
    },
    partial_update: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<StandaloneDetailAudienceUsedInAdsInput>
        path: {
          pk: string|number
        }
        query?: PatchStandaloneAudienceUsedInAdsInstanceQuery
      },
      responseType: {} as StandaloneDetailAudienceUsedInAds,
      errors: {} as {},
    },
    update: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: StandaloneDetailAudienceUsedInAdsInput
        path: {
          pk: string|number
        }
        query?: PutStandaloneAudienceUsedInAdsInstanceQuery
      },
      responseType: {} as StandaloneDetailAudienceUsedInAds,
      errors: {} as {},
    },
    restore: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/restore/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<StandaloneAudienceUsedInAdsInput>
        path: {
          pk: string|number
        }
        query?: PatchRestoreQuery
      },
      responseType: {} as StandaloneAudienceUsedInAds,
      errors: {} as {},
    },
  },
  StandaloneInsights: {
    retrieve: {
      /** Standalone view for insights */
      path: '/api/external/audiences-insights/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as Insights,
      errors: {} as {},
    },
  },
  StandaloneProTargetingSummaryPDF: {
    create: {
      path: '/api/external/audiences-pro-targeting-summary/',
      method: 'POST',
      paramsType: {} as {
        body: CreateProTargetingPdfInput
      },
      responseType: {} as CreateProTargetingPdf,
      errors: {} as {},
    },
  },
  StandaloneAudience: {
    list: {
      /** Standalone view for audiences */
      path: '/api/external/audiences/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: Audience[]
      },
      errors: {} as {},
    },
    retrieve: {
      /** Standalone view for audiences */
      path: '/api/external/audiences/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAudienceInstanceQuery
      },
      responseType: {} as Audience,
      errors: {} as {},
    },
  },
  BigDipper: {
    ad_suggestion: {
      /** Generate ad suggestions based on search, prompt and url.
      Prioritizes search_id over keywords + countries */
      path: '/api/external/bigdipper/ad-suggestion-prompt/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperAdSuggestionPromptInput
      },
      responseType: {} as BigDipperAdSuggestionPrompt,
      errors: {} as "Usage limit exceeded",
    },
    analyze_query: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-analyze-query/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAnalyzeQueryQuery
      },
      responseType: {} as StandaloneAmygdalaAnalyzeQuery,
      errors: {} as "Usage limit exceeded",
    },
    answer_query: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-answer-query/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAnswerQueryQuery
      },
      responseType: {} as {},
      errors: {} as "Usage limit exceeded",
    },
    discover_summary_stream: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-discover-summary-stream/',
      method: 'GET',
      paramsType: {} as {
        query?: GetDiscoverSummaryStreamQuery
      },
      responseType: {} as {},
      errors: {} as "Usage limit exceeded",
    },
    discover_topics: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-discover-topics/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneAmygdalaDiscoverTopics,
      errors: {} as "Usage limit exceeded",
    },
    discover: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-discover/',
      method: 'GET',
      paramsType: {} as {
        query?: GetDiscoverQuery
      },
      responseType: {} as StandaloneAmygdalaDiscover,
      errors: {} as "Usage limit exceeded",
    },
    entity_detail: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-entity-detail/',
      method: 'GET',
      paramsType: {} as {
        query?: GetEntityDetailQuery
      },
      responseType: {} as StandaloneAmygdalaEntityDetail,
      errors: {} as "Usage limit exceeded",
    },
    generate_context: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-generate-context/',
      method: 'GET',
      paramsType: {} as {
        query?: GetGenerateContextQuery
      },
      responseType: {} as StandaloneAmygdalaGenerateContext,
      errors: {} as "Usage limit exceeded",
    },
    amygdala_search: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-search/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAmygdalaSearchQuery
      },
      responseType: {} as StandaloneAmygdalaSearch,
      errors: {} as "Usage limit exceeded",
    },
    sentiment_analysis: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-sentiment-analysis/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSentimentAnalysisQuery
      },
      responseType: {} as StandaloneAmygdalaSentimentAnalysis,
      errors: {} as "Usage limit exceeded",
    },
    user_search_summary: {
      /** Updates a search with the generated summary. */
      path: '/api/external/bigdipper/amygdala-user-search-summary/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAmygdalaUserSearchSummaryInput
      },
      responseType: {} as StandaloneAmygdalaUserSearchSummary,
      errors: {} as "Usage limit exceeded",
    },
    user_session_searches: {
      /** Get all searches for a given session_id, ordered by recency (latest first). */
      path: '/api/external/bigdipper/amygdala-user-session-searches/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUserSessionSearchesQuery
      },
      responseType: {} as StandaloneAmygdalaUserSessionSearches[],
      errors: {} as "Usage limit exceeded",
    },
    user_sessions: {
      /** Get all sessions for a user/email, ordered by recency (latest first). */
      path: '/api/external/bigdipper/amygdala-user-sessions/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUserSessionsQuery
      },
      responseType: {} as StandaloneAmygdalaUserSessions[],
      errors: {} as "Either parameter 'email' or logged in user is required"|"Usage limit exceeded",
    },
    analyze_prompt: {
      /** Analyze a given prompt and return the analyzed keywords */
      path: '/api/external/bigdipper/analyze-query/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAnalyzePromptQuery
      },
      responseType: {} as StandaloneAnalyzeQuery,
      errors: {} as "Usage limit exceeded",
    },
    audience_insights: {
      /** Audience insights for bigdipper. */
      path: '/api/external/bigdipper/audience-insights/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAudienceInsightsQuery
      },
      responseType: {} as StandaloneAudienceInsights,
      errors: {} as "Usage limit exceeded",
    },
    campaign_overview: {
      /** Get campaign overview stats across connected social ad accounts.
      Uses the user's own OAuth tokens to fetch data on-the-fly from the platform APIs.
      Only includes ad accounts the team has selected (or all if none selected yet).
      Query params:
        - platform: optional, filter to a specific platform ('twitter', 'facebook', 'instagram')
        - ad_account_id: optional, filter to a specific ad account within the platform
        - date_range: optional, '7d' (default), '14d', or '30d' */
      path: '/api/external/bigdipper/campaign-overview/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    cancel_scheduled_post: {
      /** Cancel a scheduled post. Removes the scheduled post from each platform
      and resets the post status to draft.
      Request body:
          post_id: int - ID of the scheduled post to cancel */
      path: '/api/external/bigdipper/cancel-scheduled-post/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput2
      },
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    send_careers_email: {
      /** Careers email for bigdipper. */
      path: '/api/external/bigdipper/careers-email/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput2
      },
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    connected_platforms: {
      /** Get all connected social media platforms with their pages/accounts.
      Used for the post preview/publish screen to show available channels. */
      path: '/api/external/bigdipper/connected-platforms/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    countries: {
      /** Countries for bigdipper. */
      path: '/api/external/bigdipper/countries/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AudienceRegion[],
      errors: {} as "Usage limit exceeded",
    },
    create_magic_login_link: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/create-magic-login-link/',
      method: 'GET',
      paramsType: {} as {
        query?: GetCreateMagicLoginLinkQuery
      },
      responseType: {} as StandaloneCreateMagicLoginLink,
      errors: {} as "Usage limit exceeded",
    },
    get_facebook_account: {
      /** Get connected Facebook account info for the authenticated user. */
      path: '/api/external/bigdipper/facebook-account/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    facebook_auth_params: {
      /** Get Facebook OAuth2 parameters for the authorization flow.
      Frontend calls this first to get the auth URL parameters. */
      path: '/api/external/bigdipper/facebook-auth-params/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as {},
    },
    facebook_connect: {
      /** Connect Facebook account to authenticated user.
      Receives authorization code and exchanges it for tokens. */
      path: '/api/external/bigdipper/facebook-connect/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput2
      },
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    disconnect_facebook: {
      /** Disconnect Facebook account from the authenticated user. */
      path: '/api/external/bigdipper/facebook-disconnect/',
      method: 'DELETE',
      paramsType: {} as {},
      responseType: {} as {},
      errors: {} as "Usage limit exceeded",
    },
    facebook_images: {
      /** Fetch images from the connected Facebook pages and save them to the team.
      Query params:
          max_results: Maximum posts to fetch per page (default 10, max 100)
          page_id: Optional - specific Facebook page ID to fetch from */
      path: '/api/external/bigdipper/facebook-images/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    facebook_pages: {
      path: '/api/external/bigdipper/facebook-pages/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    facebook_pages_post: {
      path: '/api/external/bigdipper/facebook-pages/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput2
      },
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    feedback: {
      /** Feedback for bigdipper. */
      path: '/api/external/bigdipper/feedback/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput2
      },
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    fetch_grokathon_ids: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/fetch-grokathon-ids/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFetchGrokathonIdsQuery
      },
      responseType: {} as StandaloneFetchGrokathonIds,
      errors: {} as "Usage limit exceeded",
    },
    fetch_ids_handles_topics_grokathon: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/fetch-ids-handles-topics/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFetchIdsHandlesTopicsGrokathonQuery
      },
      responseType: {} as StandaloneFetchIdsHandlesTopicsGrokathon,
      errors: {} as "Usage limit exceeded",
    },
    fetch_size_grokathon_ids: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/fetch-size-grokathon-ids/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFetchSizeGrokathonIdsQuery
      },
      responseType: {} as StandaloneFetchSizeGrokathonIds,
      errors: {} as "Usage limit exceeded",
    },
    fetch_topics_and_ranks_ids_grokathon: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/fetch-topics-and-ranks-ids/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFetchTopicsAndRanksIdsGrokathonQuery
      },
      responseType: {} as StandaloneFetchTopicsAndRanksIdsGrokathon,
      errors: {} as "Usage limit exceeded",
    },
    fetch_topics_grokathon: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/fetch-topics-grokathon/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFetchTopicsGrokathon,
      errors: {} as "Usage limit exceeded",
    },
    fetch_topics_ranks_handle_grokathon: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/fetch-topics-ranks-handle/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFetchTopicsRanksHandleGrokathonQuery
      },
      responseType: {} as StandaloneFetchTopicsRanksHandleGrokathon,
      errors: {} as "Usage limit exceeded",
    },
    get_instagram_account: {
      /** Get connected Instagram account info for the authenticated user. */
      path: '/api/external/bigdipper/instagram-account/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    instagram_auth_params: {
      /** Get Instagram OAuth parameters for initiating the OAuth flow.
      Instagram uses Facebook's OAuth with Instagram-specific scopes. */
      path: '/api/external/bigdipper/instagram-auth-params/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    instagram_connect: {
      /** Connect Instagram account to authenticated user.
      Receives authorization code and exchanges it for tokens. */
      path: '/api/external/bigdipper/instagram-connect/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput2
      },
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    disconnect_instagram: {
      /** Disconnect Instagram account from the authenticated user. */
      path: '/api/external/bigdipper/instagram-disconnect/',
      method: 'DELETE',
      paramsType: {} as {},
      responseType: {} as {},
      errors: {} as "Usage limit exceeded",
    },
    instagram_images: {
      /** Fetch images from the connected Instagram account(s) and save them to the team.
      Query params:
          max_results: Maximum posts to fetch per account (default 50, max 100)
          instagram_id: Optional - specific Instagram account ID to fetch from */
      path: '/api/external/bigdipper/instagram-images/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    instagram_pages: {
      path: '/api/external/bigdipper/instagram-pages/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    instagram_pages_post: {
      path: '/api/external/bigdipper/instagram-pages/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput2
      },
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    keywords_hashtags: {
      /** Audience insights for bigdipper. */
      path: '/api/external/bigdipper/keywords-hashtags/',
      method: 'GET',
      paramsType: {} as {
        query?: GetKeywordsHashtagsQuery
      },
      responseType: {} as StandAloneKeywordsHashtags,
      errors: {} as "Usage limit exceeded",
    },
    me: {
      /** Retreive the personal data of the logged in user. */
      path: '/api/external/bigdipper/me/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneUser,
      errors: {} as "Usage limit exceeded",
    },
    get_meta_ad_accounts: {
      /** Get user's Meta ad accounts for dark post publishing.
      Works for both Facebook and Instagram dark posts.
      Returns ad accounts the user has access to via the Marketing API. */
      path: '/api/external/bigdipper/meta-ad-accounts/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneFeedback2,
      errors: {} as "Usage limit exceeded",
    },
    publish_post: {
      /** Publish or schedule a saved post to selected social media platforms.
      When scheduled_at is provided, the post is scheduled for future publication
      using native platform APIs (Facebook and Twitter only, organic posts only).
      When omitted, the post is published immediately.
      Request body:
          post_id: int - ID of the saved post to publish
          publish_type: string - "organic" or "dark"
          scheduled_at: string (optional) - ISO 8601 datetime for scheduled publishing
          platforms: list - Platform configurations
              [
                    { "platform": "twitter", "enabled": true },
                    { "platform": "facebook", "enabled": true, "page_id": "123" },
                    { "platform": "instagram", "enabled": true, "page_id": "456" }
                ] */
        path: '/api/external/bigdipper/publish-post/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneFeedbackInput2
        },
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      reddit_comments: {
        /** Fetch Reddit comments from specified subreddits. */
        path: '/api/external/bigdipper/reddit-comments/',
        method: 'GET',
        paramsType: {} as {
          query?: GetRedditCommentsQuery
        },
        responseType: {} as StandaloneRedditComments,
        errors: {} as "Usage limit exceeded",
      },
      regenerate_post_image: {
        /** Regenerate a single image with a new prompt.
        Request body:
            image_prompt: string - The prompt to use for image generation
            reference_image_urls: string[] (optional) - URLs of images to use as style references */
        path: '/api/external/bigdipper/regenerate-post-image/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneFeedbackInput2
        },
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      saved_post_detail: {
        /** Get or update a single saved post. */
        path: '/api/external/bigdipper/saved-post/{post_id}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            post_id: string|number
          }
        },
        responseType: {} as SavedPost,
        errors: {} as "Usage limit exceeded",
      },
      saved_post_detail_patch: {
        /** Get or update a single saved post. */
        path: '/api/external/bigdipper/saved-post/{post_id}/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<SavedPostInput>
          path: {
            post_id: string|number
          }
        },
        responseType: {} as SavedPost,
        errors: {} as "Usage limit exceeded",
      },
      saved_posts: {
        /** List or create saved posts. */
        path: '/api/external/bigdipper/saved-posts/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as SavedPost,
        errors: {} as "Usage limit exceeded",
      },
      saved_posts_post: {
        /** List or create saved posts. */
        path: '/api/external/bigdipper/saved-posts/',
        method: 'POST',
        paramsType: {} as {
          body: SavedPostInput
        },
        responseType: {} as SavedPost,
        errors: {} as "Usage limit exceeded",
      },
      saved_post_delete: {
        /** Delete a saved post. */
        path: '/api/external/bigdipper/saved-posts/{post_id}/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            post_id: string|number
          }
        },
        responseType: {} as {},
        errors: {} as "Usage limit exceeded",
      },
      scheduled_posts: {
        /** List all scheduled posts for the current user's team.
        Returns posts ordered by scheduled_at ascending (next post first). */
        path: '/api/external/bigdipper/scheduled-posts/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      ad_suggestion_prompts_by_search: {
        /** Retreive the ad suggestions from the user and filter by search_id. */
        path: '/api/external/bigdipper/search-ad-suggestion-prompts/',
        method: 'GET',
        paramsType: {} as {
          query?: GetAdSuggestionPromptsBySearchQuery
        },
        responseType: {} as BigDipperAdSuggestionPrompt[],
        errors: {} as "Usage limit exceeded",
      },
      selected_ad_accounts: {
        path: '/api/external/bigdipper/selected-ad-accounts/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      selected_ad_accounts_post: {
        path: '/api/external/bigdipper/selected-ad-accounts/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneFeedbackInput2
        },
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      social_accounts_content: {
        /** Platform content for bigdipper. */
        path: '/api/external/bigdipper/social-accounts-content/',
        method: 'GET',
        paramsType: {} as {
          query?: GetSocialAccountsContentQuery
        },
        responseType: {} as StandaloneSocialAccountsContent,
        errors: {} as "Usage limit exceeded",
      },
      social_accounts_per_platform: {
        /** Social accounts per platform for bigdipper. */
        path: '/api/external/bigdipper/social-accounts-per-platform/',
        method: 'GET',
        paramsType: {} as {
          query?: GetSocialAccountsPerPlatformQuery
        },
        responseType: {} as StandalonePlatformAccountsPerPlatform,
        errors: {} as "Usage limit exceeded",
      },
      social_accounts: {
        /** Social accounts for bigdipper.
        Sending no keywords & countries returns a cached response of the top 100 accounts globally across all topics. */
        path: '/api/external/bigdipper/social-accounts/',
        method: 'GET',
        paramsType: {} as {
          query?: GetSocialAccountsQuery
        },
        responseType: {} as StandaloneSocialAccounts,
        errors: {} as "No accounts found"|"Usage limit exceeded",
      },
      targeting_pack_discord: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/targeting-pack-discord/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTargetingPackDiscordQuery
        },
        responseType: {} as StandaloneDiscordTargetingPack,
        errors: {} as "Usage limit exceeded",
      },
      targeting_pack_reddit: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/targeting-pack-reddit/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTargetingPackRedditQuery
        },
        responseType: {} as StandaloneRedditTargetingPack,
        errors: {} as "Usage limit exceeded",
      },
      targeting_pack_seo: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/targeting-pack-seo/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTargetingPackSeoQuery
        },
        responseType: {} as StandaloneSeoTargetingPack,
        errors: {} as "Usage limit exceeded",
      },
      targeting_pack_spotify: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/targeting-pack-spotify/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTargetingPackSpotifyQuery
        },
        responseType: {} as StandaloneSpotifyTargetingPack,
        errors: {} as "Usage limit exceeded",
      },
      targeting_pack_tiktok: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/targeting-pack-tiktok/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTargetingPackTiktokQuery
        },
        responseType: {} as StandaloneTiktokTargetingPack,
        errors: {} as "Usage limit exceeded",
      },
      targeting_pack_twitch: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/targeting-pack-twitch/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTargetingPackTwitchQuery
        },
        responseType: {} as StandaloneTwitchTargetingPack,
        errors: {} as "Usage limit exceeded",
      },
      targeting_pack_x: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/targeting-pack-x/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTargetingPackXQuery
        },
        responseType: {} as StandaloneXTargetingPack,
        errors: {} as "Usage limit exceeded",
      },
      targeting_pack_youtube: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/targeting-pack-youtube/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTargetingPackYoutubeQuery
        },
        responseType: {} as StandaloneYoutubeTargetingPack,
        errors: {} as "Usage limit exceeded",
      },
      team_images: {
        /** Get all images for the user's team.
        Query params:
            source: Filter by source (website, facebook, instagram, etc.)
            selected: Filter by selected status (true/false)
            include_disabled: Include disabled images (default false) */
        path: '/api/external/bigdipper/team-images/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      team_images_upload: {
        /** Upload images to the team's content wall.
        Accepts multipart/form-data with one or more image files.
        POST body (multipart/form-data):
            images: File or list of files - The image(s) to upload
            alt: string (optional) - Alt text for the image(s) */
        path: '/api/external/bigdipper/team-images/upload/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneFeedbackInput2
        },
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      team_image_update: {
        /** Update a team image (toggle selected/disabled).
        Body params:
            selected: boolean (optional)
            disabled: boolean (optional) */
        path: '/api/external/bigdipper/team-images/{pk}/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<StandaloneFeedbackInput2>
          path: {
            pk: string|number
          }
        },
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      team_settings: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/team-settings/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as BigDipperTeam,
        errors: {} as "Usage limit exceeded",
      },
      team_settings_patch: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/team-settings/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<BigDipperTeamInput>
        },
        responseType: {} as BigDipperTeam,
        errors: {} as "Usage limit exceeded",
      },
      get_twitter_account: {
        /** Get connected Twitter account info for the authenticated user.
        Returns connection status and account details if connected. */
        path: '/api/external/bigdipper/twitter-account/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      get_twitter_ads_account: {
        /** Get connected Twitter Ads account info for the authenticated user.
        Returns connection status and available ad accounts.
        Queries Twitter API directly to get accurate list of accounts. */
        path: '/api/external/bigdipper/twitter-ads-account/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      twitter_ads_connect: {
        /** Complete OAuth 1.0a flow for Twitter Ads API.
        Exchanges oauth_token and oauth_verifier for access token.
        Creates SocialAccount and SocialToken, then syncs ad accounts. */
        path: '/api/external/bigdipper/twitter-ads-connect/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneFeedbackInput2
        },
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      disconnect_twitter_ads: {
        /** Disconnect Twitter Ads account from the authenticated user.
        Removes the SocialAccount (provider="twitter") and associated tokens. */
        path: '/api/external/bigdipper/twitter-ads-disconnect/',
        method: 'DELETE',
        paramsType: {} as {},
        responseType: {} as {},
        errors: {} as "Usage limit exceeded",
      },
      twitter_ads_request_token: {
        /** Get OAuth 1.0a request token for Twitter Ads API connection.
        This is step 1 of the OAuth 1.0a flow for connecting ad accounts.
        Returns oauth_token to construct the Twitter authorization URL. */
        path: '/api/external/bigdipper/twitter-ads-request-token/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      twitter_code_challenge: {
        /** Generate PKCE code challenge for Twitter OAuth2 flow.
        Frontend calls this first to get the challenge parameters.
        Used for connecting Twitter account (not login). */
        path: '/api/external/bigdipper/twitter-code-challenge/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as {},
      },
      twitter_connect: {
        /** Connect Twitter account to authenticated user.
        Receives authorization code and exchanges it for tokens.
        Stores tokens in SocialAccount/SocialToken for future use. */
        path: '/api/external/bigdipper/twitter-connect/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneFeedbackInput2
        },
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      disconnect_twitter: {
        /** Disconnect Twitter account from the authenticated user.
        Removes the SocialAccount and associated tokens. */
        path: '/api/external/bigdipper/twitter-disconnect/',
        method: 'DELETE',
        paramsType: {} as {},
        responseType: {} as {},
        errors: {} as "Usage limit exceeded",
      },
      use_magic_login_link: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/use-magic-login-link/',
        method: 'GET',
        paramsType: {} as {
          query?: GetUseMagicLoginLinkQuery
        },
        responseType: {} as UseMagicLoginLink,
        errors: {} as "Usage limit exceeded",
      },
      user_search_history: {
        /** Retrieve the user's search history from BigDipperSearch objects. */
        path: '/api/external/bigdipper/user-search-history/',
        method: 'GET',
        paramsType: {} as {
          query?: GetUserSearchHistoryQuery
        },
        responseType: {} as StandaloneUserSearchHistory[],
        errors: {} as "Usage limit exceeded",
      },
      wall_post_suggestion: {
        /** Generate post suggestions from the content wall with optional reference images.
        This endpoint generates 3 post suggestions with images synchronously.
        Unlike the regular ad-suggestion endpoint, images are generated immediately.
        Request body:
            prompt: string - The user's prompt describing what kind of posts they want
            reference_image_urls: string[] (optional) - URLs of images to use as style references
            url: string (optional) - URL to extract brand/site context from */
        path: '/api/external/bigdipper/wall-post-suggestion/',
        method: 'POST',
        paramsType: {} as {
          body: WallPostSuggestionInput
        },
        responseType: {} as WallPostSuggestion,
        errors: {} as "Usage limit exceeded",
      },
      website_images: {
        /** Scrape images from a website and save them to the team.
        Query params:
            url: The URL to scrape (optional, falls back to team website)
            max_images: Maximum images to return (default 20)
            max_pages: Maximum pages to crawl (default 5, set to 1 for single page only) */
        path: '/api/external/bigdipper/website-images/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      website_urls: {
        /** Discover internal URLs from a website.
        Query params:
            url: The URL to discover from (optional, falls back to team website)
            max_urls: Maximum URLs to return (default 10) */
        path: '/api/external/bigdipper/website-urls/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      x_images: {
        /** Fetch images from the connected X/Twitter account and save them to the team.
        Query params:
            max_results: Maximum tweets to fetch (default 50, max 100) */
        path: '/api/external/bigdipper/x-images/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneFeedback2,
        errors: {} as "Usage limit exceeded",
      },
      youtube_videos: {
        /** Fetch YouTube videos from specified channel IDs. */
        path: '/api/external/bigdipper/youtube-videos/',
        method: 'GET',
        paramsType: {} as {
          query?: GetYoutubeVideosQuery
        },
        responseType: {} as StandaloneYoutubeVideos,
        errors: {} as "Usage limit exceeded",
      },
      ad_suggestion_result: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/{pk}/ad-suggestion-result/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as {},
        errors: {} as "Ad suggestion prompt not owned by user"|"Usage limit exceeded",
      },
      ad_suggestion_result_patch: {
        /** endpoints for socialdatabase.com */
        path: '/api/external/bigdipper/{pk}/ad-suggestion-result/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<BigDipperAdSuggestionResultInput>
          path: {
            pk: string|number
          }
        },
        responseType: {} as BigDipperAdSuggestionResult,
        errors: {} as "Ad suggestion prompt not owned by user"|"Usage limit exceeded",
      },
      delete_ad_suggestion_prompt: {
        /** Delete the ad suggestion prompt and related results */
        path: '/api/external/bigdipper/{pk}/ad-suggestions-prompt/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as {},
        errors: {} as "Ad suggestion prompt not owned by user"|"Usage limit exceeded",
      },
      delete_search_history: {
        /** Delete the user's search history from BigDipperSearch objects. */
        path: '/api/external/bigdipper/{pk}/user-search-history/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as {},
        errors: {} as "Usage limit exceeded",
      },
    },
    StandaloneCampaignCalculator: {
      create: {
        /** Standalone campaign calculator */
        path: '/api/external/campaign-calculator/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneCampaignCalculatorInput
        },
        responseType: {} as StandaloneCampaignCalculator,
        errors: {} as {},
      },
    },
    StandaloneCampaignCreate: {
      create: {
        path: '/api/external/campaign-create/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneCampaignCreateInput
        },
        responseType: {} as StandaloneCampaignCreate,
        errors: {} as {},
      },
      extract_parameters: {
        path: '/api/external/campaign-create/extract-parameters/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneCampaignExtractParametersInput
        },
        responseType: {} as StandaloneCampaignExtractParameters,
        errors: {} as {},
      },
    },
    StandAloneCampaignOption: {
      list: {
        path: '/api/external/campaign-options/',
        method: 'GET',
        paramsType: {} as {
          query?: GetStandAloneCampaignOptionListQuery
        },
        responseType: {} as StandAloneCampaignOption[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/external/campaign-options/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetStandAloneCampaignOptionInstanceQuery
        },
        responseType: {} as StandAloneCampaignOption,
        errors: {} as {},
      },
    },
    StandaloneCheckAgencyAdAccount: {
      list: {
        path: '/api/external/check-agency-ad-account/',
        method: 'GET',
        paramsType: {} as {
          query?: GetStandaloneCheckAgencyAdAccountListQuery
        },
        responseType: {} as StandaloneCheckAgencyAdAccount[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/external/check-agency-ad-account/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetStandaloneCheckAgencyAdAccountInstanceQuery
        },
        responseType: {} as StandaloneCheckAgencyAdAccount,
        errors: {} as {},
      },
    },
    StandaloneCheckCustomAudiences: {
      create: {
        path: '/api/external/check-custom-audiences/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneCheckCustomAudiencesInput
        },
        responseType: {} as StandaloneCheckCustomAudiences,
        errors: {} as {},
      },
    },
    StandAloneCompetitorAnalysis: {
      create: {
        /** Standalone get competitor analysis of handles */
        path: '/api/external/competitor-analysis/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneCompetitorAnalysisInput
        },
        responseType: {} as StandAloneCompetitorAnalysis,
        errors: {} as {},
      },
      account_topics: {
        /** Standalone topics for accounts for xprotargeting.com */
        path: '/api/external/competitor-analysis/account-topics/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneAccountTopicsInput
        },
        responseType: {} as StandaloneAccountTopics,
        errors: {} as {},
      },
      suggest_competitors: {
        /** Standalone suggest competitors for account for xprotargeting.com */
        path: '/api/external/competitor-analysis/suggest-competitors/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneCompetitorAnalysisSuggestCompetitorsInput
        },
        responseType: {} as StandaloneCompetitorAnalysisSuggestCompetitors,
        errors: {} as {},
      },
    },
    StandAloneComputeAgeGroups: {
      create: {
        /** Standalone get age groups of accounts */
        path: '/api/external/compute-age-groups/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneComputeAgeGroupsInput
        },
        responseType: {} as StandAloneComputeAgeGroups,
        errors: {} as "The request could not be processed, please try again later.",
      },
    },
    StandaloneConfigGenerateExploreInsights: {
      create: {
        /** Standalone create Explore Insights for Audience Configs */
        path: '/api/external/config-explore-insights/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneConfigGenerateExploreInsightsInput
        },
        responseType: {} as StandaloneConfigGenerateExploreInsights,
        errors: {} as {},
      },
    },
    StandaloneConversationTopics: {
      list: {
        path: '/api/external/conversation-topics/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneConversationTopic[],
        errors: {} as {},
      },
      search: {
        path: '/api/external/conversation-topics/search/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneSearchConversationTopicsInput
        },
        responseType: {} as StandaloneSearchConversationTopics,
        errors: {} as {},
      },
    },
    StandAloneCreateExclusionAudience: {
      create: {
        path: '/api/external/create-exclusion-audience/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneCreateExclusionAudienceInput
        },
        responseType: {} as StandAloneCreateExclusionAudience,
        errors: {} as {},
      },
    },
    DeepThoughtToken: {
      analyse_spam: {
        /** analyse handle endpoint for xdeepthought extension */
        path: '/api/external/deepthought-token/analyse-spam/',
        method: 'GET',
        paramsType: {} as {
          query?: GetAnalyseSpamQuery
        },
        responseType: {} as DeepThoughtAnalyseSpam,
        errors: {} as {},
      },
      extract_account_ranks: {
        /** extract ranks endpoint for xdeepthought extension */
        path: '/api/external/deepthought-token/extract-ranks/',
        method: 'GET',
        paramsType: {} as {
          query?: GetExtractAccountRanksQuery
        },
        responseType: {} as DeepThoughtExtractAccountRanks,
        errors: {} as {},
      },
      followers_token: {
        /** followers endpoint for xdeepthought extension */
        path: '/api/external/deepthought-token/followers-token/',
        method: 'GET',
        paramsType: {} as {
          query?: GetFollowersTokenQuery
        },
        responseType: {} as {
          count: number
          next: string
          previous: string
          results: DeepThoughtAccount[]
        },
        errors: {} as {},
      },
      following_token: {
        /** following endpoint for xdeepthought extension */
        path: '/api/external/deepthought-token/following-token/',
        method: 'GET',
        paramsType: {} as {
          query?: GetFollowingTokenQuery
        },
        responseType: {} as {
          count: number
          next: string
          previous: string
          results: DeepThoughtAccount[]
        },
        errors: {} as {},
      },
      predict_payout_based_on_engagements_token: {
        /** get prediction based on engagements for xdeepthought extension */
        path: '/api/external/deepthought-token/predict-payout-based-on-engagements-token/',
        method: 'GET',
        paramsType: {} as {
          query?: GetPredictPayoutBasedOnEngagementsTokenQuery
        },
        responseType: {} as DeepThoughtPredictPayoutBasedOnEngagements,
        errors: {} as {},
      },
      unfollowers_token: {
        /** recent unfollowers endpoint for xdeepthought extension */
        path: '/api/external/deepthought-token/unfollowers-token/',
        method: 'GET',
        paramsType: {} as {
          query?: GetUnfollowersTokenQuery
        },
        responseType: {} as DeepThoughtFollowerOverlap,
        errors: {} as {},
      },
      verified_followers: {
        /** verified-followers endpoint for xdeepthought.com */
        path: '/api/external/deepthought-token/verified-followers/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtVerifiedFollowersInput
        },
        responseType: {} as DeepThoughtVerifiedFollowers,
        errors: {} as {},
      },
      who_to_follow: {
        /** who-to-follow endpoint for xdeepthought extension */
        path: '/api/external/deepthought-token/who-to-follow/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtWhoToFollowInput
        },
        responseType: {} as DeepThoughtWhoToFollow,
        errors: {} as {},
      },
    },
    DeepThought: {
      account_stats: {
        /** accounts-stats endpoint for xdeepthought.com */
        path: '/api/external/deepthought/accounts-stats/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtAccountStats,
        errors: {} as {},
      },
      add_members_to_list: {
        /** Add members to a list */
        path: '/api/external/deepthought/add-members-to-list/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtListMemberInput
        },
        responseType: {} as DeepThoughtListMember,
        errors: {} as {},
      },
      analyse_spam: {
        /** analyse handle endpoint for xdeepthought extension */
        path: '/api/external/deepthought/analyse-spam/',
        method: 'GET',
        paramsType: {} as {
          query?: GetAnalyseSpamQuery
        },
        responseType: {} as DeepThoughtAnalyseSpam,
        errors: {} as {},
      },
      best_post_time: {
        /** endpoints for xdeepthought.com */
        path: '/api/external/deepthought/best-post-time/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtBestPostTimeInput
        },
        responseType: {} as DeepThoughtBestPostTime,
        errors: {} as {},
      },
      cancel_subscription: {
        /** Cancels the user's Stripe subscription */
        path: '/api/external/deepthought/cancel-subscription/',
        method: 'POST',
        paramsType: {} as {
          body: SubscriptionCancelInput
        },
        responseType: {} as SubscriptionCancel,
        errors: {} as {},
      },
      create_list: {
        /** Create a new list for the user */
        path: '/api/external/deepthought/create-list/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtListInput
        },
        responseType: {} as DeepThoughtList,
        errors: {} as "Failed to create list.",
      },
      create_referral: {
        /** Create a referral between two users */
        path: '/api/external/deepthought/create-referral/',
        method: 'POST',
        paramsType: {} as {
          body: ReferralCreateInput
        },
        responseType: {} as ReferralCreate,
        errors: {} as {},
      },
      create_subscription: {
        /** Creates a Stripe checkout session for subscription */
        path: '/api/external/deepthought/create-subscription/',
        method: 'POST',
        paramsType: {} as {
          body: SubscriptionCreateInput
        },
        responseType: {} as SubscriptionCreate,
        errors: {} as {},
      },
      engagers: {
        /** enagers endpoint for xdeepthought.com */
        path: '/api/external/deepthought/engagers/',
        method: 'GET',
        paramsType: {} as {
          query?: GetEngagersQuery
        },
        responseType: {} as DeepThoughtEngagers,
        errors: {} as {},
      },
      enrichment_accounts: {
        /** enrichment accounts endpoint for xdeepthought.com */
        path: '/api/external/deepthought/enrichment-accounts/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtEnrichmentAccountsInput
        },
        responseType: {} as DeepThoughtEnrichmentAccounts,
        errors: {} as {},
      },
      enrichment_followers: {
        /** enrichment of my followers endpoint for xdeepthought.com */
        path: '/api/external/deepthought/enrichment-followers/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtEnrichedAccountMany,
        errors: {} as {},
      },
      enrichments: {
        /** enrichments endpoint for xdeepthought.com */
        path: '/api/external/deepthought/enrichments/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtEnrichmentsInput
        },
        responseType: {} as DeepThoughtEnrichments,
        errors: {} as {},
      },
      extract_account_ranks: {
        /** extract ranks endpoint for xdeepthought extension */
        path: '/api/external/deepthought/extract-ranks/',
        method: 'GET',
        paramsType: {} as {
          query?: GetExtractAccountRanksQuery
        },
        responseType: {} as DeepThoughtExtractAccountRanks,
        errors: {} as {},
      },
      fetch_interests: {
        /** endpoints for xdeepthought.com */
        path: '/api/external/deepthought/fetch-interests/',
        method: 'GET',
        paramsType: {} as {
          query?: GetFetchInterestsQuery
        },
        responseType: {} as DeepThoughtFetchInterests,
        errors: {} as {},
      },
      fetch_timeline: {
        /** Fetch timeline endpoint for xdeepthought extension */
        path: '/api/external/deepthought/fetch-timeline/',
        method: 'GET',
        paramsType: {} as {
          query?: GetFetchTimelineQuery
        },
        responseType: {} as DeepThoughtFetchTimeline,
        errors: {} as {},
      },
      follow_account: {
        /** follow account endpoint for xdeepthought.com */
        path: '/api/external/deepthought/follow-account/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtFollowAccountInput
        },
        responseType: {} as DeepThoughtFollowAccount,
        errors: {} as {},
      },
      follower_intersection: {
        /** follower-intersection endpoint for xdeepthought.com */
        path: '/api/external/deepthought/follower-intersection/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtFollowerIntersectionInput
        },
        responseType: {} as DeepThoughtFollowerIntersection,
        errors: {} as {},
      },
      follower_overlap: {
        /** follower-overlap endpoint for xdeepthought.com */
        path: '/api/external/deepthought/follower-overlap/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtFollowerOverlap,
        errors: {} as {},
      },
      followers_bot_percentage: {
        /** followers bot percentage for xdeepthought.com */
        path: '/api/external/deepthought/followers-bot-percentage/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtBotPercentageInput
        },
        responseType: {} as DeepThoughtBotPercentage,
        errors: {} as {},
      },
      followers: {
        /** followers endpoint for xdeepthought.com */
        path: '/api/external/deepthought/followers/',
        method: 'GET',
        paramsType: {} as {
          query?: GetFollowersQuery
        },
        responseType: {} as {
          count: number
          next: string
          previous: string
          results: DeepThoughtAccount[]
        },
        errors: {} as {},
      },
      following: {
        /** following endpoint for xdeepthought.com */
        path: '/api/external/deepthought/following/',
        method: 'GET',
        paramsType: {} as {
          query?: GetFollowingQuery
        },
        responseType: {} as {
          count: number
          next: string
          previous: string
          results: DeepThoughtAccount[]
        },
        errors: {} as {},
      },
      lists: {
        /** Lists ther user's lists */
        path: '/api/external/deepthought/lists/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtList[],
        errors: {} as {},
      },
      me: {
        /** me endpoint for xdeepthought.com */
        path: '/api/external/deepthought/me/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtAccount,
        errors: {} as {},
      },
      payout_actual: {
        /** payout-actual endpoint for xdeepthought.com */
        path: '/api/external/deepthought/payout-actual/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtPayoutActualInput
        },
        responseType: {} as DeepThoughtPayoutActual,
        errors: {} as {},
      },
      payout_predictor: {
        /** payout-predictor endpoint for xdeepthought.com */
        path: '/api/external/deepthought/payout-predictor/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtPayoutPredictor,
        errors: {} as {},
      },
      get_posts_account: {
        /** endpoints for xdeepthought.com */
        path: '/api/external/deepthought/posts-account/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtPostsAccountInput
        },
        responseType: {} as DeepThoughtPostsAccount,
        errors: {} as {},
      },
      posts_and_likes: {
        /** posts-and-likes endpoint for xdeepthought.com */
        path: '/api/external/deepthought/posts-and-likes/',
        method: 'GET',
        paramsType: {} as {
          query?: GetPostsAndLikesQuery
        },
        responseType: {} as DeepThoughtPostsAndLikes,
        errors: {} as {},
      },
      predict_payout_based_on_engagements: {
        /** get prediction based on engagements for xdeepthought.com */
        path: '/api/external/deepthought/predict-payout-based-on-engagements/',
        method: 'GET',
        paramsType: {} as {
          query?: GetPredictPayoutBasedOnEngagementsQuery
        },
        responseType: {} as DeepThoughtPredictPayoutBasedOnEngagements,
        errors: {} as {},
      },
      predict_post_performance: {
        /** endpoints for xdeepthought.com */
        path: '/api/external/deepthought/predict-post-performance/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtPredictPostPerformanceInput
        },
        responseType: {} as DeepThoughtPredictPostPerformance,
        errors: {} as {},
      },
      recently_joined: {
        /** recently joined account check for xdeepthought.com */
        path: '/api/external/deepthought/recently-joined/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtAccountRecentlyJoined,
        errors: {} as {},
      },
      remove_members_from_list: {
        /** Remove members from a list */
        path: '/api/external/deepthought/remove-members-from-list/',
        method: 'DELETE',
        paramsType: {} as {},
        responseType: {} as {},
        errors: {} as "Failed to delete member(s) from list.",
      },
      search_notifications: {
        /** analyse handle endpoint for xdeepthought extension */
        path: '/api/external/deepthought/search-notifications/',
        method: 'GET',
        paramsType: {} as {
          query?: GetSearchNotificationsQuery
        },
        responseType: {} as DeepThoughtSearchNotifications,
        errors: {} as {},
      },
      user_subscription: {
        /** Retrieve or update the user's subscription info */
        path: '/api/external/deepthought/subscription-info/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as UserSubscription,
        errors: {} as {},
      },
      user_subscription_patch: {
        /** Retrieve or update the user's subscription info */
        path: '/api/external/deepthought/subscription-info/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<UserSubscriptionInput>
        },
        responseType: {} as UserSubscription,
        errors: {} as {},
      },
      talk_to_x_questions: {
        /** Get summary and follow up questions for Talk to X */
        path: '/api/external/deepthought/talk-to-x-questions/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtQuestions,
        errors: {} as {},
      },
      talk_to_x: {
        /** Talk to X endpoint for xdeepthought.com, logic in serializer */
        path: '/api/external/deepthought/talk-to-x/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtTalkToXInput
        },
        responseType: {} as DeepThoughtTalkToX,
        errors: {} as {},
      },
      top_countries: {
        /** top-countries endpoint for xdeepthought.com */
        path: '/api/external/deepthought/top-countries/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtCountries,
        errors: {} as {},
      },
      unfollow_account_bulk: {
        /** unfollow account in bulk endpoint for xdeepthought.com */
        path: '/api/external/deepthought/unfollow-account-bulk/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtUnfollowAccountBulkInput
        },
        responseType: {} as DeepThoughtUnfollowAccountBulk,
        errors: {} as {},
      },
      unfollow_account: {
        /** unfollow account endpoint for xdeepthought.com */
        path: '/api/external/deepthought/unfollow-account/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtFollowAccountInput
        },
        responseType: {} as DeepThoughtFollowAccount,
        errors: {} as {},
      },
      unfollowers: {
        /** recent unfollowers endpoint for xdeepthought.com */
        path: '/api/external/deepthought/unfollowers/',
        method: 'GET',
        paramsType: {} as {
          query?: GetUnfollowersQuery
        },
        responseType: {} as DeepThoughtFollowerOverlap,
        errors: {} as {},
      },
      update_user: {
        /** extract ranks endpoint for xdeepthought extension */
        path: '/api/external/deepthought/update-user/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtInputHandleInput
        },
        responseType: {} as DeepThoughtInputHandle,
        errors: {} as {},
      },
      verified_followers: {
        /** verified-followers endpoint for xdeepthought.com */
        path: '/api/external/deepthought/verified-followers/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtVerifiedFollowersInput
        },
        responseType: {} as DeepThoughtVerifiedFollowers,
        errors: {} as {},
      },
      who_to_follow: {
        /** who-to-follow endpoint for xdeepthought.com */
        path: '/api/external/deepthought/who-to-follow/',
        method: 'POST',
        paramsType: {} as {
          body: DeepThoughtWhoToFollowInput
        },
        responseType: {} as DeepThoughtWhoToFollow,
        errors: {} as {},
      },
      x_stats_countries: {
        /** x-stats-countries endpoint for xdeepthought.com */
        path: '/api/external/deepthought/x-stats-countries/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtXStatsCountryActivity,
        errors: {} as {},
      },
      x_stats: {
        /** x-stats endpoint for xdeepthought.com */
        path: '/api/external/deepthought/x-stats/',
        method: 'GET',
        paramsType: {} as {
          query?: GetXStatsQuery
        },
        responseType: {} as DeepThoughtXStats,
        errors: {} as {},
      },
      delete_list: {
        /** Delete a list */
        path: '/api/external/deepthought/{pk}/delete-list/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as {},
        errors: {} as "Failed to delete list.",
      },
      list_members: {
        /** Lists list members */
        path: '/api/external/deepthought/{pk}/list-members/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as DeepThoughtAccount[],
        errors: {} as {},
      },
      post_engagements: {
        /** get post engagements endpoint for xdeepthought.com */
        path: '/api/external/deepthought/{pk}/post-engagements/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetPostEngagementsQuery
        },
        responseType: {} as DeepThoughtPostEngagement,
        errors: {} as {},
      },
      report: {
        /** report endpoint for xdeepthought.com */
        path: '/api/external/deepthought/{pk}/report/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as DeepThoughtReport,
        errors: {} as {},
      },
      update_list: {
        /** Update a list */
        path: '/api/external/deepthought/{pk}/update-list/',
        method: 'PUT',
        paramsType: {} as {
          body: DeepThoughtUpdateListInput
          path: {
            pk: string|number
          }
        },
        responseType: {} as DeepThoughtUpdateList,
        errors: {} as "Failed to update list.",
      },
    },
    StandaloneEvent: {
      list: {
        path: '/api/external/events/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as EventSocialdatabase[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/external/events/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as EventSocialdatabase,
        errors: {} as {},
      },
    },
    StandaloneExploreClusters: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-clusters/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneExploreClustersInput
        },
        responseType: {} as StandaloneExploreClusters,
        errors: {} as {},
      },
    },
    StandaloneCompareAccounts: {
      create: {
        path: '/api/external/explore-compare-accounts/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneCompareAccountsInput
        },
        responseType: {} as StandaloneCompareAccounts,
        errors: {} as {},
      },
    },
    StandAloneExploreExtractCreators: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-creators/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreExtractCreatorsInput
        },
        responseType: {} as StandAloneExploreExtractCreators,
        errors: {} as {},
      },
      classifier_children: {
        /** Standalone classifier children for insights */
        path: '/api/external/explore-creators/classifier-children/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneCreatorClassifierChildrenInput
        },
        responseType: {} as StandaloneCreatorClassifierChildren,
        errors: {} as {},
      },
    },
    StandAloneExploreDemographics: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-demographics/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreDemographicsInput
        },
        responseType: {} as StandAloneExploreDemographics,
        errors: {} as "The request could not be processed, please try again later.",
      },
    },
    StandaloneExploreEmailAdAccounts: {
      list: {
        path: '/api/external/explore-email-ad-accounts/',
        method: 'GET',
        paramsType: {} as {
          query?: GetStandaloneExploreEmailAdAccountsListQuery
        },
        responseType: {} as StandaloneExploreEmailAdAccounts[],
        errors: {} as {},
      },
      create: {
        path: '/api/external/explore-email-ad-accounts/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneExploreEmailAdAccountsInput
        },
        responseType: {} as StandaloneExploreEmailAdAccounts,
        errors: {} as {},
      },
      retrieve: {
        path: '/api/external/explore-email-ad-accounts/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetStandaloneExploreEmailAdAccountsInstanceQuery
        },
        responseType: {} as StandaloneExploreEmailAdAccounts,
        errors: {} as {},
      },
      partial_update: {
        path: '/api/external/explore-email-ad-accounts/{pk}/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<StandaloneExploreEmailAdAccountsInput>
          path: {
            pk: string|number
          }
          query?: PatchStandaloneExploreEmailAdAccountsInstanceQuery
        },
        responseType: {} as StandaloneExploreEmailAdAccounts,
        errors: {} as {},
      },
      update: {
        path: '/api/external/explore-email-ad-accounts/{pk}/',
        method: 'PUT',
        paramsType: {} as {
          body: StandaloneExploreEmailAdAccountsInput
          path: {
            pk: string|number
          }
          query?: PutStandaloneExploreEmailAdAccountsInstanceQuery
        },
        responseType: {} as StandaloneExploreEmailAdAccounts,
        errors: {} as {},
      },
    },
    StandAloneExploreEnrichments: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-enrichments/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreEnrichmentsInput
        },
        responseType: {} as StandAloneExploreEnrichments,
        errors: {} as "The request could not be processed, please try again later.",
      },
    },
    StandaloneExploreExtractDataHandles: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-extract-data-handles/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneExploreExtractDataHandlesInput
        },
        responseType: {} as StandaloneExploreExtractDataHandles,
        errors: {} as "No audience found"|"Unfortnately, we cannot process your request. We couldn't process the inputted handle(s), because it does not exist or it may be that the user is 'protected' on X.",
      },
    },
    StandaloneExploreExtractDataKeywords: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-extract-data-keywords/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneExploreExtractDataKeywordsInput
        },
        responseType: {} as StandaloneExploreExtractDataKeywords,
        errors: {} as {},
      },
    },
    StandaloneExploreExtractDataTweetKeywords: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-extract-data-tweet-keywords/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneExploreExtractDataTweetKeywordsInput
        },
        responseType: {} as StandaloneExploreExtractDataTweetKeywords,
        errors: {} as {},
      },
    },
    StandalonePostMetadataHandle: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-extract-post-metadata-handles/',
        method: 'POST',
        paramsType: {} as {
          body: StandalonePostMetadataHandleInput
        },
        responseType: {} as StandalonePostMetadataHandle,
        errors: {} as {},
      },
    },
    StandaloneFetchTimeline: {
      fetch_timeline: {
        /** Fetch timeline endpoint for xdeepthought extension */
        path: '/api/external/explore-fetch-timeline/fetch-timeline/',
        method: 'GET',
        paramsType: {} as {
          query?: GetFetchTimelineQuery
        },
        responseType: {} as DeepThoughtFetchTimeline,
        errors: {} as {},
      },
    },
    StandAloneExploreFollowerGrowth: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-follower-growth/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreFollowerGrowthInput
        },
        responseType: {} as StandAloneExploreFollowerGrowth,
        errors: {} as {},
      },
    },
    StandaloneExploreExtractPostDataHandles: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-post-data-handles/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneExploreExtractPostDataHandlesInput
        },
        responseType: {} as StandaloneExploreExtractPostDataHandles,
        errors: {} as {},
      },
    },
    StandAloneExplorePostsData: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-post-data/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExplorePostsDataInput
        },
        responseType: {} as StandAloneExplorePostsData,
        errors: {} as "The request could not be processed, please try again later.",
      },
    },
    StandaloneExploreSearch: {
      list: {
        path: '/api/external/explore-searches/',
        method: 'GET',
        paramsType: {} as {
          query?: GetStandaloneExploreSearchListQuery
        },
        responseType: {} as StandaloneExploreSearch[],
        errors: {} as {},
      },
      create: {
        path: '/api/external/explore-searches/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneExploreSearchInput
        },
        responseType: {} as StandaloneExploreSearch,
        errors: {} as {},
      },
      destroy: {
        path: '/api/external/explore-searches/{pk}/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: DeleteStandaloneExploreSearchInstanceQuery
        },
        responseType: {} as {},
        errors: {} as {},
      },
      retrieve: {
        path: '/api/external/explore-searches/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetStandaloneExploreSearchInstanceQuery
        },
        responseType: {} as StandaloneExploreSearch,
        errors: {} as {},
      },
      partial_update: {
        path: '/api/external/explore-searches/{pk}/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<StandaloneExploreSearchInput>
          path: {
            pk: string|number
          }
          query?: PatchStandaloneExploreSearchInstanceQuery
        },
        responseType: {} as StandaloneExploreSearch,
        errors: {} as {},
      },
      update: {
        path: '/api/external/explore-searches/{pk}/',
        method: 'PUT',
        paramsType: {} as {
          body: StandaloneExploreSearchInput
          path: {
            pk: string|number
          }
          query?: PutStandaloneExploreSearchInstanceQuery
        },
        responseType: {} as StandaloneExploreSearch,
        errors: {} as {},
      },
    },
    StandAloneExploreExtractSEOKeywords: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-seo-keywords/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreExtractSEOKeywordsInput
        },
        responseType: {} as StandAloneExploreExtractSEOKeywords,
        errors: {} as "The request could not be processed, please try again later.",
      },
    },
    StandaloneFindRelatedAudiencesClassifier: {
      create: {
        path: '/api/external/explore-similar-audiences-classifier/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneFindRelatedAudiencesClassifierInput
        },
        responseType: {} as StandaloneFindRelatedAudiencesClassifier,
        errors: {} as {},
      },
    },
    StandaloneFindRelatedAudiences: {
      create: {
        path: '/api/external/explore-similar-audiences/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneFindRelatedAudiencesInput
        },
        responseType: {} as StandaloneFindRelatedAudiences,
        errors: {} as "The request could not be processed, please try again later.",
      },
    },
    StandAloneExploreTopAccounts: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-top-accounts/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreTopAccountsInput
        },
        responseType: {} as StandAloneExploreTopAccounts,
        errors: {} as "The request could not be processed, please try again later.",
      },
    },
    StandAloneExploreTopFollowers: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-top-followers/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreTopFollowersInput
        },
        responseType: {} as StandAloneExploreTopFollowers,
        errors: {} as {},
      },
    },
    StandAloneExploreTopPosts: {
      create: {
        /** Standalone Explore endpoint */
        path: '/api/external/explore-top-posts/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreTopPostsInput
        },
        responseType: {} as StandAloneExploreTopPosts,
        errors: {} as "The request could not be processed, please try again later.",
      },
    },
    StandAloneExtractExclusionSample: {
      create: {
        path: '/api/external/extract-exclusion-sample/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExtractExclusionSampleInput
        },
        responseType: {} as StandAloneExtractExclusionSample,
        errors: {} as {},
      },
    },
    StandaloneNativePackGenerator: {
      create: {
        /** Standalone create for audience requests */
        path: '/api/external/generate-native-pack/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneNativePackGeneratorInput
        },
        responseType: {} as StandaloneNativePackGenerator,
        errors: {} as "Brand safety"|"No audience found"|"No input found",
      },
    },
    StandaloneImageDownloader: {
      download_image_unique_name: {
        path: '/api/external/image-downloader/download_image_unique_name/',
        method: 'GET',
        paramsType: {} as {
          query?: GetDownloadImageUniqueNameQuery
        },
        responseType: {} as {},
        errors: {} as {},
      },
    },
    StandaloneInterests: {
      list: {
        path: '/api/external/interests/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneInterest[],
        errors: {} as {},
      },
      search: {
        path: '/api/external/interests/search/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneSearchInterestsInput
        },
        responseType: {} as StandaloneSearchInterests,
        errors: {} as {},
      },
    },
    StandAloneJobTitlesSizeEstimator: {
      create: {
        /** Standalone create for audience requests */
        path: '/api/external/job-title-size-estimator/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneJobTitlesSizeEstimatorInput
        },
        responseType: {} as StandAloneJobTitlesSizeEstimator,
        errors: {} as {},
      },
    },
    StandaloneJobTitleTargeting: {
      create: {
        /** Standalone viewset for job title targeting */
        path: '/api/external/job-title-targeting/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneJobTitleTargetingInput
        },
        responseType: {} as StandaloneJobTitleTargeting,
        errors: {} as {},
      },
    },
    StandaloneAutopilotKeywordSuggestionUsage: {
      create: {
        path: '/api/external/keyword-suggestion-usages/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneAutopilotKeywordSuggestionUsageManyInput
        },
        responseType: {} as StandaloneAutopilotKeywordSuggestionUsageMany,
        errors: {} as {},
      },
    },
    StandaloneLanguages: {
      list: {
        path: '/api/external/languages/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneLanguage[],
        errors: {} as {},
      },
    },
    StandaloneTargetingLocations: {
      list: {
        path: '/api/external/locations/',
        method: 'GET',
        paramsType: {} as {
          query?: GetStandaloneTargetingLocationsListQuery
        },
        responseType: {} as StandaloneTargetingLocation[],
        errors: {} as {},
      },
      search: {
        path: '/api/external/locations/search/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneSearchTargetingLocationsInput
        },
        responseType: {} as StandaloneSearchTargetingLocations,
        errors: {} as {},
      },
    },
    StandaloneMarketingMaterial: {
      list: {
        path: '/api/external/marketing-materials/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as MarketingMaterialList[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/external/marketing-materials/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as MarketingMaterialList,
        errors: {} as {},
      },
      download: {
        path: '/api/external/marketing-materials/{pk}/download/',
        method: 'POST',
        paramsType: {} as {
          body: MarketingMaterialInput
          path: {
            pk: string|number
          }
        },
        responseType: {} as MarketingMaterial,
        errors: {} as {},
      },
    },
    StandaloneMonitor: {
      list: {
        path: '/api/external/monitors/',
        method: 'GET',
        paramsType: {} as {
          query?: GetStandaloneMonitorListQuery
        },
        responseType: {} as StandaloneMonitor[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/external/monitors/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetStandaloneMonitorInstanceQuery
        },
        responseType: {} as StandaloneMonitor,
        errors: {} as {},
      },
    },
    StandaloneMoviesTvShows: {
      list: {
        path: '/api/external/movies-tv-shows/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneMoviesTvShows[],
        errors: {} as {},
      },
      search: {
        path: '/api/external/movies-tv-shows/search/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneSearchMoviesTvShowsInput
        },
        responseType: {} as StandaloneSearchMoviesTvShows,
        errors: {} as {},
      },
    },
    StandaloneNetworkOperators: {
      list: {
        path: '/api/external/network-operators/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneNetworkOperator[],
        errors: {} as {},
      },
      search: {
        path: '/api/external/network-operators/search/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneSearchNetworkOperatorsInput
        },
        responseType: {} as StandaloneSearchNetworkOperators,
        errors: {} as {},
      },
    },
    StandalonePersona: {
      create_signed: {
        /** Standalone Persona endpoint */
        path: '/api/external/persona/create-signed/',
        method: 'POST',
        paramsType: {} as {
          body: StandalonePersonaTokenInput
        },
        responseType: {} as StandalonePersonaToken,
        errors: {} as {},
      },
      verify_signed: {
        /** Standalone Persona endpoint */
        path: '/api/external/persona/verify-signed/',
        method: 'GET',
        paramsType: {} as {
          query?: GetVerifySignedQuery
        },
        responseType: {} as StandaloneExploreQueryAnalyzer,
        errors: {} as {},
      },
    },
    StandaloneMagicLoginLink: {
      magic: {
        path: '/api/external/personal-magic-link/magic/',
        method: 'GET',
        paramsType: {} as {
          query?: GetMagicQuery
        },
        responseType: {} as CreateMagicLoginLink,
        errors: {} as {},
      },
      use: {
        path: '/api/external/personal-magic-link/use/',
        method: 'GET',
        paramsType: {} as {
          query?: GetUseQuery
        },
        responseType: {} as UseMagicLoginLink,
        errors: {} as {},
      },
    },
    StandAlonePostsAccount: {
      create: {
        /** Standalone get posts of account */
        path: '/api/external/posts-account/',
        method: 'POST',
        paramsType: {} as {
          body: StandAlonePostsAccountInput
        },
        responseType: {} as StandAlonePostsAccount,
        errors: {} as {},
      },
    },
    StandAloneXplorePostsSentimentAnalysis: {
      create: {
        path: '/api/external/posts-sentiment-analysis/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneXplorePostsSentimentAnalysisInput
        },
        responseType: {} as StandAloneXplorePostsSentimentAnalysis,
        errors: {} as {},
      },
    },
    StandaloneRecentlyCreatedAudiences: {
      list: {
        path: '/api/external/recent-audiences/',
        method: 'GET',
        paramsType: {} as {
          query?: GetStandaloneRecentlyCreatedAudiencesListQuery
        },
        responseType: {} as StandaloneRecentlyCreatedAudiences[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/external/recent-audiences/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetStandaloneRecentlyCreatedAudiencesInstanceQuery
        },
        responseType: {} as StandaloneRecentlyCreatedAudiences,
        errors: {} as {},
      },
    },
    StandaloneRelatedKeywords: {
      create: {
        path: '/api/external/related-keywords/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneRelatedKeywordsInput
        },
        responseType: {} as StandaloneRelatedKeywords,
        errors: {} as {},
      },
    },
    StandaloneMe: {
      standalone_me: {
        path: '/api/external/standalone-me/standalone_me/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as StandaloneMe,
        errors: {} as {},
      },
    },
    StandaloneTopicAccounts: {
      create: {
        /** Standalone get accounts of topic */
        path: '/api/external/topic-accounts/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneTopicAccountsInput
        },
        responseType: {} as StandaloneTopicAccounts,
        errors: {} as {},
      },
    },
    StandAloneUploadAudience: {
      create: {
        path: '/api/external/upload-audience/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneUploadAudienceInput
        },
        responseType: {} as StandAloneUploadAudience,
        errors: {} as "No ad account found",
      },
    },
    StandaloneUserActivityEntry: {
      create: {
        path: '/api/external/user-activity-entry/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneUserActivityEntryInput
        },
        responseType: {} as StandaloneUserActivityEntry,
        errors: {} as {},
      },
    },
    StandAloneExtractWeeklyResultsMonitor: {
      create: {
        path: '/api/external/weekly-results-monitor/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneMonitorExtractWeeklyResultsInput
        },
        responseType: {} as StandaloneMonitorExtractWeeklyResults,
        errors: {} as {},
      },
    },
    StandaloneXConversation: {
      create: {
        /** Standalone get conversation */
        path: '/api/external/x-conversations/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneXConversationInput
        },
        responseType: {} as StandaloneXConversation,
        errors: {} as {},
      },
    },
    StandAlonePostActivity: {
      create: {
        /** Standalone get conversation */
        path: '/api/external/x-post-activity/',
        method: 'POST',
        paramsType: {} as {
          body: StandAlonePostActivityInput
        },
        responseType: {} as StandAlonePostActivity,
        errors: {} as {},
      },
    },
    StandAloneExploreSentimentAnalysis: {
      create: {
        /** Standalone get sentiment analysis */
        path: '/api/external/x-sentiment-analysis/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneExploreSentimentAnalysisInput
        },
        responseType: {} as StandAloneExploreSentimentAnalysis,
        errors: {} as {},
      },
    },
    StandAloneGenerateShareOfVoiceAliases: {
      create: {
        /** Standalone get conversation */
        path: '/api/external/x-share-of-voice-aliases/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneGenerateShareOfVoiceAliasesInput
        },
        responseType: {} as StandAloneGenerateShareOfVoiceAliases,
        errors: {} as {},
      },
    },
    StandAloneGenerateShareOfVoiceKeywords: {
      create: {
        /** Standalone get conversation */
        path: '/api/external/x-share-of-voice/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneGenerateShareOfVoiceKeywordsInput
        },
        responseType: {} as StandAloneGenerateShareOfVoiceKeywords,
        errors: {} as {},
      },
    },
    StandaloneXStats: {
      trending_topics: {
        /** x-stats trending topics endpoint for xprotaregting.com */
        path: '/api/external/x-stats/trending-topics/',
        method: 'GET',
        paramsType: {} as {
          query?: GetTrendingTopicsQuery
        },
        responseType: {} as DeepThoughtXStatsTrend,
        errors: {} as {},
      },
      x_stats_countries: {
        /** x-stats-countries endpoint for xprotargeting.com */
        path: '/api/external/x-stats/x-stats-countries/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as DeepThoughtXStatsCountryActivity,
        errors: {} as {},
      },
      x_stats: {
        /** x-stats endpoint for xprotaregting.com */
        path: '/api/external/x-stats/x-stats/',
        method: 'GET',
        paramsType: {} as {
          query?: GetXStatsQuery
        },
        responseType: {} as DeepThoughtXStats,
        errors: {} as {},
      },
    },
    StandaloneXploreDetailTrends: {
      create: {
        path: '/api/external/xplore-detail-trends/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneXploreDetailTrendsInput
        },
        responseType: {} as StandaloneXploreDetailTrends,
        errors: {} as {},
      },
    },
    StandAloneXploreDetail: {
      create: {
        path: '/api/external/xplore-detail/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneXploreDetailInput
        },
        responseType: {} as StandaloneXploreDetail,
        errors: {} as "Topic not published",
      },
    },
    StandAloneXplorePostsSentiment: {
      create: {
        path: '/api/external/xplore-posts-sentiment/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneXplorePostsSentimentInput
        },
        responseType: {} as StandAloneXplorePostsSentiment,
        errors: {} as {},
      },
    },
    StandAloneXplorePostsStartEnd: {
      create: {
        path: '/api/external/xplore-posts-start-end/',
        method: 'POST',
        paramsType: {} as {
          body: StandAloneXplorePostsStartEndInput
        },
        responseType: {} as StandAloneXplorePostsStartEnd,
        errors: {} as {},
      },
    },
    StandAloneXplore: {
      create: {
        path: '/api/external/xplore/',
        method: 'POST',
        paramsType: {} as {
          body: StandaloneXploreInput
        },
        responseType: {} as StandaloneXplore,
        errors: {} as {},
      },
    },
    GeoLocationUser: {
      geo_location: {
        path: '/api/geo-location/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as GeoLocation,
        errors: {} as {},
      },
    },
    CheckHasPixel: {
      has_pixel: {
        path: '/api/has-pixel/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as {},
        errors: {} as {},
      },
    },
    HelperDocuments: {
      list: {
        path: '/api/helper-documents/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as HelperDocuments[],
        errors: {} as {},
      },
      download: {
        path: '/api/helper-documents/download/',
        method: 'GET',
        paramsType: {} as {
          query?: GetDownloadQuery
        },
        responseType: {} as HelperDocumentsDownload,
        errors: {} as {},
      },
      retrieve: {
        path: '/api/helper-documents/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as HelperDocuments,
        errors: {} as {},
      },
    },
    IconoGraphy: {
      list: {
        path: '/api/iconography/',
        method: 'GET',
        paramsType: {} as {
          query?: GetIconoGraphyListQuery
        },
        responseType: {} as Iconography[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/iconography/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetIconoGraphyInstanceQuery
        },
        responseType: {} as Iconography,
        errors: {} as {},
      },
    },
    Icon: {
      list: {
        path: '/api/icons/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as Icon[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/icons/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as Icon,
        errors: {} as {},
      },
    },
    InsightsInfluencer: {
      list: {
        path: '/api/insights-influencer/',
        method: 'GET',
        paramsType: {} as {
          query?: GetInsightsInfluencerListQuery
        },
        responseType: {} as {
          count: number
          next: string
          previous: string
          results: InsightsInfluencer[]
        },
        errors: {} as {},
      },
      retrieve: {
        path: '/api/insights-influencer/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
          query?: GetInsightsInfluencerInstanceQuery
        },
        responseType: {} as InsightsInfluencer,
        errors: {} as {},
      },
    },
    ProTargetingSummaryPDF: {
      create: {
        path: '/api/insights-pro-targeting-summary/',
        method: 'POST',
        paramsType: {} as {
          body: CreateProTargetingPdfInput
        },
        responseType: {} as CreateProTargetingPdf,
        errors: {} as {},
      },
    },
    InsightsSummaryPDF: {
      create: {
        path: '/api/insights-summary/',
        method: 'POST',
        paramsType: {} as {
          body: CreateInsightsPdfInput
        },
        responseType: {} as CreateInsightsPdf,
        errors: {} as {},
      },
    },
    JobTitles: {
      list: {
        path: '/api/job-titles/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as JobTitle[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/job-titles/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as JobTitle,
        errors: {} as {},
      },
    },
    Metrics: {
      list: {
        /** Meta information about available campaign metrics */
        path: '/api/metrics/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as MetricInfo[],
        errors: {} as {},
      },
    },
    ResetE2E: {
      mock: {
        path: '/api/reset-e2e/mock/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as E2E,
        errors: {} as {},
      },
    },
    TypescriptSchemaView: {
      list: {
        path: '/api/schema/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as {}[],
        errors: {} as {},
      },
    },
    TargetingCountries: {
      list: {
        /** Targeting countries list */
        path: '/api/targeting-countries/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as TargetingCountries[],
        errors: {} as {},
      },
    },
    TargetingInterests: {
      list: {
        /** Targeting interests list */
        path: '/api/targeting-interests/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as TargetingInterests[],
        errors: {} as {},
      },
    },
    TargetingLocations: {
      list: {
        /** Targeting cities list */
        path: '/api/targeting-locations/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as TargetingLocations[],
        errors: {} as {},
      },
    },
    TeamPublic: {
      retrieve: {
        /** Used to show public name/picture on login page for team */
        path: '/api/teaminfo/{slug}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            slug: string|number
          }
        },
        responseType: {} as TeamPublic,
        errors: {} as {},
      },
    },
    UserTeam: {
      list: {
        /** Viewset for my teams (teams). Retrieve by slug. */
        path: '/api/teams/',
        method: 'GET',
        paramsType: {} as {
          query?: GetUserTeamListQuery
        },
        responseType: {} as TeamPublic[],
        errors: {} as {},
      },
      create: {
        /** Viewset for my teams (teams). Retrieve by slug. */
        path: '/api/teams/',
        method: 'POST',
        paramsType: {} as {
          body: TeamInput
        },
        responseType: {} as Team,
        errors: {} as {},
      },
      retrieve: {
        /** Viewset for my teams (teams). Retrieve by slug. */
        path: '/api/teams/{slug}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            slug: string|number
          }
          query?: GetUserTeamInstanceQuery
        },
        responseType: {} as Team,
        errors: {} as {},
      },
      partial_update: {
        /** Viewset for my teams (teams). Retrieve by slug. */
        path: '/api/teams/{slug}/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<TeamInput>
          path: {
            slug: string|number
          }
          query?: PatchUserTeamInstanceQuery
        },
        responseType: {} as Team,
        errors: {} as {},
      },
      update: {
        /** Viewset for my teams (teams). Retrieve by slug. */
        path: '/api/teams/{slug}/',
        method: 'PUT',
        paramsType: {} as {
          body: TeamInput
          path: {
            slug: string|number
          }
          query?: PutUserTeamInstanceQuery
        },
        responseType: {} as Team,
        errors: {} as {},
      },
    },
    TeamAccount: {
      list: {
        path: '/api/teams/{team_id}/accounts/',
        method: 'GET',
        paramsType: {} as {
          path: {
            team_id: string|number
          }
        },
        responseType: {} as AdAccount[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/teams/{team_id}/accounts/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            team_id: string|number
            pk: string|number
          }
        },
        responseType: {} as AdAccount,
        errors: {} as {},
      },
    },
    TeamInvite: {
      list: {
        path: '/api/teams/{team_id}/invites/',
        method: 'GET',
        paramsType: {} as {
          path: {
            team_id: string|number
          }
        },
        responseType: {} as TeamInvite[],
        errors: {} as {},
      },
      create: {
        path: '/api/teams/{team_id}/invites/',
        method: 'POST',
        paramsType: {} as {
          body: TeamInviteInput
          path: {
            team_id: string|number
          }
        },
        responseType: {} as TeamInvite,
        errors: {} as {},
      },
      accept: {
        path: '/api/teams/{team_id}/invites/accept/',
        method: 'POST',
        paramsType: {} as {
          body: InviteAcceptInput
          path: {
            team_id: string|number
          }
        },
        responseType: {} as InviteAccept,
        errors: {} as {},
      },
      retrieve: {
        path: '/api/teams/{team_id}/invites/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            team_id: string|number
            pk: string|number
          }
        },
        responseType: {} as TeamInvite,
        errors: {} as {},
      },
    },
    TeamMember: {
      list: {
        path: '/api/teams/{team_id}/members/',
        method: 'GET',
        paramsType: {} as {
          path: {
            team_id: string|number
          }
        },
        responseType: {} as TeamMember[],
        errors: {} as {},
      },
      retrieve: {
        path: '/api/teams/{team_id}/members/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            team_id: string|number
            pk: string|number
          }
        },
        responseType: {} as TeamMember,
        errors: {} as {},
      },
    },
    UploadedAudience: {
      create: {
        path: '/api/uploaded-audiences/',
        method: 'POST',
        paramsType: {} as {
          body: UploadedAudiencesInput
        },
        responseType: {} as UploadedAudiences,
        errors: {} as {},
      },
      destroy: {
        path: '/api/uploaded-audiences/{pk}/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as {},
        errors: {} as {},
      },
    },
    UserAdAccount: {
      list: {
        /** List user ad accounts */
        path: '/api/user/accounts/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as UserAdAccount[],
        errors: {} as {},
      },
      retrieve: {
        /** List user ad accounts */
        path: '/api/user/accounts/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as UserAdAccount,
        errors: {} as {},
      },
    },
    FollowUnfollow: {
      create: {
        path: '/api/user/follow-unfollow/',
        method: 'POST',
        paramsType: {} as {
          body: FollowUnfollowInput
        },
        responseType: {} as FollowUnfollow,
        errors: {} as {},
      },
    },
    GrantedAdAccount: {
      list: {
        /** List/Create/Delete (aka Grant/revoke) access to ad accounts through team memberships */
        path: '/api/user/granted-accounts/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as GrantedAccount[],
        errors: {} as {},
      },
      create: {
        /** List/Create/Delete (aka Grant/revoke) access to ad accounts through team memberships */
        path: '/api/user/granted-accounts/',
        method: 'POST',
        paramsType: {} as {
          body: GrantedAccountInput
        },
        responseType: {} as GrantedAccount,
        errors: {} as {},
      },
      destroy: {
        /** List/Create/Delete (aka Grant/revoke) access to ad accounts through team memberships */
        path: '/api/user/granted-accounts/{pk}/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as {},
        errors: {} as {},
      },
      retrieve: {
        /** List/Create/Delete (aka Grant/revoke) access to ad accounts through team memberships */
        path: '/api/user/granted-accounts/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as GrantedAccount,
        errors: {} as {},
      },
    },
    TwitterLists: {
      list: {
        path: '/api/user/lists/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as TwitterList[],
        errors: {} as {},
      },
      create: {
        path: '/api/user/lists/',
        method: 'POST',
        paramsType: {} as {
          body: TwitterListInput
        },
        responseType: {} as TwitterList,
        errors: {} as {},
      },
      destroy: {
        path: '/api/user/lists/{pk}/',
        method: 'DELETE',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as {},
        errors: {} as {},
      },
      retrieve: {
        path: '/api/user/lists/{pk}/',
        method: 'GET',
        paramsType: {} as {
          path: {
            pk: string|number
          }
        },
        responseType: {} as TwitterList,
        errors: {} as {},
      },
      partial_update: {
        path: '/api/user/lists/{pk}/',
        method: 'PATCH',
        paramsType: {} as {
          body: Partial<TwitterListInput>
          path: {
            pk: string|number
          }
        },
        responseType: {} as TwitterList,
        errors: {} as {},
      },
      update: {
        path: '/api/user/lists/{pk}/',
        method: 'PUT',
        paramsType: {} as {
          body: TwitterListInput
          path: {
            pk: string|number
          }
        },
        responseType: {} as TwitterList,
        errors: {} as {},
      },
      members: {
        path: '/api/user/lists/{pk}/members/',
        method: 'POST',
        paramsType: {} as {
          body: TwitterListsMembersInput
          path: {
            pk: string|number
          }
        },
        responseType: {} as TwitterListsMembers,
        errors: {} as {},
      },
    },
    MagicLoginLink: {
      create: {
        path: '/api/user/magic-link/',
        method: 'POST',
        paramsType: {} as {
          body: CreateMagicLoginLinkInput
        },
        responseType: {} as CreateMagicLoginLink,
        errors: {} as {},
      },
      use: {
        path: '/api/user/magic-link/use/',
        method: 'POST',
        paramsType: {} as {
          body: UseMagicLoginLinkInput
        },
        responseType: {} as UseMagicLoginLink2,
        errors: {} as {},
      },
    },
    User: {
      me: {
        /** Update user profile (name, etc) */
        path: '/api/user/me/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as User,
        errors: {} as {},
      },
      me_put: {
        /** Update user profile (name, etc) */
        path: '/api/user/me/',
        method: 'PUT',
        paramsType: {} as {
          body: UserInput
        },
        responseType: {} as User,
        errors: {} as {},
      },
    },
    WebEvents: {
      list: {
        /** Account web events list */
        path: '/api/web-events/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as WebEvents[],
        errors: {} as {},
      },
    },
    TwitterWebhookView: {
      list: {
        path: '/api/webhook/twitter/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as {}[],
        errors: {} as {},
      },
      post: {
        path: '/api/webhook/twitter/',
        method: 'POST',
        paramsType: {} as {
          body: {}
        },
        responseType: {} as {},
        errors: {} as {},
      },
    },
    LoginViaToken: {
      create: {
        path: '/rest-auth/login-via-token/',
        method: 'POST',
        paramsType: {} as {
          body: LoginViaTokenInput
        },
        responseType: {} as LoginViaToken,
        errors: {} as "Invalid token",
      },
    },
    LogoutView: {
      list: {
        /** Calls Django logout method and delete the Token object
        assigned to the current User object.
        Accepts/Returns nothing. */
        path: '/rest-auth/logout/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as {}[],
        errors: {} as {},
      },
      post: {
        /** Calls Django logout method and delete the Token object
        assigned to the current User object.
        Accepts/Returns nothing. */
        path: '/rest-auth/logout/',
        method: 'POST',
        paramsType: {} as {
          body: {}
        },
        responseType: {} as {},
        errors: {} as {},
      },
    },
    SocialAccountListView: {
      list: {
        /** List SocialAccounts for the currently logged in user */
        path: '/rest-auth/socialaccounts/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as SocialAccount2[],
        errors: {} as {},
      },
    },
    SocialAccountDisconnectView: {
      post: {
        /** Disconnect SocialAccount from remote service for
        the currently logged in user */
        path: '/rest-auth/socialaccounts/{pk}/disconnect/',
        method: 'POST',
        paramsType: {} as {
          body: SocialConnectInput
          path: {
            pk: string|number
          }
        },
        responseType: {} as SocialConnect,
        errors: {} as {},
      },
    },
    TwitterLogin: {
      post: {
        path: '/rest-auth/twitter/',
        method: 'POST',
        paramsType: {} as {
          body: TwitterLoginInput
        },
        responseType: {} as TwitterLogin,
        errors: {} as {},
      },
    },
    TwitterAccessTokenView: {
      get: {
        /** Receives Twitter redirect
        Requests access token
        Returns token to be used on TwitterConnect/TwitterLogin */
        path: '/rest-auth/twitter/access_token/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as TwitterAccessToken,
        errors: {} as {},
      },
    },
    TwitterConnect: {
      post: {
        path: '/rest-auth/twitter/connect/',
        method: 'POST',
        paramsType: {} as {
          body: TwitterConnectInput
        },
        responseType: {} as TwitterConnect,
        errors: {} as {},
      },
    },
    TwitterRequestTokenView: {
      get: {
        /** Receives oauth_callback
        Requests request token
        Returns oauth_token which is need to redirect to Twitter */
        path: '/rest-auth/twitter/request_token/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as TwitterRequestToken,
        errors: {} as {},
      },
    },
    TwitterOauth2Login: {
      post: {
        path: '/rest-auth/twitter_oauth2/',
        method: 'POST',
        paramsType: {} as {
          body: MyLoginInput
        },
        responseType: {} as MyLogin,
        errors: {} as {},
      },
    },
    TwitterCodeChallenge: {
      code_challenge: {
        path: '/rest-auth/twitter_oauth2_challenge/code-challenge/',
        method: 'GET',
        paramsType: {} as {},
        responseType: {} as TwitterAuthParams,
        errors: {} as {},
      },
    },
  } as const
